// Solano Essence i18n — de
const de = {
  "webGate": {
    "title": "Bitte nutze die iPhone-App",
    "body": "Solano Essence läuft für dich exklusiv in der iPhone-App. Öffne die App auf deinem Handy, um weiterzumachen — dort wartet dein Coach auf dich."
  },
  "engagement": {
    "title": "Nutzer-Aktivität",
    "filterAll": "Alle",
    "filterRed": "Inaktiv",
    "filterAmber": "Nachlassend",
    "filterGreen": "Aktiv",
    "statusActive": "Aktiv",
    "statusFading": "Nachlassend",
    "statusInactive": "Inaktiv",
    "lastActive": "Zuletzt aktiv",
    "today": "Heute",
    "yesterday": "Gestern",
    "daysAgo": "Tage her",
    "never": "Nie aktiv",
    "emptyFilter": "Keine Nutzer in dieser Kategorie"
  },
  "common": {
    "networkError": "Server nicht erreichbar. Bitte prüfe deine Internetverbindung und versuche es erneut.",
    "save": "Speichern",
    "saved": "Gespeichert ✓",
    "cancel": "Abbrechen",
    "edit": "Bearbeiten",
    "more": "Mehr",
    "back": "Zurück",
    "loading": "Lädt…",
    "daysAgoShort": "vor {n} T",
    "error": "Fehler",
    "saving": "Speichere…",
    "none": "—",
    "delete": "Löschen",
    "add": "Hinzufügen",
    "ok": "OK",
    "done": "Fertig",
    "clear": "Löschen",
    "close": "Schließen",
    "search": "Suchen",
    "all": "Alle",
    "kg": "kg",
    "kcal": "kcal",
    "protein": "Eiweiß",
    "carbs": "Kohlenhydrate",
    "fat": "Fett",
    "calories": "Kalorien",
    "date": "Datum",
    "time": "Uhrzeit",
    "notes": "Notizen",
    "logout": "Abmelden",
    "select": "Auswählen",
    "confirm": "Bestätigen",
    "reject": "Ablehnen",
    "completed": "Erledigt",
    "welcomeBack": "Willkommen zurück",
    "retry": "Erneut versuchen",
    "gotIt": "Alles klar",
    "refresh": "Aktualisieren",
    "mon": "Mo",
    "tue": "Di",
    "wed": "Mi",
    "thu": "Do",
    "fri": "Fr",
    "sat": "Sa",
    "sun": "So",
    "copied": "kopiert",
    "copy": "Kopieren",
    "dismiss": "Ausblenden",
    "errorGeneric": "Etwas ist schiefgelaufen.",
    "micDenied": "Mikrofon-Zugriff verweigert",
    "micUnsupported": "Mikrofon wird auf diesem Gerät nicht unterstützt",
    "more": "Mehr",
    "next": "Weiter",
    "prev": "Zurück",
    "recipe": "Rezept",
    "remove": "Entfernen",
    "stop": "Stopp",
    "undo": "Rückgängig"
  },
  "appStats": {
    "title": "App-Statistiken",
    "subtitle": "Übersicht über deine Praxis",
    "scopeNote": "Diese Zahlen beziehen sich ausschließlich auf DEINE Nutzer und deine Praxis.",
    "orphanNote": "Hinweis: {n} nicht verknüpfte Nutzer-Accounts existieren im System (Testkonten / offene Einladungen).",
    "myClients": "Meine Nutzer",
    "coaches": "Coaches im Studio",
    "users": "Nutzer",
    "engagement": "Engagement",
    "aiUsage": "AI-Nutzung",
    "notifSocial": "Push & Community",
    "growthTrend": "Wachstumstrend",
    "totalClients": "Nutzer",
    "nutritionists": "Nutritionists",
    "activeToday": "Aktiv heute",
    "newUsersWeek": "Neu · 7 Tage",
    "thisWeek": "diese Woche",
    "pastWeek": "letzte 7 Tage",
    "total": "gesamt",
    "mealsToday": "Meals heute",
    "workoutsToday": "Workouts heute",
    "waterToday": "Wasser-Logs heute",
    "sharedMealsWeek": "Shared Meals · 7d",
    "coachMsgsToday": "Coach-AI heute",
    "weeklyMenusWeek": "Wochenmenüs · 7d",
    "recipeImagesCached": "Rezept-Bilder Cache",
    "foodsAiCached": "AI-Foods Cache",
    "pushSubs": "Push-Abos",
    "notifToday": "Pushes heute",
    "chatWeek": "Chat Msgs · 7d",
    "upcomingAppts": "Kommende Termine"
  },
  "quickSteps": {
    "title": "Schritte heute",
    "subtitle": "Zahl aus deiner Schritte-App eintragen",
    "saved": "Schritte gespeichert",
    "invalid": "Ungültige Zahl"
  },
  "wearable": {
    "directIntegrations": "Direkte Wearable-Integrationen",
    "appleBridgeHint": "Synchronisiert unterstützte Daten von Apple Watch sowie verbundenen Apps und Geräten wie Garmin, Fitbit, Polar und smarten Waagen.",
    "directSoonTitle": "Direkte Verbindungen – bald verfügbar",
    "directSoonHint": "Basisdaten dieser Anbieter können bereits über Apple Health synchronisiert werden. Direkte Verbindungen bringen später zusätzliche, herstellerspezifische Messwerte.",
    "connected": "Verbunden",
    "notConnected": "Nicht verbunden",
    "paused": "Pausiert",
    "comingSoon": "Bald verfügbar",
    "manualOnly": "Nur manueller Import",
    "connectCta": "Verbinden",
    "needsCreds": "Server-Credentials fehlen noch — bald verfügbar",
    "applePlaceholder": "WHOOP zählt keine Schritte über die API. Für genaue Schritte, Gewicht und Kalorien: verbinde Apple Health über die iOS-App \"Health Auto Export\" — Token unten generieren, in die App einfügen, fertig.",
    "healthkitCta": "Direkt aus HealthKit synchronisieren",
    "healthkitSyncing": "Lese HealthKit…",
    "healthkitDone": "HealthKit-Sync fertig: {days} Tage",
    "healthkitDenied": "HealthKit-Zugriff nicht möglich. Prüfe die Freigaben in Einstellungen → Health → Datenzugriff.",
    "healthkitServerError": "Server-Fehler beim Speichern der Health-Daten. Bitte später erneut versuchen.",
    "healthkitNetworkError": "Keine Verbindung zum Server. Prüfe deine Internetverbindung.",
    "healthkitHint": "Diese App kann Health-Daten direkt vom iPhone lesen — ohne Zusatz-App.",
    "healthConnectSoon": "Auf Android kommt die Anbindung an Health Connect bald. Bis dahin kannst du WHOOP, Garmin & Co. direkt verbinden.",
    "healthConnectBridgeHint": "Liest Schritte, Kalorien, Schlaf, Ruhepuls, HRV, Gewicht und Trainings aus Health Connect – also von Samsung Health, Fitbit, Garmin, Google Fit & Co.",
    "healthConnectDone": "Health-Connect-Sync fertig: {days} Tage",
    "healthConnectCta": "Direkt aus Health Connect synchronisieren",
    "healthConnectSyncing": "Lese Health Connect…",
    "healthConnectDenied": "Health-Connect-Zugriff nicht möglich. Öffne die Health-Connect-App → App-Berechtigungen → Solano Essence und erlaube das Lesen.",
    "healthConnectMissing": "Health Connect ist auf diesem Gerät nicht installiert oder veraltet. Bitte im Play Store installieren/aktualisieren.",
    "healthConnectEmpty": "Berechtigung ok, aber Health Connect enthält keine Daten der letzten 7 Tage. Aktiviere in deiner Fitness-App (Samsung Health → Einstellungen → Health Connect, Fitbit, Garmin Connect, Google Fit …) die Synchronisation mit Health Connect und versuche es dann erneut.",
    "healthConnectNoPermission": "Keine Health-Connect-Berechtigung erteilt. Öffne Health Connect → App-Berechtigungen → Solano Essence und erlaube das Lesen von Schritten, Kalorien, Schlaf, Herzfrequenz und Gewicht.",
    "healthConnectOpen": "Health Connect öffnen",
    "healthConnectSoonShort": "Bald via Health Connect",
    "myDevices": "Meine Geräte",
    "addDevice": "Gerät hinzufügen",
    "noDevices": "Noch kein Gerät verbunden.",
    "active": "Aktiv",
    "available": "Verfügbar",
    "iosOnly": "In der Solano-App (iPhone/Android)",
    "pause": "Pausieren",
    "resume": "Fortsetzen",
    "syncNow": "Jetzt syncen",
    "syncing": "Sync…",
    "disconnect": "Trennen",
    "disconnectedOk": "Verbindung getrennt",
    "lastSync": "Letzte Sync",
    "priorityRule": "Daten-Priorität bei Duplikaten",
    "whoopConnectedOk": "WHOOP verbunden — starte erste Sync…",
    "syncedOk": "Sync fertig: {days} Tage",
    "resumedOk": "Sync wieder aktiv",
    "pausedOk": "Sync pausiert",
    "manualTag": "Ohne Wearable",
    "manualTitle": "Werte manuell eintragen",
    "manualDate": "Datum",
    "manualSleepMin": "Schlaf (min)",
    "manualRestingHr": "Ruhepuls (bpm)",
    "manualHrv": "HRV (ms)",
    "manualSteps": "Schritte",
    "manualActiveKcal": "Aktive kcal",
    "manualRecovery": "Recovery (0-100)",
    "manualSaveCta": "Werte speichern",
    "manualSavedOk": "Werte gespeichert",
    "manualEmpty": "Bitte mindestens einen Wert eintragen",
    "manualRecent": "Zuletzt eingetragen",
    "whoopNoSteps": "WHOOP liefert die Schritte nicht über die API. Verbinde Apple Health unten, damit Schritte, Gewicht und Kalorien automatisch stimmen.",
    "appleSyncHint": "Apple Health überträgt Daten automatisch vom iPhone. Öffne die App \"Health Auto Export\" → tippe \"Run Now\" — Schritte, Gewicht und Kalorien kommen in ~20 Sekunden.",
    "appleWaiting": "Warte auf iPhone",
    "appleTestWebhook": "Test-Übertragung",
    "appleTestOk": "Test-Übertragung erfolgreich ✓",
    "appleTestFail": "Test fehlgeschlagen",
    "appleSetupOpen": "Setup / Automatischer Import",
    "appleSetupClose": "Setup schließen",
    "appleResetToday": "Heute zurücksetzen",
    "appleResetConfirm": "Apple-Werte für heute löschen? Falls Health Auto Export nachher etwas sendet, werden sie überschrieben.",
    "appleResetOk": "Heute-Werte zurückgesetzt",
    "appleAutoHint": "Läuft automatisch vom iPhone im Hintergrund. Für sofortiges Update: \"Health Auto Export\" öffnen → Run Now.",
    "appleHeaderAlt": "Alternative: Header statt URL-Parameter",
    "appleHeaderAltHint": "Nutze ENTWEDER die URL mit ?token oben ODER die drei Felder unten (URL + Key + Value) in \"Überschriften hinzufügen\" — nicht beides.",
    "appleBridgeTag": "Health Auto Export Bridge",
    "appleBridgeSetup": "Automatischen Import einrichten",
    "appleBridgeConnected": "Apple Health verbunden",
    "appleStep1": "Lade auf dem iPhone die App \"Health Auto Export\" (Gratis)",
    "appleStep2": "Öffne die App → \"Automations\" → \"+ Add Automation\" → \"REST API\"",
    "appleStep3": "Füge die URL unten ein → wähle Metriken: Steps, Weight, Active Energy, Resting HR, Sleep, HRV, Workouts",
    "appleStep4": "Speichern & \"Run Now\" tippen — Daten kommen in ~20 Sekunden",
    "appleGenerateToken": "Token generieren",
    "appleWebhookUrl": "Webhook-URL (in Health Auto Export einfügen)",
    "appleTokenCreated": "Neuer Token generiert",
    "appleTokenRevoked": "Token gelöscht",
    "appleTokenCreatedAt": "Erstellt",
    "appleLastPayload": "Letzter Import",
    "appleRotateToken": "Neu generieren",
    "appleRevokeToken": "Löschen",
    "appleRevokeConfirm": "Token wirklich löschen? Die iPhone-App überträgt dann keine Daten mehr.",
    "metric": {
      "steps": "Schritte",
      "weight_kg": "Gewicht",
      "active_calories": "Aktive kcal",
      "hr": "Herzfrequenz",
      "resting_hr": "Ruhepuls",
      "sleep": "Schlaf",
      "workouts": "Workouts",
      "recovery": "Recovery",
      "hrv": "HRV",
      "strain": "Strain"
    }
  },
  "health": {
    "title": "Health Score",
    "chipLabel": "Health",
    "chipEmpty": "Keine Mahlzeit",
    "excellent": "Ausgezeichnet",
    "veryGood": "Sehr gut",
    "good": "Gut",
    "fair": "Verbesserbar",
    "poor": "Braucht Aufmerksamkeit",
    "noMeals": "Mahlzeiten loggen für deinen Score",
    "hint": "Basierend auf Protein, Ballaststoffen, Obst & Gemüse, gesättigten Fetten, Zucker, Salz und Wasser.",
    "muscleTitle": "Muscle",
    "heartTitle": "Heart",
    "energyTitle": "Energy",
    "saltPinch": "eine Prise Salz",
    "saltHalfTsp": "½ Teelöffel Salz",
    "saltTsp": "Teelöffel Salz",
    "saltTspPl": "Teelöffel Salz",
    "infoAria": "So funktioniert der Health Score",
    "infoTag": "So funktioniert's",
    "infoTitle": "Dein Health Score",
    "infoBody": "Der Score wird aus deinen heute erfassten Mahlzeiten berechnet. Er summiert Pluspunkte für gute Gewohnheiten und zieht Strafpunkte für zu begrenzende Nährstoffe ab. Maximal 100.",
    "infoPositiveTitle": "Bonus (max 70)",
    "infoProtein": "Eiweiß (~1,4 g/kg Körpergewicht)",
    "infoFiber": "Ballaststoffe (30 g/Tag)",
    "infoFV": "Obst & Gemüse (4 Portionen)",
    "infoWater": "Wasser (2 L)",
    "infoNegativeTitle": "Strafpunkte (max 30)",
    "infoSatFat": "Gesättigte Fette (<10% kcal)",
    "infoSugar": "Zucker (<40 g)",
    "infoSalt": "Salz (<5 g)",
    "infoNegativeHint": "Volle Punktzahl deutlich unter Schwelle, null wenn weit darüber.",
    "infoTip": "Tippe auf den HEALTH-Ring in der oberen Leiste, um die heutige Live-Aufschlüsselung zu sehen.",
    "infoSource": "Quellen: WHO, EFSA, italienische ISS/CREA-Ernährungsrichtlinien 2018.",
    "infoSubTitle": "Die 3 Kreise erklärt",
    "infoMuscleDesc": "60 % Eiweiß (Anteil deines Tagesziels) + 25 % Training (20 Min = 100 %) + 15 % Kalorienbedarf (nah am Tagesziel = volle Punkte, zu viel oder zu wenig senkt den Wert).",
    "infoHeartDesc": "30 % Ballaststoffe + 30 % Obst & Gemüse (4 Portionen = 100 %) + 20 % Salz + 20 % gesättigte Fette. Bei Salz & Fetten gilt: unter dem Limit = 100 %, darüber sinkt der Wert.",
    "infoEnergyDesc": "40 % Wasser + 30 % Kohlenhydrate + 30 % Aktivität. Aktivität = das Beste aus Schritten (Anteil deines Schrittziels) ODER Training (30 Min = 100 %) — ein Workout zählt also auch bei wenigen Schritten voll."
  },
  "streak": {
    "dayOne": "Tag",
    "dayMany": "Tage",
    "tooltip": "Aufeinanderfolgende Tage ≥ {target} Schritte · Rekord: {best}"
  },
  "auth": {
    "accountBlocked": "Dein Konto wurde gesperrt. Bitte kontaktiere den Support.",
    "blockedTitle": "Dein Konto wurde gesperrt",
    "blockedBody": "Dieses Konto wurde wegen eines Verstosses gegen unsere Nutzungsregeln vorübergehend gesperrt. Du kannst dich nicht anmelden. Wenn du glaubst, dass das ein Irrtum ist, melde dich bitte bei uns – wir prüfen jeden Fall innerhalb von 48 Stunden.",
    "blockedCta": "Support kontaktieren: info@solano-essence.com",
    "socialLoginOnly": "Dieses Konto nutzt den Google- oder Apple-Login. Melde dich damit an oder lege über 'Passwort vergessen?' ein Passwort fest.",
    "tooManyAttempts": "Zu viele fehlgeschlagene Anmeldeversuche. Bitte in 15 Minuten erneut versuchen.",
    "nameRequired": "Bitte gib deinen Namen ein.",
    "emailExists": "E-Mail bereits registriert. Bitte melde dich an.",
    "emailExistsSocial": "E-Mail bereits mit Google oder Apple registriert. Melde dich damit an — oder lege über 'Passwort vergessen?' ein Passwort fest.",
    "resetLinkInvalid": "Link ungültig oder bereits verwendet.",
    "resetLinkExpired": "Link abgelaufen. Fordere einen neuen an."
  },
  "admin": {
    "illu_title": "Maskottchen-Bilder Training",
    "illu_exercises": "Übungen",
    "illu_today": "Heute Nacht",
    "illu_last_night": "Letzte Nacht",
    "illu_eta": "Restdauer",
    "illu_nights": "{n} Nächte",
    "illu_window": "Läuft nachts {w} Uhr",
    "illu_running": "läuft gerade",
    "illu_next": "nächster Lauf {at}",
    "illu_remaining": "{n} Übungen offen",
    "subKind": "Abo-Art",
    "subSince": "Seit",
    "segNew": "Neu (7 Tage)",
    "segInactive": "Inaktiv (7 Tage+)",
    "segPaid": "Pro bezahlt",
    "segComp": "Pro geschenkt",
    "testAccount": "Testkonto",
    "testMark": "Als Testkonto markieren (zählt nicht in Statistik)",
    "testUnmark": "Markierung aufheben",
    "testMarked": "Als Testkonto markiert — zählt nicht mehr in Zahlen",
    "testUnmarked": "Testkonto-Markierung aufgehoben",
    "adherence": "Einhaltung",
    "untilShort": "bis",
    "expiredShort": "abgelaufen",
    "activeUsersLegend": "Aktive Nutzer",
    "aiCostMonth": "KI-Kosten im Monat",
    "aiShareNet": "Anteil am Netto-Umsatz",
    "aiUsageEstNote": "Kosten = Schätzwerte pro Aufruf-Typ",
    "aiLimitsTitle": "Pro-Limits pro Monat",
    "countsNote": "Zählung ohne Testkonten und Team-Konten — überall gleich.",
    "revenueEstimate": "Schätzung aus aktiven Abos × Preis",
    "filterAll": "Alle",
    "onlyPublic": "Nur öffentliche",
    "onlyPrivate": "Nur private",
    "onlyDupes": "Doppelte",
    "publicLabel": "Öffentlich",
    "privateLabel": "Privat",
    "merge": "Zusammenführen",
    "mergeTitle": "Doppelte Rezepte zusammenführen",
    "mergeHint": "Wähle das Rezept, das bleiben soll. Favoriten und Sammlungen der anderen werden übernommen, die Duplikate gelöscht.",
    "mergeKeep": "Zusammenführen",
    "mergeDone": "{n} Duplikat(e) zusammengeführt",
    "ingredientsShort": "Zutaten",
    "recipeDeleteTitle": "Rezept wirklich löschen?",
    "recipeDeleteBody": "Das kann nicht rückgängig gemacht werden.",
    "foodDeleteTitle": "Lebensmittel wirklich löschen?",
    "editFood": "Lebensmittel bearbeiten",
    "foodName": "Name",
    "per100g": "Nährwerte pro 100 g",
    "fiberShort": "Ballast.",
    "markVerified": "Als geprüft markieren",
    "verified": "geprüft",
    "settings": "Einstellungen",
    "appleFee": "Apple-Gebühr (%)",
    "usdChf": "USD → CHF Kurs",
    "settingsHint": "Standard 15 % (Small Business Program). Der Kurs rechnet die KI-Kosten in CHF um.",
    "gross": "Brutto",
    "net": "Netto",
    "expiresOn": "läuft ab am",
    "expiredOn": "abgelaufen am",
    "daysShort": "Tage",
    "noExpiry": "ohne Ablauf",
    "inviteUpgrade": "Einladen",
    "inviteSent": "Einladung zum Pro-Abo gesendet",
    "manualSet": "Manuell",
    "sourcesHint": "Apple ✓ = über Apple bezahlt und per Quittung bestätigt. Manuell = Pro ohne Zahlungsquelle gesetzt.",
    "expiringSoon": "Läuft in den nächsten 14 Tagen ab",
    "expiringNone": "Kein geschenktes Pro läuft in den nächsten 14 Tagen ab.",
    "paidSubs": "Bezahlte Abos",
    "unverifiedSubs": "Nicht bestätigt / manuell",
    "unverifiedHint": "Diese Pro-Zugänge sind nicht durch eine Apple-Quittung belegt.",
    "giftedSubs": "Geschenkte Pro-Zugänge",
    "sortedByExpiry": "nach Ablauf sortiert",
    "revenueTitle": "Umsatz / Monat",
    "revenueNoPrices": "Apple-Preise nicht konfiguriert (APPLE_PRICE_MONTHLY/_YEARLY)",
    "revenueMonthly": "monatlich",
    "revenueYearly": "jährlich",
    "revMonthlySubs": "Monatsabos",
    "revYearlySubs": "Jahresabos",
    "revPerMonth": "pro Monat",
    "revPerYear": "pro Jahr (einmalig)",
    "gifted": "Geschenkt",
    "aiLimitsSaved": "Limits gespeichert",
    "tab_ai": "KI-Verbrauch",
    "aiUsageTotals": "Gesamte App",
    "aiUsageCalls": "Aufrufe",
    "aiUsageEmpty": "Keine KI-Aufrufe in diesem Monat.",
    "grantAllBtn": "Allen bestehenden Nutzern Gratis-Pro schenken (einmalig, für Tester)",
    "grantAllConfirm": "Allen bestehenden Nutzern ohne Pro jetzt Gratis-Pro (🎁) schenken?",
    "grantAllOk": "Pro verschenkt an {n} Nutzer 🎁",
    "compProTitle": "Gratis-Pro",
    "compProActive": "Geschenkt — Nutzer hat Pro gratis (unbegrenzt)",
    "compProUntil": "Geschenkt bis",
    "compProGrant3m": "3 Monate",
    "compProGrant1m": "1 Monat",
    "compProGranted1mOk": "Pro für 1 Monat verschenkt 🎁",
    "compProGrant12m": "1 Jahr",
    "compProGrantUnlimited": "Unbegrenzt",
    "compProGranted3mOk": "Pro für 3 Monate verschenkt 🎁",
    "compProGranted12mOk": "Pro für 1 Jahr verschenkt 🎁",
    "compProPaid": "Nutzer hat ein bezahltes Abo",
    "compProOff": "Vollversion gratis freischalten",
    "compProGrant": "Pro schenken",
    "compProRevoke": "Entziehen",
    "compProGrantedOk": "Pro verschenkt 🎁",
    "compProRevokedOk": "Gratis-Pro entzogen",
    "tab_content": "Inhalte",
    "tab_stats": "Statistik",
    "recipes": "Rezepte",
    "foods": "Lebensmittel",
    "searchRecipes": "Rezepte suchen…",
    "searchFoods": "Lebensmittel suchen",
    "noRecipes": "Keine Rezepte gefunden.",
    "publish": "Veröffentlichen",
    "unpublish": "Verbergen",
    "publishOk": "Rezept veröffentlicht",
    "unpublishOk": "Rezept verborgen",
    "recipeDeletedOk": "Rezept gelöscht",
    "foodDeletedOk": "Eintrag gelöscht",
    "foodsLearned": "Gelernte Lebensmittel",
    "foodsCustom": "Eigene Lebensmittel (Nutzer)",
    "bp": {
      "tab": "Angelernt",
      "hint": "Produkte, die Nutzer per Barcode angelernt haben (Nährwert-Tabelle fotografiert oder manuell). Geprüfte Produkte gelten für alle Nutzer als verbindlich.",
      "search": "Name, Marke oder Barcode suchen…",
      "toReview": "Zu prüfen",
      "empty": "Keine angelernten Produkte",
      "global": "Global",
      "fromLabel": "Etikett-Foto",
      "verify": "Prüfen",
      "unverify": "Geprüft",
      "verifiedOk": "Produkt geprüft – gilt jetzt für alle Nutzer",
      "unverifiedOk": "Prüfung zurückgenommen",
      "deletedOk": "Produkt gelöscht",
      "deleteTitle": "Produkt löschen?",
      "deleteBody": "wird für alle Nutzer entfernt. Beim nächsten Scan wird es wieder als unbekannt gemeldet.",
      "editTitle": "Produkt korrigieren",
      "brand": "Marke",
      "ingredients": "Zutaten",
      "markVerified": "Als geprüft markieren (gilt für alle Nutzer)"
    },
    "foodsBuiltin": "Standard-Datenbank (nur Ansicht)",
    "dailyActivity": "Aktivität (14 Tage)",
    "signups": "Registrierungen pro Woche",
    "total_recipes": "Rezepte",
    "total_recipes_public": "Öffentliche Rezepte",
    "total_foods_learned": "Gelernte Lebensmittel",
    "total_foods_custom": "Eigene Lebensmittel",
    "total_ai_photo_cache": "KI-Analysen (zwischengespeichert)",
    "total_food_logs_total": "Food-Einträge gesamt",
    "total_workouts_total": "Workouts gesamt",
    "changeRole": "Rolle",
    "roleChangedOk": "Rolle geändert",
    "title": "Admin-Bereich",
    "subtitle": "Alles auf einen Blick — Nutzer, Abos, Inhalte, Statistik",
    "navAdmin": "Admin",
    "tab_overview": "Übersicht",
    "tab_users": "Nutzer",
    "mrr": "Umsatz/Monat",
    "teamAccounts": "Team-Konten",
    "subsApple": "Apple",
    "subsWeb": "Web",
    "subsComp": "Geschenkt",
    "recentUsers": "Neueste Nutzer",
    "seeAllUsers": "Alle Nutzer",
    "todayImportant": "Heute wichtig",
    "todayImportantEmpty": "Alles im grünen Bereich. Nichts zu tun.",
    "grpInactive": "{n} Nutzer seit 7+ Tagen inaktiv",
    "grpFading": "{n} Nutzer mit nachlassender Aktivität",
    "grpOverKcal": "{n} Nutzer über dem Kalorienziel",
    "grpLowProtein": "{n} Nutzer unter dem Proteinziel",
    "grpNewLogs": "{n} neue Tagebucheinträge heute",
    "showAll": "Alle anzeigen",
    "logoutConfirmTitle": "Wirklich abmelden?",
    "logoutConfirmBody": "Du musst dich danach erneut anmelden.",
    "action": {
      "block_user": "Nutzer gesperrt",
      "unblock_user": "Sperre aufgehoben",
      "change_role": "Rolle geändert",
      "delete_user": "Nutzer gelöscht",
      "delete_food": "Lebensmittel gelöscht",
      "delete_recipe": "Rezept gelöscht",
      "merge_recipes": "Rezepte zusammengeführt",
      "edit_food": "Lebensmittel bearbeitet",
      "mark_test": "Als Testkonto markiert",
      "unmark_test": "Testkonto-Markierung aufgehoben",
      "grant_pro": "Pro geschenkt ({months} Monate)",
      "revoke_pro": "Pro entzogen",
      "grant_pro_all": "Pro an alle geschenkt",
      "nudge": "Erinnerung gesendet",
      "recipe_publish": "Rezept veröffentlicht/zurückgezogen",
      "reset_apple_sub": "Apple-Abo zurückgesetzt",
      "update_ai_limits": "KI-Limits geändert",
      "update_settings": "Einstellungen geändert (Gebühr/Kurs)",
      "invite_upgrade": "Einladung zum Pro-Abo gesendet"
    },
    "tab_subs": "Abos",
    "tab_reports": "Meldungen",
    "tab_moderation": "Moderation",
    "tab_audit": "Protokoll",
    "statUsers": "Nutzer",
    "statActive7d": "aktiv (7T)",
    "statPendingOnboarding": "ohne Onboarding",
    "statLogsToday": "Einträge heute",
    "foodEntries": "Food-Einträge",
    "todayLogsTitle": "Food-Einträge heute",
    "openProfile": "Profil öffnen",
    "todayLogsEmpty": "Heute noch keine Einträge",
    "activeUsersTitle": "Aktiv in den letzten 7 Tagen",
    "activeUsersEmpty": "Keine aktiven Nutzer",
    "lastActive": "zuletzt aktiv",
    "logs7d": "Einträge (7 T)",
    "justNow": "gerade eben",
    "inactiveChip": "Inaktiv 7T+",
    "inactiveTitle": "Inaktive Nutzer",
    "inactiveHint": "Seit 7+ Tagen kein Tagebuch-Eintrag. Anstupsen schickt eine freundliche Erinnerung per Push 🔔 (wenn aktiviert) und E-Mail ✉️.",
    "inactiveEmpty": "Alle sind aktiv 🎉",
    "nudge": "Anstupsen",
    "nudgeAll": "Alle anstupsen",
    "nudgeAllConfirm": "{n} Nutzer anstupsen (Push + E-Mail)?",
    "nudgeAllDone": "{n} Nutzer angestupst",
    "nudgeSent": "Erinnerung gesendet",
    "nudgeNoChannel": "kein Kanal (weder Push noch E-Mail)",
    "nudgedOn": "angestupst am",
    "neverLogged": "noch nie geloggt",
    "daysInactive": "Tage inaktiv",
    "statSubs": "Abos",
    "statBlocked": "Gesperrt",
    "statReports": "Meldungen",
    "searchUsers": "Name oder E-Mail",
    "last7days": "Letzte 7 Tage",
    "allLetters": "Alle",
    "country": "Land",
    "countryAll": "Alle Länder",
    "countryUnknown": "Unbekannt",
    "signupsByCountry": "Neuanmeldungen pro Land & Woche",
    "signupsByCountryHint": "letzte 8 Wochen",
    "countryOther": "Andere",
    "signupsNone": "Noch keine Anmeldungen",
    "proByCountry": "Pro-Abos pro Land",
    "proByCountryHint": "Umwandlung = bezahlte Pro ÷ Nutzer ohne Geschenk-Pro",
    "proGifted": "Geschenkt",
    "proConversion": "Umwandlung",
    "filterActive": "Aktiv",
    "filterBlocked": "Gesperrt",
    "noUsers": "Keine Nutzer gefunden.",
    "role": "Rolle",
    "registered": "Registriert",
    "plan": "Plan",
    "blocked": "Gesperrt",
    "linkedClients": "Verknüpfte Nutzer",
    "weights": "Gewichte",
    "payments": "Zahlungen",
    "block": "Sperren",
    "unblock": "Entsperren",
    "delete": "Löschen",
    "deleteConfirm": "Wirklich löschen?",
    "blockReasonPrompt": "Grund für die Sperrung (optional):",
    "blockedOk": "Nutzer gesperrt",
    "unblockedOk": "Nutzer entsperrt",
    "deletedOk": "Nutzer und alle Daten gelöscht",
    "noSubs": "Noch keine Abonnenten.",
    "recentTx": "Letzte Transaktionen",
    "noReports": "Keine Meldungen.",
    "noAudit": "Noch keine Admin-Aktionen protokolliert.",
    "viewTracking": "Tracking & Details ansehen",
    "resetApple": "Apple-Abo zurücksetzen",
    "resetAppleConfirm": "Apple-Abo aus der Datenbank entfernen? (Nur für Sandbox-Tests — ein echtes aktives Abo aktiviert sich wieder)",
    "resetAppleOk": "Apple-Abo zurückgesetzt",
    "aiFeat": {
      "food_photo": "Essensfoto",
      "food_photo_hint": "Nachanalyse",
      "fridge_photo": "Vorrats-Foto",
      "workout_photo": "Workout-Import",
      "coach_chat": "KI-Coach",
      "pantry_recipe": "Vorrats-Rezepte",
      "weekly_menu": "Wochenmenüs",
      "social_caption": "Social-Texte"
    }
  },
  "notifBell": {
    "achievements": "Erfolge",
    "levelUp": "Level {level} erreicht — „{name}“",
    "streak": "{days}-Tage-Serie! +{points} SP",
    "badge": "Neues Abzeichen: {name}",
    "goals": {
      "water_goal": "Wasserziel erreicht",
      "steps_goal": "Schrittziel erreicht",
      "sleep_7h": "7 Std. Schlaf geschafft",
      "diary_complete": "Tagebuch komplett (3+ Mahlzeiten)",
      "plate_check_80": "Ausgewogener Teller geschafft"
    },
    "title": "Benachrichtigungen",
    "empty": "Keine neuen Benachrichtigungen",
    "openFriends": "Freunde öffnen"
  },
  "offline": {
    "savedOffline": "Kein Netz – Mahlzeit lokal gespeichert, wird automatisch nachgesendet",
    "synced": "{count} Mahlzeit(en) nachgesendet",
    "syncFailed": "{count} Mahlzeit(en) konnten nicht gesendet werden",
    "pendingTitle": "{count} Mahlzeit(en) warten auf Verbindung",
    "pendingHint": "Sie werden automatisch ins Tagebuch übertragen, sobald wieder Netz da ist.",
    "sendNow": "Jetzt senden",
    "stillOffline": "Noch keine Verbindung – wir versuchen es weiter",
    "waiting": "Wartet auf Verbindung"
  },
  "voicePrivacy": {
    "title": "Was passiert mit meiner Stimme?",
    "pillNotStored": "Stimme wird nicht gespeichert",
    "pillStored": "Sprachnachricht wird gespeichert",
    "introDictation": "Die Diktierfunktion wandelt deine Stimme nur in Text um.",
    "dict1": "Die Aufnahme wird verschlüsselt übertragen und ausschließlich in Text umgewandelt. Gespeichert wird nur dieser Text – so, als hättest du ihn getippt. Du kannst ihn vor dem Speichern prüfen und ändern.",
    "dict2": "Die Audiodatei wird sofort nach der Umwandlung gelöscht. Sie landet weder in der Datenbank noch in Backups.",
    "dict3": "Das Mikrofon ist nur aktiv, während du bewusst aufnimmst. Kein Mithören im Hintergrund.",
    "introStored": "Diese Sprachnachricht ist für deine Ernährungsberatung bestimmt.",
    "msg1": "Die Aufnahme wird – wie eine Chatnachricht – am Eintrag gespeichert, damit deine Beraterin oder dein Berater sie anhören kann.",
    "msg2": "Nur du und deine verbundene Beratung können sie abspielen. Sie wird nicht an eine KI gesendet und nicht in Text umgewandelt.",
    "msg3": "Du löschst sie jederzeit, indem du die Antwort ersetzt, den Eintrag oder dein Konto löschst.",
    "never": "Stimme, Fotos und Chats werden nie für KI-Training verwendet und nie an Werbenetzwerke weitergegeben.",
  },
  "dailySummary": {
    "sourceManual": "Manuell",
    "pickTheme": "Design wählen",
    "waterQuickTitle": "Wasser hinzufügen",
    "waterCustomPlaceholder": "ml eingeben…",
    "title": "Dein Tag",
    "today": "Heute",
    "sleep": "Schlaf",
    "steps": "Schritte",
    "water": "Wasser",
    "kcal": "Kcal",
    "workout": "Training",
    "goals": "Ziele",
    "missionsAllDone": "Missionen abgeschlossen! 🎉",
    "missionsAllDoneSub": "+{n} SP Tagesbonus",
    "download": "Tag herunterladen",
    "downloaded": "Bild gespeichert",
    "shareTitle": "Mein Solano-Tag",
    "share": "Teilen",
    "longPressToSave": "Bild gedrückt halten, um es in Fotos zu sichern",
    "previewHint": "Bild speichern oder direkt teilen",
    "shareFailedHint": "Teilen nicht möglich – halte das Bild gedrückt, um es zu sichern",
    "mealsToday": "Heutige Mahlzeiten",
    "noMeals": "Heute keine Mahlzeiten protokolliert",
    "pointsToday": "Punkte heute",
    "coachMessage": "Dein Coach sagt",
    "brand": "Dein Tag in Bestform",
    "defaultMotivation": "Ein Tag nach dem anderen. Kleine Schritte, große Erfolge. 💪",
    "themeLabel": "Design",
    "themes": {
      "bright_morning": "Heller Morgen",
      "golden_hour": "Goldene Stunde",
      "deep_teal": "Tiefes Teal",
      "berry_night": "Beeren-Nacht"
    }
  },
  "coach": {
    "title": "Heutiger Coach",
    "today": "Solano KI",
    "refresh": "Aktualisieren"
  },
  "mascots": {
    "section": "Maskottchen-Momente",
    "title": "Deine Sammlung",
    "steps": "Schrittziel",
    "stepsHint": "Erreiche dein Schrittziel",
    "training": "Training",
    "trainingHint": "Schließe ein Training ab",
    "water": "2L Wasser",
    "waterHint": "Trinke 2 Liter an einem Tag",
    "sleep": "Schlafziel",
    "sleepHint": "Erreiche dein Schlafziel",
    "unlockedCount": "{n} von {total} freigeschaltet"
  },
  "nutriscore": {
    "info": {
      "title": "Was ist der Nutri-Score?",
      "body": "Der Nutri-Score dient als Orientierung und vergleicht ähnliche Produkte miteinander. Er sagt nicht allein aus, ob ein Lebensmittel gesund oder ungesund ist.",
      "hint": "A = ausgewogenere Nährwerte pro 100 g. E = intensive Zutaten wie Zucker, Salz oder gesättigte Fettsäuren."
    }
  },
  "solano": {
    "label": "Solano Bewertung",
    "tier": {
      "very_good": "Sehr gute Wahl",
      "good": "Gute Wahl",
      "ok": "In Ordnung",
      "mindful": "Bewusst geniessen"
    },
    "hint": {
      "bio": "Bio-Qualität",
      "wholegrain": "Vollkorn",
      "no_added_sugar": "Ohne zugesetzten Zucker",
      "less_fat": "Weniger Fett als klassisch",
      "fried": "Frittiert — sparsam verwenden",
      "processed_meat": "Verarbeitetes Fleisch — bewusst",
      "whole_food": "Ganzes Lebensmittel",
      "mindful": "Nur gelegentlich",
      "watch_salt": "Salz und gesättigte Fettsäuren beachten",
      "hydrating": "Ideal zum Hydrieren"
    }
  },
  "nutAdvice": {
    "title": "Ernährungscoach",
    "chipLabel": "Ernährung",
    "subtitle": "{count} konkrete Tipps für den Rest des Tages",
    "noData": "Mahlzeiten loggen, um Tipps zu erhalten"
  },
  "challenges": {
    "title": "Heutige Challenges",
    "chipLabel": "Challenges",
    "subtitle": "{done}/{total} heute geschafft",
    "allDone": "Alle Challenges heute geschafft! 🎉",
    "startCta": "Starte mit Tracken, um die Challenges freizuschalten",
    "hint": "Setzt sich täglich zurück. Halte die Serie am Laufen!",
    "completed": "Geschafft",
    "remaining": "fehlen",
    "edit": "Anpassen",
    "editTitle": "Deine Challenges anpassen",
    "editDesc": "Lege deine täglichen Ziele fest und deaktiviere, was du nicht tracken willst.",
    "steps": "Schritte",
    "fiber": "Ballaststoffe",
    "protein": "Protein",
    "water": "Wasser",
    "saveBtn": "Challenges speichern",
    "saved": "Challenges aktualisiert!",
    "resetDefaults": "Standardwerte",
    "atLeastOne": "Mindestens eine Challenge muss aktiv bleiben"
  },
  "learn": {
    "title": "Lernen",
    "chipLabel": "Lernen",
    "chipNew": "Neuer Artikel",
    "subtitle": "Deine Pille für heute",
    "next": "Nächste Pille",
    "loading": "Ich wähle eine Pille für dich…",
    "empty": "Keine Pille verfügbar",
    "catNutrition": "Ernährung",
    "catBasics": "Grundlagen",
    "basicsProgress": "Grundlagen-Lehrplan · Lektion {n} von {total}",
    "quizTitle": "Kurz-Quiz",
    "quizCorrect": "Richtig!",
    "quizCorrectSp": "Richtig! +{points} Solano Points",
    "quizWrong": "Leider falsch — die richtige Antwort ist markiert.",
    "catHealth": "Gesundheit",
    "catRecipes": "Rezepte",
    "catMyths": "Mythen entlarvt",
    "pickCategory": "Thema wechseln",
    "limitReached": "Du hast alle heutigen Pillen gesehen — komm morgen wieder!",
    "statsTitle": "Deine Lernwoche",
    "weekCorrect": "{correct}/{answered} richtig",
    "streak": "{n} Tage Lernsträhne",
    "streakNone": "Starte heute deine Lernsträhne",
    "streakNext": "Bonus ab {n} Tagen",
    "streakBonusToday": "+{points} Bonus heute",
    "streakBonus": "Lernsträhne {n} Tage: +{points} Solano Points Bonus!",
    "reviewTitle": "Wiederholung",
    "reviewDue": "{n} fällig",
    "reviewStart": "Wissens-Check: alte Karte wiederholen",
    "reviewHint": "Karte von vor {days} Tagen — sitzt das Wissen noch?",
    "reviewNone": "Keine Wiederholung fällig — weiter so!",
    "reviewCorrect": "Sitzt! +{points} Solano Points",
    "reviewWrong": "Nicht ganz — merk dir die markierte Antwort.",
    "reviewNext": "Nächste Wiederholung ({n})"
  },
  "med": {
    "title": "Mediterran-Score",
    "chipLabel": "Med",
    "chipDays": "Letzte {days}T",
    "chipEmpty": "Mahlzeit loggen",
    "subtitle": "Letzte {days} Tage",
    "hint": "Einhaltung der Mittelmeerdiät: mehr Olivenöl, Fisch, Gemüse, Hülsenfrüchte, Vollkorn und Nüsse; weniger rotes Fleisch.",
    "noData": "Mahlzeiten der letzten 7 Tage loggen",
    "infoAria": "So funktioniert der Score",
    "infoTag": "So funktioniert's",
    "infoTitle": "Dein Mittelmeer-Score",
    "infoBody": "Wir analysieren die letzten 7 Tage deines Ernährungstagebuchs und erkennen 8 typische Mittelmeer-Lebensmittelgruppen (plus eine Strafe für rotes Fleisch). Jede Mahlzeit wird nach ihren Zutaten klassifiziert; wenn du auch Gramm angibst (z.B. \"80g Spinat\"), berechnen wir echte Portionen nach CREA/EFSA-Richtlinien.",
    "infoTargetsTitle": "Wöchentliche Ziele · Portion",
    "infoTip": "Tipp: gib Gramm in deinen Mahlzeiten an (z.B. \"150g Bohnen\") für eine genauere Zählung. Ohne Gramm zählt jede Mahlzeit als 1 Portion.",
    "infoSource": "Quelle: MedDiet Adherence Score (Trichopoulou 2003, PREDIMED), CREA/EFSA-Portionsrichtlinien.",
    "penaltyHint": "Jede Portion über 1/Woche zieht Punkte ab (max −6).",
    "tipTitle": "Tipp für heute",
    "tipCta": "Passende Rezepte ansehen",
    "genEmpty": "Kein passendes Rezept in deiner Bibliothek",
    "genBtn": "Mit KI ein neues Rezept erzeugen",
    "tips": {
      "olive_oil": "Heute noch einen Esslöffel Olivenöl einbauen – z.B. übers Gemüse oder in den Salat.",
      "fish": "Plane heute oder morgen eine Portion Fisch ein – z.B. Lachs, Forelle oder Thunfisch.",
      "vegetables": "Heute noch eine Extraportion Gemüse – z.B. Salat, Brokkoli oder Ofengemüse.",
      "fruits": "Greif heute noch zu einem Stück Obst – z.B. Apfel, Beeren oder eine Banane.",
      "legumes": "Heute noch eine Portion Hülsenfrüchte – z.B. Linsen, Kichererbsen oder Bohnen.",
      "whole_grains": "Wähle heute Vollkorn – z.B. Haferflocken, Vollkornbrot oder Vollkornreis.",
      "nuts_seeds": "Eine kleine Handvoll Nüsse oder Samen als Snack – z.B. Mandeln oder Walnüsse.",
      "dairy_fermented": "Heute noch ein Joghurt, Skyr oder Kefir – ideal als Snack oder zum Frühstück.",
      "red_meat": "Diese Woche war viel rotes Fleisch dabei – tausche heute gegen Fisch, Geflügel oder Hülsenfrüchte.",
      "processed_meat": "Wurst & Aufschnitt reduzieren – probier heute Hummus, Käse oder Avocado als Belag."
    }
  },
  "moderation": {
    "newReportToast": "Neue Meldung ({reason}) zu {name}",
    "openReports": "{n} offene Meldungen",
    "report": "Melden",
    "block": "Blockieren",
    "unblock": "Blockierung aufheben",
    "reportTitle": "{name} melden",
    "reason_harassment": "Belästigung",
    "reason_spam": "Spam",
    "reason_inappropriate": "Unangemessener Inhalt",
    "reason_other": "Sonstiges",
    "reportTextPh": "Optional: Was ist passiert?",
    "reportHint": "Deine Meldung geht vertraulich an das Solano-Team und wird innerhalb von 24 h geprüft.",
    "reportSubmit": "Meldung senden",
    "reportSent": "Danke – deine Meldung wurde übermittelt.",
    "blockConfirm": "{name} blockieren? Ihr seht euch nicht mehr, Nachrichten und Freundschaftsanfragen (auch per Code) sind nicht mehr möglich.",
    "blockedOk": "{name} wurde blockiert.",
    "unblockedOk": "Blockierung aufgehoben.",
    "sendBlocked": "Nachricht nicht möglich – dieser Kontakt ist blockiert.",
    "blockedTitle": "Blockierte Nutzer",
    "blockedHint": "Blockierte Personen können dir keine Nachrichten und Anfragen senden.",
    "blockedEmpty": "Du hast niemanden blockiert.",
    "filter_open": "Offen",
    "filter_resolved": "Erledigt",
    "filter_all": "Alle",
    "noReports": "Keine Meldungen.",
    "reportedUser": "Gemeldet",
    "reporter": "Gemeldet von",
    "userBlocked": "gesperrt",
    "messageDeleted": "Nachricht gelöscht",
    "deleteMessage": "Nachricht löschen",
    "blockUser": "Nutzer sperren",
    "blockConfirmAdmin": "Diesen Nutzer sperren? Alle Sitzungen werden beendet.",
    "resolve": "Erledigt",
    "deletedOk": "Nachricht gelöscht.",
    "userBlockedOk": "Nutzer gesperrt.",
    "resolvedOk": "Meldung erledigt."
  },
  "friends": {
    "remove": "Freund entfernen",
    "photoCamera": "Foto aufnehmen",
    "photoFile": "Bild aus Galerie/Datei senden",
    "shareTitle": "Teilen",
    "shareTabMeals": "Mahlzeiten",
    "shareTabRecipes": "Rezepte",
    "shareRecipeHint": "Wähle ein gespeichertes Rezept – es wird als Karte mit Nährwerten in den Chat gesendet.",
    "shareRecipeEmpty": "Keine Rezepte gefunden.",
    "searchRecipes": "Rezept suchen…",
    "recipeShared": "Rezept",
    "openRecipe": "Rezept öffnen",
    "perServing": "pro Portion",
    "shareMeal": "Mahlzeit teilen",
    "shareMealTitle": "Mahlzeit teilen",
    "shareMealHint": "Wähle eine geloggte Mahlzeit – sie wird mit Foto und Nährwerten in den Chat gesendet.",
    "shareMealEmpty": "Noch keine Mahlzeiten geloggt.",
    "mealShared": "Mahlzeit",
    "removeConfirm": "Freund wirklich entfernen? Der Chat-Verlauf bleibt bis zum erneuten Verbinden verborgen.",
    "openChat": "Öffnen",
    "toastGoToChat": "Tippe, um zum Chat zu gehen",
    "chatEmpty": "…",
    "pageTitle": "Freunde",
    "pageSubtitle": "Finde Freunde und motiviert euch gegenseitig",
    "requestsInbox": "Eingehende Anfragen",
    "addSection": "Freunde hinzufügen",
    "yourFriends": "Deine Freunde",
    "leaderboardTitle": "Wöchentliche Rangliste",
    "leaderboardHint": "Durchschnittlicher Health Score der letzten 7 Tage",
    "computingBoard": "Rangliste wird berechnet…",
    "boardEmpty": "Noch keine Freunde in der Rangliste.",
    "boardEmptyHint": "Füge Freunde hinzu, um euch jede Woche zu vergleichen.",
    "daysActive": "{n} aktive Tage",
    "noDayTracked": "Kein Tag erfasst",
    "you": "Du",
    "yourCode": "Dein Code",
    "copy": "Kopieren",
    "regenerate": "Neu erzeugen",
    "shareHint": "Teile diesen Code mit einem Freund über WhatsApp. Er gibt ihn in seiner App ein und ihr werdet Freunde.",
    "shareWa": "Auf WhatsApp teilen",
    "hasCodeQ": "Hast du den Code eines Freundes?",
    "redeemBtn": "Hinzufügen",
    "codeInvalid": "Der Code muss 6 Zeichen haben",
    "alreadyFriends": "Ihr seid bereits Freunde",
    "codeNotValid": "Ungültiger Code",
    "copyOk": "Code kopiert",
    "copyErr": "Kopieren nicht möglich",
    "newCodeGen": "Neuer Code erzeugt",
    "genericError": "Fehler",
    "waMessage": "Hallo! Füge mich auf Solano Essence mit meinem Code hinzu: {code}\nApp laden: https://solano-essence.com",
    "chatMsgPlaceholder": "Nachricht schreiben…",
    "removeFriend": "Freund entfernen",
    "confirmRemove": "Möchtest du diesen Freund wirklich entfernen?",
    "removedOk": "Freund entfernt",
    "accept": "Annehmen",
    "decline": "Ablehnen",
    "noChange": "Keine Änderung",
    "pushBannerTitle": "Benachrichtigungen aktivieren",
    "pushBannerHint": "Erhalte auch bei geschlossener App eine Nachricht, wenn dir ein Freund schreibt",
    "pushBannerCta": "Aktivieren",
    "pushToastOk": "Benachrichtigungen aktiviert!",
    "emptyList": "Noch keine Freunde. Suche oben, um jemanden hinzuzufügen.",
    "confirmRegen": "Wenn du den Code neu generierst, funktioniert der alte nicht mehr. Fortfahren?"
  },
  "mealType": {
    "colazione": "Frühstück",
    "spuntino": "Zwischenmahlzeit",
    "pranzo": "Mittagessen",
    "merenda": "Nachmittagssnack",
    "cena": "Abendessen",
    "altro": "Sonstiges"
  },
  "exlib": {
    "ctaBtn": "Training zusammenstellen",
    "ctaHint": "Übungen aus der Bibliothek wählen, Vorlage laden oder live trainieren",
    "title": "Übungsbibliothek",
    "subtitle": "Über 870 Übungen mit Bildern – Kraft, Cardio, Dehnen",
    "tabSearch": "Übungen",
    "tabTemplates": "Vorlagen",
    "tabPlan": "Mein Plan",
    "searchPlaceholder": "Übung oder Muskel suchen…",
    "all": "Alle",
    "results": "{n} Übungen",
    "exercises": "Übungen",
    "loadingInstructions": "Anleitung wird übersetzt…",
    "addToPlan": "Zum Training hinzufügen",
    "inPlan": "Im Plan",
    "planEmpty": "Noch keine Übungen – wähle welche aus der Suche oder lade eine Vorlage.",
    "sets": "Sätze",
    "reps": "Wdh.",
    "repsShort": "Wdh.",
    "seconds": "Sek.",
    "useTime": "Nach Zeit",
    "useReps": "Nach Wdh.",
    "saveDone": "Als erledigt speichern",
    "startLive": "Jetzt starten",
    "customWorkout": "Mein Training",
    "setsDone": "{done} von {total} Sätzen",
    "rest": "Pause",
    "finish": "Training beenden",
    "abortConfirm": "Training abbrechen? Abgehakte Sätze gehen verloren.",
    "saved": "Training gespeichert – {min} Min, stark!",
    "liveNote": "Live-Training: {done}/{total} Sätze",
    "savedPlan": "Training gespeichert",
    "lastTime": "Letztes Mal: {w} kg × {r} ({d})",
    "lastTimeReps": "Letztes Mal: {r} Wdh. ({d})",
    "best": "Bestwert {w} kg",
    "newRecord": "Neuer Bestwert!",
    "saveTemplate": "Als Vorlage speichern",
    "templateName": "Name der Vorlage",
    "templateSaved": "Vorlage gespeichert",
    "myTemplates": "Meine Vorlagen",
    "fromCoach": "Vom Coach",
    "deleteTemplateConfirm": "Diesen Plan löschen?",
    "myPlansTitle": "Meine Trainingspläne",
    "myPlansHint": "Antippen und direkt loslegen",
    "assignToClient": "Dem Kunden zuweisen",
    "assigned": "Plan zugewiesen",
    "coachPlansTitle": "Trainingspläne",
    "coachPlansEmpty": "Noch kein Plan zugewiesen – stelle einen aus der Übungsbibliothek zusammen.",
    "assignBtn": "Plan zuweisen",
    "editPlan": "Plan bearbeiten",
    "saveChanges": "Änderungen speichern",
    "changesSaved": "Plan aktualisiert",
    "daysLabel": "Tage",
    "todayDue": "Heute dran",
    "todaySuggest": "Heute steht an: {name}",
    "historyTitle": "Live-Trainings & Bestwerte",
    "historyEmpty": "Noch keine Trainings mit Übungen protokolliert.",
    "curveTitle": "Maximalgewicht – letzte {weeks} Wochen",
    "curveEmpty": "Noch zu wenig Daten für eine Kurve – ab dem zweiten Training mit Gewicht.",
    "suggestWeight": "Letztes Mal alle Sätze geschafft – Vorschlag {w} kg (+2,5)",
    "keepLast": "{w} kg behalten",
    "weekTitle": "Dein Wochen-Rückblick",
    "weekWorkouts": "Trainings",
    "weekMinutes": "Minuten",
    "weekVolume": "Volumen",
    "weekRecords": "Bestwerte",
    "weekVolumeHint": "Du hast diese Woche {kg} kg bewegt – Sätze × Wdh. × Gewicht. Stark!",
    "weekHint": "Trag beim nächsten Training Gewichte ein, dann siehst du hier dein Volumen.",
    "weekShare": "Rückblick teilen",
    "weekNewRecords": "Neue Bestwerte",
    "weekShareNoRecords": "Dranbleiben – nächste Woche fällt ein Bestwert!",
    "weekShareFooter": "Trainiert mit Solano Essence",
    "weekShareDownloaded": "Bild gespeichert",
    "deloadHint": "{n} Wochen in Folge gesteigert – diese Woche leichter: {w} kg (−10 %)",
    "deloadApply": "Übernehmen",
    "deloadTitle": "Deload-Woche empfohlen",
    "deloadBody": "{names}: {n} Wochen in Folge gesteigert. Geh diese Woche mit −10 % ran – so regeneriert dein Körper und du kommst stärker zurück.",
    "swapTitle": "Gerät besetzt? Alternative für denselben Muskel",
    "swapEmpty": "Keine passende Alternative gefunden.",
    "swapped": "Getauscht gegen {name}",
    "photoStart": "Startposition",
    "photoEnd": "Endposition",
    "openDetail": "Übung ansehen",
    "placeGym": "Studio",
    "placeHome": "Zuhause",
    "showAll": "Alle anzeigen",
    "showCore": "Nur Klassiker",
    "pickGroup": "Was willst du trainieren?",
    "coreCount": "{n} Klassiker",
    "resultsCore": "{n} Klassiker · {all} gesamt",
    "moreAll": "{n} weitere Übungen anzeigen",
    "empty": "Nichts gefunden – versuch einen anderen Begriff.",
    "coreBadge": "Klassiker",
    "guideLoading": "Coach-Tipps werden geladen …",
    "steps": "Ausführung",
    "tips": "Technik-Tipps",
    "mistakes": "Häufige Fehler",
    "breathing": "Atmung",
    "feel": "Hier spürst du es",
    "easier": "Leichter",
    "harder": "Schwerer",
    "showPhotos": "Original-Fotos anzeigen",
    "hidePhotos": "Fotos ausblenden",
    "regenImage": "Bild stimmt nicht? Neu zeichnen",
    "regenDone": "Maskottchen neu gezeichnet",
    "regenRecent": "Wurde in den letzten 24 h schon neu gezeichnet",
    "regenBudget": "KI-Guthaben für heute aufgebraucht – bitte später nochmals",
    "group": {
      "chest": "Brust",
      "back": "Rücken",
      "legs": "Beine & Po",
      "shoulders": "Schultern",
      "arms": "Arme",
      "core": "Bauch & Core",
      "cardio": "Cardio & Ganzkörper",
      "stretch": "Mobility & Dehnen"
    }
  },
  "recipePhoto": {
    "title": "Rezeptbild ändern",
    "menu": "Foto ändern",
    "takePhoto": "Foto aufnehmen",
    "fromGallery": "Aus Galerie wählen",
    "aiHint": "Die KI erstellt ein passendes Foodfoto aus Name und Zutaten",
    "remove": "Foto entfernen",
    "updated": "Rezeptbild aktualisiert",
    "removed": "Rezeptbild entfernt",
    "cropTitle": "Bild zuschneiden",
    "cropHint": "Ziehen zum Verschieben, zwei Finger zum Zoomen, Pfeile zum Drehen",
    "cropApply": "Zuschneiden & speichern",
    "styleTitle": "Stil für das KI-Foto",
    "styleRustic": "Rustikal",
    "styleBright": "Hell & modern",
    "styleTopdown": "Draufsicht",
    "generateNow": "Jetzt erstellen",
    "variantsBtn": "2 Vorschläge erzeugen",
    "variantsGenerating": "Zwei Vorschläge entstehen…",
    "pickTitle": "Welches gefällt dir besser?",
    "pickHint": "Tippe auf das bessere Foto und übernimm es.",
    "variantsRetry": "Neu würfeln",
    "variantApply": "Dieses übernehmen"
  },
  "recipeScan": {
    "addPage": "Weitere Seite / Rückseite",
    "photosCount": "{n} Foto(s) ausgewählt",
    "readBtn": "Rezept lesen",
    "removePhoto": "Foto entfernen",
    "or": "oder",
    "urlLabel": "Rezept-Link einfügen",
    "urlPlaceholder": "https://…/rezept",
    "urlBtn": "Einlesen",
    "urlReading": "Webseite wird gelesen…",
    "urlError": "Seite konnte nicht geladen werden – Link prüfen oder Screenshot fotografieren.",
    "invalidUrl": "Bitte einen gültigen Link eingeben.",
    "ctaBtn": "Rezept abfotografieren",
    "title": "Rezept aus Foto",
    "subtitle": "Fotografiere eine Kochbuch-Seite oder Rezeptkarte – die KI wandelt sie in ein Solano-Rezept um.",
    "takePhoto": "Foto aufnehmen",
    "fromGallery": "Aus Galerie",
    "tip": "Tipp: Seite flach und gut beleuchtet fotografieren, Zutaten und Zubereitung sollten lesbar sein.",
    "scanning": "Rezept wird gelesen…",
    "scanningHint": "Zutaten, Mengen und Schritte werden erkannt und Nährwerte berechnet.",
    "reviewTitle": "Rezept prüfen",
    "reviewDesc": "Prüfe Name, Mengen und Schritte – dann speichern.",
    "nameLabel": "Name",
    "servingsLabel": "Portionen",
    "ingredientsLabel": "Zutaten (eine pro Zeile)",
    "stepsLabel": "Zubereitung (ein Schritt pro Zeile)",
    "filledNote": "{n} Zutat(en) ohne Menge wurden mit typischen Mengen ergänzt – bitte prüfen.",
    "usePhoto": "Foto als Rezeptbild verwenden",
    "fromSource": "Quelle: {title}",
    "lowConfidence": "Die Seite war schwer lesbar – bitte Zutaten und Mengen genau kontrollieren.",
    "save": "Als Rezept speichern",
    "saved": "Rezept „{name}“ gespeichert",
    "retake": "Anderes Foto",
    "noRecipe": "Auf dem Foto wurde kein Rezept erkannt – bitte Seite mit Zutaten und Zubereitung fotografieren.",
    "error": "Rezept konnte nicht gelesen werden – bitte erneut versuchen."
  },
  "fridge": {
    "ctaBtn": "Aus dem Kühlschrank",
    "title": "Was hast du im Kühlschrank?",
    "subtitle": "Liste deine Zutaten auf und die KI erstellt ein Rezept mit Makros und Nährwerten.",
    "ingredientsLabel": "Deine Zutaten",
    "ingredientsPlaceholder": "z. B. 2 Eier, 200g Tomaten, Mozzarella, Reis, Basilikum, Olivenöl",
    "ingredientsHint": "Mit Komma trennen. Salz, Pfeffer, Wasser und Öl sind vorausgesetzt.",
    "photoBtn": "Foto Kühlschrank",
    "recognizing": "Erkenne…",
    "photoDetected": "{count} Zutaten aus dem Foto hinzugefügt",
    "photoRecogError": "Zutaten konnten nicht erkannt werden, bitte erneut versuchen",
    "mealTypeLabel": "Mahlzeit (optional)",
    "maxTimeLabel": "Max. Zeit (Min)",
    "servingsLabel": "Portionen",
    "goalLabel": "Für welches Ziel?",
    "goalAny": "Egal",
    "goalHint.weight_loss": "≈ 350-500 kcal · ≥ 20 g Eiweiß pro Portion",
    "goalHint.maintenance": "≈ 450-650 kcal · ausgewogene Makros",
    "goalHint.muscle_gain": "≈ 600-800 kcal · ≥ 35 g Eiweiß pro Portion",
    "dietaryLabel": "Präferenzen (optional)",
    "dietVeg": "Vegetarisch",
    "dietVegan": "Vegan",
    "dietGlutenFree": "Glutenfrei",
    "dietLactoseFree": "Laktosefrei",
    "dietLowCarb": "Low Carb",
    "dietHighProtein": "Eiweissreich",
    "generateBtn": "Rezept erstellen",
    "generating": "Ich erstelle dein Rezept…",
    "generatingHint": "GPT-5.2 plant Zutaten, Schritte und Makros.",
    "needIngredients": "Mindestens 2 Zutaten hinzufügen.",
    "errorGen": "Fehler bei der Erstellung. Bitte erneut versuchen.",
    "recipeReady": "Rezept bereit!",
    "reviewDesc": "Im Rezeptbuch gespeichert. Du kannst ein KI-Foto erzeugen.",
    "ingredientsSection": "Zutaten",
    "stepsSection": "Zubereitung",
    "servingsShort": "Port.",
    "macrosAccurate": "Genaue Makros",
    "matchedTip": "Aus der Solano-Datenbank berechnet.",
    "missingLabel": "Optionale Zutaten, die das Rezept aufwerten würden:",
    "newRecipe": "Neu",
    "generatePhoto": "KI-Foto erstellen",
    "photoDone": "Foto fertig!",
    "photoError": "KI-Foto-Fehler.",
    "done": "Fertig",
    "goalHint": {
      "weight_loss": "≈ 350–500 kcal · ≥ 20 g Eiweiß pro Portion",
      "maintenance": "≈ 450–650 kcal · ausgewogene Makros",
      "muscle_gain": "≈ 600–800 kcal · ≥ 35 g Eiweiß pro Portion"
    }
  },
  "login": {
    "portalTag": "Nutzer-Portal",
    "title": "Willkommen zurück.",
    "subtitle": "Melde dich mit Google an, um deine Reise mit deiner Ernährungsberatung fortzusetzen.",
    "googleBtn": "Mit Google fortfahren",
    "appleBtn": "Mit Apple anmelden",
    "hint": "Neu hier? Bei der ersten Anmeldung wirst du gefragt, ob du",
    "hintNut": "Ernährungsberater*in",
    "hintOr": "oder",
    "hintCli": "Nutzer*in bist",
    "tagline": "Deine Essenz, dein Gleichgewicht.",
    "taglineDesc": "Das Portal für Nutzer der Praxis Solano Essence. Ernährung, Sport und Fortschritt an einem Ort.",
    "discipline": "Klinische Ernährung · Sporternährung",
    "tabGoogle": "Google",
    "tabEmail": "E-Mail",
    "emailLabel": "E-Mail-Adresse",
    "emailPlaceholder": "name@beispiel.ch",
    "welcomeSub": "Melde dich an, um deine Gesundheitsreise fortzusetzen.",
    "passwordLabel": "Passwort",
    "loginBtn": "Anmelden",
    "noAccount": "Noch kein Konto?",
    "registerLink": "Registrieren",
    "registerTitle": "Konto erstellen",
    "registerSubtitle": "Registriere dich mit E-Mail und Passwort, um zu starten.",
    "inviteLabel": "Beta-Einladungscode",
    "inviteHint": "Mit deiner Beta-Einladung erhalten",
    "invite": {
      "required": "Ein Einladungscode ist erforderlich. Frag deinen Ernährungsberater.",
      "invalid": "Ungültiger Code. Bitte prüfe oder fordere einen neuen an.",
      "used": "Dieser Code wurde bereits verwendet.",
      "revoked": "Dieser Code wurde widerrufen.",
      "emailMismatch": "Dieser Code ist an eine andere E-Mail gebunden. Nutze die vom Ernährungsberater angegebene Adresse."
    },
    "nameLabel": "Vollständiger Name",
    "confirmPasswordLabel": "Passwort bestätigen",
    "registerBtn": "Konto erstellen",
    "haveAccount": "Schon ein Konto?",
    "loginLink": "Anmelden",
    "passwordsDontMatch": "Passwörter stimmen nicht überein",
    "passwordTooShort": "Passwort muss mindestens 6 Zeichen haben",
    "forgotPassword": "Passwort vergessen?",
    "or": "oder",
    "invalidCredentials": "E-Mail oder Passwort falsch."
  },
  "forgot": {
    "tag": "Passwort wiederherstellen",
    "title": "Passwort zurücksetzen",
    "subtitle": "Gib deine E-Mail ein: Falls dein Konto existiert, erhältst du einen Link zum Festlegen eines neuen Passworts.",
    "tagline": "Wir helfen dir sicher zurück.",
    "taglineDesc": "Du erhältst einen sicheren Link per E-Mail. Der Link ist 60 Minuten gültig.",
    "submitBtn": "Reset-Link senden",
    "sentTitle": "Prüfe deine E-Mail",
    "sentBody": "Wenn die eingegebene Adresse zu einem Solano-Essence-Konto gehört, erhältst du eine E-Mail mit einem Link zum Zurücksetzen des Passworts.",
    "sentHint": "E-Mail nicht gefunden? Prüfe Spam- und Werbeordner.",
    "backToLogin": "Zurück zur Anmeldung"
  },
  "reset": {
    "tag": "Neues Passwort",
    "title": "Wähle dein neues Passwort",
    "subtitle": "Mindestens 6 Zeichen. Nach der Änderung melden wir dich automatisch an.",
    "tagline": "Ein sicherer Neuanfang.",
    "taglineDesc": "Nach der Bestätigung wirst du in deinen persönlichen Bereich weitergeleitet.",
    "newPasswordLabel": "Neues Passwort",
    "confirmPasswordLabel": "Neues Passwort bestätigen",
    "submitBtn": "Neues Passwort bestätigen",
    "success": "Passwort aktualisiert!",
    "invalidTitle": "Ungültiger Link",
    "invalidBody": "Der Link fehlt oder ist ungültig. Fordere einen neuen im Bereich „Passwort vergessen“ an."
  },
  "profileSetup": {
    "hint": "Letzter Schritt",
    "title": "Dein Profil",
    "subtitle": "Wir brauchen nur ein paar Angaben, um deine täglichen Kalorien und Makros automatisch zu berechnen.",
    "goalLabel": "Dein Ziel",
    "activityLabel": "Aktivitätsniveau",
    "submit": "Berechnen & weiter",
    "skip": "Später ausfüllen",
    "savedOk": "Profil gespeichert — Kalorien berechnet!",
    "privacyNote": "Du kannst diese Werte jederzeit im Profil ändern.",
    "errAge": "Ungültiges Alter (10-120)",
    "errHeight": "Ungültige Größe (100-250 cm)",
    "errWeight": "Ungültiges Gewicht (30-300 kg)"
  },
  "onboarding": {
    "welcome": "Willkommen",
    "title": "Wie willst du die App nutzen?",
    "subtitle": "Wähle deine Rolle. Du kannst den Support kontaktieren, um sie zu ändern.",
    "nutTitle": "Ich bin die Ernährungsberatung",
    "nutDesc": "Nutzer verwalten, KI-gestützte Ernährungspläne erstellen, Fortschritt und Termine im Blick.",
    "cliTitle": "Ich bin Nutzer*in",
    "cliDesc": "Deinem Plan folgen, Gewicht & Maße erfassen, Mahlzeiten loggen, Termine buchen.",
    "inviteTitle": "Einladungscode",
    "inviteDesc": "Gib den Code deiner Ernährungsberatung ein, um dein Profil zu verknüpfen.",
    "inviteLabel": "Einladungscode",
    "invitePlaceholder": "Z.B. A1B2C3D4",
    "linkMe": "Verknüpfen",
    "inviteRequired": "Bitte gib den Einladungscode ein",
    "inviteInvalid": "Ungültiger Code",
    "linkedOk": "Mit deiner Ernährungsberatung verknüpft!",
    "yourCode": "Dein Einladungscode",
    "shareCodeDesc": "Teile diesen Code mit deinen Nutzer — sie nutzen ihn, um sich mit deiner Praxis zu verbinden.",
    "goToDash": "Zum Panel →",
    "clientOptionsTitle": "Wie möchtest du starten?",
    "clientOptionsDesc": "Verbinde dich sofort mit einer Ernährungsberatung per Einladungscode oder starte alleine. Du kannst später jederzeit im Profil eine Beratung verknüpfen.",
    "recommended": "Empfohlen",
    "withInviteTitle": "Ich habe einen Einladungscode",
    "withInviteDesc": "Deine Ernährungsberatung hat dir einen Code gegeben — trete der Praxis bei.",
    "orNoCode": "Oder",
    "soloTitle": "Die App alleine nutzen",
    "soloDesc": "Verfolge deinen Fortschritt selbst. Verknüpfe eine Beratung, wann du bereit bist.",
    "soloFeat1": "Gewicht, Maße und Ziele erfassen",
    "soloFeat2": "Tägliches Ernährungstagebuch",
    "soloFeat3": "WHOOP, Apple Health und andere Wearables verbinden",
    "startSolo": "Alleine starten",
    "canLinkLater": "Du kannst eine Beratung später im Profil verknüpfen.",
    "soloOk": "Willkommen! Du kannst mit dem Tracking beginnen."
  },
  "nav": {
    "dashboard": "Dashboard",
    "clients": "Nutzer",
    "appointments": "Termine",
    "myPlan": "Mein Plan",
    "weeklyMenu": "Wochenmenu",
    "diary": "Tagebuch",
    "progress": "Fortschritt",
    "profile": "Profil",
    "chat": "Chat",
    "recipes": "Rezepte",
    "workouts": "Training",
    "pantry": "Vorratskammer",
    "friends": "Freunde",
    "restaurant": "Im Restaurant",
    "plate": "Teller",
    "menu": "Menü",
    "openMenu": "Menü öffnen"
  },
  "plate": {
    "title": "Das Solano Essence Teller-Prinzip",
    "builder": {
      "title": "Baue deinen ausgewogenen Teller",
      "subtitle": "Stelle deine Mahlzeit zusammen – einfach und ohne Kalorienzählen.",
      "chooseVeg": "Wähle zuerst dein Gemüse.",
      "addProtein": "Sehr gut! Jetzt fehlt noch eine Proteinquelle.",
      "addCarbs": "Ergänze noch komplexe Kohlenhydrate.",
      "moreVeg": "Fast geschafft – noch etwas mehr Gemüse!",
      "balanced": "Dein Teller ist ausgewogen!",
      "fatsExtra": "kleines Extra",
      "actPhoto": "Teller fotografieren",
      "actPantry": "Aus der Vorratskammer",
      "actSuggest": "Gericht vorschlagen",
      "actSave": "Als Mahlzeit speichern",
      "actGenerate": "Rezept generieren",
      "genBusy": "Erstelle dein Rezept…",
      "genDone": "Rezept erstellt! Foto wird generiert…",
      "saved": "Mahlzeit gespeichert! Du findest sie im Tagebuch.",
      "reset": "Teller leeren",
      "ruleTip1": "Protein sättigt und schützt deine Muskeln – z.B. Poulet, Fisch, Eier, Tofu oder Hülsenfrüchte.",
      "ruleTip2": "Gemüse liefert Volumen, Vitamine und Ballaststoffe bei wenig Kalorien.",
      "ruleTip3": "Süssgetränke sind versteckte Kalorien – Wasser oder ungesüsster Tee sind die beste Wahl."
    },
    "check": {
      "btn": "Foto-Teller-Check",
      "busy": "Analysiere deinen Teller…",
      "hint": "Fotografiere deinen Teller – die KI prüft die 50/25/25-Verteilung.",
      "resultTitle": "Dein Teller-Check",
      "detected": "Erkannt",
      "missing": "Das fehlt noch",
      "fatsSeen": "Gesunde Fette erkannt",
      "noFood": "Kein Essen erkannt – bitte fotografiere deinen Teller.",
      "reward": "+15 Solano-Punkte für deinen ausgewogenen Teller!"
    },
    "subtitle": "Ausgewogene Mahlzeiten ohne jede Kalorie zu zählen",
    "intro": "Gesund essen muss nicht kompliziert sein. Mit dem Solano Essence Teller-Prinzip kannst du ausgewogene Mahlzeiten zusammenstellen — einfach nach den Proportionen auf deinem Teller, ohne Kalorien zu zählen.",
    "centerLabel": "Dein Teller",
    "ofYourPlate": "deines Tellers",
    "slice": {
      "veg": "Gemüse",
      "protein": "Protein",
      "carbs": "Komplexe Kohlenhydrate"
    },
    "items": {
      "veg": [
        "Salat",
        "Brokkoli",
        "Zucchini",
        "Paprika",
        "Tomaten",
        "Blumenkohl",
        "Saisongemüse",
        "Spinat",
        "Karotten",
        "Gurke",
        "Aubergine",
        "Kürbis",
        "Pilze",
        "Fenchel",
        "Rucola"
      ],
      "protein": [
        "Hähnchen",
        "Pute",
        "Fisch",
        "Eier",
        "Skyr",
        "Magerquark",
        "Tofu",
        "Hülsenfrüchte",
        "Lachs",
        "Thunfisch",
        "Garnelen",
        "Tempeh",
        "Hüttenkäse",
        "Mageres Rind"
      ],
      "carbs": [
        "Reis",
        "Vollkornnudeln",
        "Kartoffeln",
        "Haferflocken",
        "Quinoa",
        "Vollkornbrot",
        "Süsskartoffeln",
        "Bulgur",
        "Hirse",
        "Vollkorn-Couscous"
      ],
      "fats": [
        "Natives Olivenöl extra",
        "Avocado",
        "Nüsse",
        "Samen",
        "Mandeln",
        "Walnüsse",
        "Leinsamen",
        "Chiasamen"
      ]
    },
    "fats": {
      "title": "Gesunde Fette in Maßen",
      "subtitle": "Kein eigenes Tellersegment — füge sie in kleinen Mengen zu jeder Mahlzeit hinzu."
    },
    "rules": {
      "title": "Die 3 Solano Essence Regeln",
      "r1": "Baue in jede Mahlzeit eine Proteinquelle ein.",
      "r2": "Fülle die Hälfte deines Tellers mit Gemüse.",
      "r3": "Trinke hauptsächlich Wasser und begrenze zuckerhaltige Getränke."
    }
  },
  "plateCheck": {
    "title": "Solano-Teller",
    "tipPrefix": "Tipp:",
    "slice": {
      "veg": "Gemüse",
      "protein": "Protein",
      "carbs": "Kohlenh.",
      "fats": "Gesunde Fette"
    },
    "assigned": "Zuordnung",
    "extras": "Extras",
    "unknown": "Nicht erkannt",
    "notDetected": "nicht erkannt – bitte prüfen",
    "fatsMissing": "fehlen – z. B. Olivenöl, Avocado, Nüsse",
    "fatsHint": "Als Ergänzung zum Teller, nicht Teil der 50/25/25-Verteilung.",
    "satFatTitle": "Viel gesättigtes Fett heute:",
    "satFatHint": "kein Problem ab und zu – morgen gern öfter zu Olivenöl, Nüssen oder Fisch greifen.",
    "editAssign": "Anpassen",
    "verdict": {
      "excellent": "Perfektes 50/25/25 Verhältnis",
      "good": "Gut ausgewogen",
      "adjust": "Neu ausbalancieren"
    },
    "tip": {
      "more_veg": "füge mehr Gemüse hinzu — es sollte die halbe Tellerfläche ausmachen.",
      "more_protein": "ergänze eine Proteinquelle (Hähnchen, Fisch, Eier, Hülsenfrüchte).",
      "less_carbs": "reduziere die Kohlenhydrate leicht zugunsten von mehr Gemüse.",
      "less_protein": "Protein ist zu hoch — balanciere mit Gemüse und Vollkorn aus.",
      "rebalance": "verschiebe die Portionen näher an 50/25/25.",
      "add_fats": "ergänze eine gesunde Fettquelle: 1 EL Olivenöl, ½ Avocado oder eine Handvoll Nüsse.",
      "swap_fats": "tausche gesättigte Fette (Butter, Sahne, Wurst) teilweise gegen Olivenöl, Avocado oder Fisch."
    }
  },
  "plateHistory": {
    "title": "Teller-Verlauf",
    "subtitle": "Letzte {days} Tage",
    "average": "7-Tage-Ø",
    "empty": "Noch keine Daten",
    "dataDays": "{n} Tage mit Daten",
    "targetShort": "Ziel 50/25/25"
  },
  "plateToday": {
    "target": "Ziel",
    "tomorrow": "Morgen besser machen",
    "keepUp": "Weiter so — dein Teller war heute im Gleichgewicht!",
    "shareTitle": "Solano-Teller teilen",
    "storyKicker": "Mein Teller heute",
    "detailsLink": "Teller-Prinzip öffnen",
    "summary": {
      "excellent": "dein Teller war heute fast perfekt ausbalanciert.",
      "good": "dein Teller war heute gut — kleine Anpassungen lohnen sich.",
      "adjust": "Die Verteilung weicht vom Tellerprinzip ab. Prüfe bitte die erkannten Lebensmittel und Mengen."
    },
    "title": "Heutiger Teller",
    "plateOn": "Teller vom",
    "empty": "Kein Mittag- oder Abendessen erfasst",
    "emptyHint": "Der Solano-Teller misst nur Hauptmahlzeiten."
  },
  "workouts": {
    "last30": "Letzte 30 Tage",
    "title": "Training",
    "subtitle": "Cardio, Kraft und Dehnung erfassen",
    "newBtn": "Neues Training",
    "dialogTitle": "Training erfassen",
    "typeLabel": "Typ",
    "typeCardio": "Cardio",
    "typeStrength": "Krafttraining",
    "typeFlexibility": "Dehnen",
    "typeSport": "Sport",
    "typeOther": "Sonstiges",
    "nameLabel": "Name",
    "namePlaceholder": "z. B. Waldlauf, Push-Tag…",
    "dateLabel": "Datum",
    "durationLabel": "Dauer (Min)",
    "intensityLabel": "Intensität",
    "intensity_low": "Niedrig",
    "intensity_medium": "Mittel",
    "intensity_high": "Hoch",
    "kcalLabel": "Verbrannte kcal",
    "kcalAuto": "auto",
    "kcalHint": "Leer lassen für Schätzung nach Gewicht & Intensität.",
    "exercisesLabel": "Übungen",
    "addExercise": "Übung hinzufügen",
    "addSet": "Satz hinzufügen",
    "exercisePh": "z. B. Bankdrücken, Kniebeuge…",
    "reps": "Wdh",
    "notesLabel": "Notizen",
    "notesPh": "Wie war das Training?",
    "save": "Speichern",
    "saved": "Training gespeichert",
    "needName": "Bitte einen Namen angeben",
    "deleted": "Training gelöscht",
    "confirmDelete": "Dieses Training löschen?",
    "planned": "Geplant",
    "emptyState": "Noch keine Trainings. Erfasse dein erstes!",
    "weekCount": "7-Tg Sessions",
    "weekMin": "7-Tg Minuten",
    "weekKcal": "7-Tg kcal",
    "workout": "Workout",
    "workoutsShort": "Workouts",
    "markDone": "Habe trainiert",
    "markSkip": "Nicht trainiert",
    "markSkipOk": "Notiert – kein Training an diesem Tag",
    "markSkipError": "Konnte nicht speichern, erneut versuchen?",
    "markRestDay": "Ruhetag",
    "planTrainingCta": "Training planen",
    "addAnotherCta": "Weiteres Training hinzufügen",
    "dayIsRestDay": "Ruhetag",
    "dayIsPlanned": "Geplantes Training heute",
    "dayIsPlannedFuture": "Geplanter Trainingstag",
    "dayIsFuture": "Zukünftiger Tag",
    "dayIsFree": "Freier Tag",
    "unskipCta": "Doch trainiert?",
    "unskipOk": "Ruhetag entfernt",
    "changeReasonCta": "Grund ändern",
    "pickReasonTitle": "Was ist heute los?",
    "reasonRestDay": "Ruhetag",
    "reasonSick": "Krank",
    "reasonNoTime": "Keine Zeit",
    "reasonPain": "Schmerzen",
    "reasonOther": "Sonstiges",
    "skipNoReason": "Ohne Grund",
    "skipNoReasonCta": "Ohne Grund speichern",
    "calLegendSkip": "Ruhetag",
    "calLegendRecovery": "Recovery",
    "dayIsRecovery": "Bewusster Ruhetag",
    "recoveryQuote": "Regeneration gehört zum Fortschritt. Dein Körper wird in den Pausen stärker.",
    "recoveryDoneTitle": "Regeneration ist Fortschritt",
    "recoveryStreakStrip": "Recovery Streak: {n} Woche",
    "recoveryNextBadge": "Nächste Stufe",
    "recoveryWeeksUnit": "Wochen",
    "badge_recovery_starter": "🌿 Recovery Starter",
    "badge_recovery_balance": "🌙 Recovery Balance",
    "badge_regeneration_pro": "🧘 Regenerations-Profi",
    "trainingPlanTag": "Mein Trainingsplan",
    "trainingPlanEmpty": "Noch keine Trainingstage",
    "trainingPlanQ": "An welchen Tagen trainierst du normalerweise?",
    "trainingPlanHint": "Nicht ausgewählte Tage werden nicht automatisch als Ruhetage gewertet.",
    "trainingPlanApply": "Übernehmen",
    "trainingPlanSaved": "Trainingsplan gespeichert",
    "trainingPlanTypeTitle": "Trainingsart pro Tag",
    "skipNudgeTag": "Alles im grünen Bereich",
    "skipNudgeTitle": "{n} freie Tage in Folge – Woche neu planen?",
    "skipNudgeBody": "Kein Stress. Wähl' einfach andere Tage, die besser in deine Woche passen. Wir bleiben an deiner Seite.",
    "skipNudgeCta": "Trainingstage anpassen",
    "skipNudgeLater": "Vielleicht später",
    "calLegendDone": "Workout",
    "calLegendToday": "Heute",
    "calLegendSelected": "Ausgewählt",
    "calLegendPlanned": "Geplant",
    "todayCount": "heute",
    "kcalEstimatedTip": "Geschätzte kcal (Gewicht & MET)",
    "totalSets": "Sätze gesamt",
    "totalVolume": "Gesamtvolumen",
    "noExtraDetails": "Keine weiteren Details.",
    "settingKcalInBudgetLabel": "Standard für neue Tage: verbrannte kcal ins Budget einrechnen",
    "settingKcalInBudgetHelp": "z. B. 2000 kcal + 300 verbrannt = 2300 verfügbar. Auf dem Dashboard kannst du es für jeden Tag einzeln umschalten.",
    "kcalBudgetShort": "Kcal-Budget mit Workout",
    "kcalBudgetOn": "Workout-kcal jetzt im Tagesbudget",
    "kcalBudgetOff": "Workout-kcal separat vom Budget",
    "wearableReadOnly": "Vom Wearable synchronisiert — hier nicht bearbeitbar"
  },
  "workoutPhoto": {
    "openBtn": "Aus Foto",
    "title": "Aus Foto hinzufügen",
    "subtitle": "Screenshot der Trainings-Zusammenfassung (Speediance, Apple Fitness, Garmin…) aufnehmen. KI erkennt Dauer, kcal und Typ.",
    "pickPhoto": "Foto aufnehmen oder wählen",
    "hint": "Zusammenfassungs-Screens funktionieren am besten",
    "batchHint": "Mehrere Fotos gleichzeitig wählen (bis zu einer ganzen Woche)",
    "analyzing": "Analyse läuft…",
    "analyzingBatch": "Analyse {done}/{total}…",
    "notRecognized": "Kein Foto ist eine Trainings-Zusammenfassung.",
    "itemNotRecognized": "Nicht erkannt",
    "extracted": "Erkannt — bitte prüfen vor dem Speichern",
    "extractedBatch": "{ok} Trainings erkannt · {err} nicht erkannt",
    "name": "Name",
    "type": "Typ",
    "date": "Datum",
    "dateAutoTooltip": "Datum automatisch aus dem Bild erkannt",
    "duration": "Dauer (Min)",
    "durationShort": "Min",
    "kcal": "Kcal",
    "intensity": "Intensität",
    "notes": "Notizen",
    "low": "Niedrig",
    "medium": "Mittel",
    "high": "Hoch",
    "types": {
      "strength": "Krafttraining",
      "cardio": "Cardio",
      "flexibility": "Dehnen",
      "sport": "Sport",
      "other": "Sonstiges"
    },
    "retake": "Neu aufnehmen",
    "save": "Training speichern",
    "saveAll": "Alle speichern ({n})",
    "savedToast": "Training aus Foto gespeichert",
    "batchSavedToast": "{n} Trainings aus Fotos gespeichert",
    "batchFailedToast": "{n} Trainings nicht gespeichert"
  },
  "nutDash": {
    "hello": "Hallo,",
    "subtitle": "Hier ist ein Überblick deiner Praxis.",
    "appStatsTag": "App-Owner",
    "appStatsTitle": "App-Statistiken",
    "appStatsSub": "Alle Aktivitäten in der App auf einen Blick",
    "inviteCodeTag": "Praxis-Einladungscode",
    "inviteShare": "Teile ihn mit neuen Nutzer, um sie zu verknüpfen.",
    "copyCode": "Code kopieren",
    "copied": "Kopiert!",
    "shareCode": "Teilen",
    "shareMessage": "Hallo! Um dich in der Solano Essence App mit mir zu verbinden, nutze diesen Einladungscode:",
    "activeClients": "Aktive Nutzer",
    "totalClients": "Nutzer gesamt",
    "subtitleToday": "Hier ist dein Überblick für heute.",
    "todayImportant": "Heute wichtig",
    "todayImportantEmpty": "Alles im grünen Bereich. Nichts zu tun.",
    "inviteTitle": "Nutzer einladen",
    "alertNeverActive": "Noch nie aktiv",
    "alertInactiveSince": "Seit",
    "alertDays": "Tagen inaktiv",
    "alertFading": "Aktivität lässt nach",
    "alertContact": "Kontaktieren",
    "alertOpen": "Ansehen",
    "alertNewLogs": "Neue Tagebucheinträge",
    "alertLogOne": "Eintrag heute",
    "alertLogMany": "Einträge heute",
    "alertOpenFeed": "Zum Feed",
    "alertDaysShort": "Tage",
    "alertKcalOverfix": "(Ziel überschritten)",
    "alertProteinTarget": "Proteinziel",
    "pendingRequests": "Offene Anfragen",
    "recentClients": "Neueste Nutzer",
    "seeAll": "Alle",
    "noClients": "Noch keine Nutzer",
    "noClientsDesc": "Teile den Einladungscode, um zu starten.",
    "thresholdsTag": "Einstellungen",
    "thresholdsTitle": "Alert-Schwellwerte anpassen",
    "thresholdsKcalOver": "Alert bei kcal über Ziel",
    "thresholdsKcalOverHint": "Benachrichtigen, wenn der Nutzer das kcal-Ziel mindestens N Tage überschreitet",
    "thresholdsProteinLow": "Alert bei Protein unter Ziel",
    "thresholdsProteinLowHint": "Benachrichtigen, wenn der Nutzer mindestens N Tage unter dem Proteinziel bleibt",
    "thresholdsDays": "Tage",
    "thresholdsThreshold": "Schwelle %",
    "thresholdsSave": "Speichern",
    "upcomingAppts": "Nächste Termine",
    "noAppts": "Keine Termine",
    "noApptsDesc": "Bestätigte Buchungen erscheinen hier.",
    "open": "Öffnen",
    "goalToDefine": "Ziel offen"
  },
  "clientsList": {
    "filterAll": "Alle",
    "filterAction": "Handlungsbedarf",
    "filterCheckin": "Check-in fällig",
    "filterNew": "Neue Nutzer",
    "msg": "Nachricht",
    "more": "Mehr",
    "adherence": "Einhaltung",
    "noGoal": "Kein Ziel",
    "empty": "Keine Nutzer",
    "title": "Nutzer",
    "subtitle": "Verwalte deine Nutzer und ihre Pläne.",
    "searchPh": "Nutzer suchen…",
    "emptyDesc": "Teile deinen Einladungscode aus dem Dashboard, um Nutzer hinzuzufügen.",
    "newBadge": "Neu",
    "statusGreen": "Läuft",
    "statusAmber": "Aufmerksamkeit",
    "statusRed": "Dringend"
  },
  "lastEntry": "Letzter Eintrag",
  "mWeight": "Gewicht",
  "mScore": "Score",
  "mAdherence": "Einhaltung",
  "mStatus": "Status",
  "ctaMessage": "Nachricht",
  "ctaCoachAi": "KI-Coach",
  "ctaPlan": "Plan bearbeiten",
  "attentionTitle": "Aufmerksamkeit",
  "checkinTitle": "Coach-Betreuung & Check-in",
  "lastCheckin": "Letzter Check-in",
  "nextCheckin": "Nächster Check-in",
  "cadence": "Kadenz",
  "cadWeekly": "Wöchentlich",
  "cadBiweekly": "Alle 2 Wochen",
  "cadMonthly": "Monatlich",
  "lastNote": "Letzte Notiz",
  "addNote": "Notiz hinzufügen",
  "notePh": "Was ist gut gelaufen? Was fehlt noch?",
  "completeCheckin": "Check-in abschließen",
  "checkinDone": "Check-in gespeichert",
  "cadenceSaved": "Kadenz aktualisiert",
  "betaInvites": {
    "title": "Beta-Einladungen",
    "subtitle": "Einweg-Codes, um deine Nutzer einzuladen",
    "active": "aktiv",
    "newInvite": "Neue Einladung",
    "labelPh": "Name des Nutzers (optional)",
    "emailPh": "E-Mail des Nutzers (optional)",
    "emailHint": "Füge die E-Mail hinzu, damit nur dieser Nutzer den Code einlösen kann.",
    "generate": "Erstellen",
    "created": "Code erstellt",
    "empty": "Noch keine Einladungen. Erstelle oben deine erste.",
    "usedBy": "verwendet von",
    "copyCode": "Code kopieren",
    "shareLink": "Link teilen",
    "revoke": "Widerrufen",
    "linkCopied": "Link kopiert",
    "shareText": "Hallo {name}! Hier ist deine Einladung zu Solano Essence:",
    "waTemplate": "Hallo {name}! 👋\n\nWillkommen bei Solano Essence — deiner personalisierten Ernährungs-App.\n\nRegistriere dich hier mit deinem Einladungscode:\n{url}\n\nFalls die Anmeldung den Code manuell verlangt, nutze den aus dem Link.\n\nBis bald! 🥗",
    "sendWhatsApp": "Per WhatsApp senden",
    "showQr": "QR-Code anzeigen",
    "qrTag": "QR-Code",
    "qrTitle": "Nutzer einladen",
    "qrHint": "Lass deinen Nutzer scannen — die Anmeldung öffnet sich mit dem Code bereits eingetragen.",
    "defaultName": "Nutzer",
    "status": {
      "active": "Aktiv",
      "used": "Benutzt",
      "revoked": "Widerrufen"
    }
  },
  "nutJournal": {
    "title": "Tagebuch des Nutzers",
    "lastNDays": "Letzte {n} Tage",
    "empty": "Der Nutzer hat noch keine Tagebucheinträge geschrieben.",
    "noContent": "Keine Notiz — nur Antworten.",
    "replyPlaceholder": "Antwort an den Nutzer schreiben…",
    "replySent": "Antwort gesendet"
  },
  "providerPrefs": {
    "title": "Datenpräferenzen",
    "subtitle": "Wähle, welches Gerät für welche Metrik verwendet werden soll",
    "noDevices": "Verbinde erst ein Gerät, um Präferenzen zu setzen",
    "auto": "Automatisch (max)",
    "saved": "Präferenzen gespeichert",
    "resetBtn": "Daten zurücksetzen",
    "resetConfirm": "Wearable-Daten der letzten 7 Tage löschen? Beim nächsten Sync werden sie neu geladen.",
    "resetDone": "{n} Tage gelöscht. Jetzt auf Synchronisieren tippen.",
    "metric": {
      "sleep": "Schlaf",
      "sleepHint": "Wird auf der SCHLAF-Karte angezeigt",
      "steps": "Schritte",
      "stepsHint": "Tägliche Schrittzahl",
      "hrv": "HRV",
      "hrvHint": "Herzratenvariabilität (ms)",
      "resting_hr": "Ruhepuls",
      "resting_hrHint": "Ruheherzfrequenz (bpm)"
    }
  },
  "clientDetail": {
    "heroSection": "Kennzahlen & KI-Coach",
    "tabOverview": "Übersicht",
    "tabNutrition": "Ernährung",
    "tabProgress": "Fortschritt",
    "tabProfile": "Profil",
    "tapForDetails": "Für Details tippen",
    "hasComment": "Kommentar vorhanden",
    "noLogsForBadge": "Keine Einträge",
    "lastEntry": "Letzter Eintrag",
    "mWeight": "Gewicht",
    "mScore": "Score",
    "mAdherence": "Einhaltung",
    "mStatus": "Status",
    "ctaMessage": "Nachricht",
    "ctaCoachAi": "KI-Coach",
    "ctaPlan": "Plan bearbeiten",
    "attentionTitle": "Aufmerksamkeit",
    "checkinTitle": "Coach-Betreuung & Check-in",
    "lastCheckin": "Letzter Check-in",
    "nextCheckin": "Naechster Check-in",
    "cadence": "Kadenz",
    "cadWeekly": "Woechentlich",
    "cadBiweekly": "Alle 2 Wochen",
    "cadMonthly": "Monatlich",
    "lastNote": "Letzte Notiz",
    "addNote": "Notiz hinzufuegen",
    "notePh": "Was ist gut gelaufen? Was fehlt noch?",
    "completeCheckin": "Check-in abschliessen",
    "checkinDone": "Check-in gespeichert",
    "cadenceSaved": "Kadenz aktualisiert",
    "tileAdherence": "Einhaltung",
    "tileAdherenceSub": "14 Tage",
    "tileJournal": "Tagebuch",
    "tileJournalSub": "30 Tage",
    "tileProfile": "Profil",
    "tileProfileSub": "Ziel, Alter, Größe",
    "tileTrends": "Trends",
    "tileTrendsSub": "Gewicht & Einhaltung",
    "tileWearable": "Wearable",
    "tileWearableSub": "HRV, Schlaf, Schritte",
    "tileDiary": "Ernährungstagebuch",
    "tileDiarySub": "Mahlzeiten & Kommentare",
    "profile": "Profil",
    "goal": "Ziel",
    "activity": "Aktivität",
    "sport": "Sport",
    "height": "Größe",
    "startingWeight": "Startgewicht",
    "kcalTarget": "Kcal-Ziel",
    "allergies": "Allergien",
    "weightTrend": "Gewichtsverlauf",
    "needMoreWeights": "Nutzer hat noch nicht genug Gewichte eingetragen.",
    "currentPlan": "Aktueller Plan",
    "noPlan": "Kein Plan zugewiesen.",
    "planTargetsTitle": "Plan-Ziele",
    "avgIntakeTitle": "Durchschn. Verzehr (letzte 7 Tage)",
    "avgIntakeEmpty": "In den letzten 7 Tagen keine Mahlzeiten eingetragen.",
    "microsTitle": "Durchschn. Mikronährstoffe",
    "dailyAverage": "Tagesdurchschnitt",
    "recentLogs": "Ernährungstagebuch des Nutzers",
    "noLogs": "Noch keine Logs.",
    "noLogsForDay": "Keine Einträge für diesen Tag.",
    "jumpToDay": "Zum Tag springen",
    "today": "Heute",
    "yesterday": "Gestern",
    "quickNotes": "Schnellnotizen",
    "clientReplyLabel": "Antwort des Nutzers",
    "qn_great": "Super Mahlzeit",
    "qn_portion": "Achte auf die Portion",
    "qn_veggies": "Mehr Gemüse",
    "qn_protein": "Mehr Eiweiß",
    "qn_water": "Mehr Wasser trinken",
    "qn_carbs": "Weniger Kohlenhydrate",
    "qn_timing": "Essenszeiten überprüfen",
    "qn_sugar": "Achte auf Zucker",
    "commentTitle": "Mahlzeit kommentieren",
    "commentLabel": "Dein Kommentar (für den Nutzer sichtbar)",
    "commentPlaceholder": "Kurzes Feedback an den Nutzer…",
    "commentSaved": "Kommentar an den Nutzer gesendet",
    "commentCleared": "Kommentar entfernt",
    "createPlan": "Plan erstellen",
    "updatePlan": "Plan aktualisieren",
    "weeklyPreview": "Wochen-PDF",
    "weeklySend": "Jetzt senden",
    "weeklyLoading": "PDF wird erstellt…",
    "weeklySending": "Sende…",
    "weeklySent": "Report per E-Mail verschickt",
    "backClients": "Nutzer",
    "monthlyReport": "Monatsbericht",
    "printPdf": "Drucken / PDF",
    "period": "Zeitraum",
    "client": "Nutzer",
    "startWeight": "Startgewicht",
    "endWeight": "Endgewicht",
    "delta": "Delta",
    "diaryDays": "Tagebuch-Tage",
    "avgKcalDay": "Ø Kcal/Tag",
    "avgWaterDay": "Ø Wasser/Tag",
    "glasses": "Glas",
    "avgSleep": "Ø Schlaf",
    "avgHrv": "Ø HRV",
    "progressPhotosTitle": "Fortschrittsfotos",
    "reportFooter": "Gesamt Mahlzeiten: {meals} · Fortschrittsfotos: {photos} · Ø Ruhepuls: {rhr}"
  },
  "builder": {
    "title": "Ernährungsplan-Builder",
    "for": "Für",
    "aiTitle": "KI-Generator (GPT-5.2)",
    "aiDesc": "Fülle den Plan auf Basis des Nutzerprofils vor. Danach frei bearbeiten.",
    "caloriesTarget": "Ziel-Kalorien",
    "preferences": "Vorlieben / Notizen",
    "preferencesPh": "z.B. laktosefrei, viel Fisch, süßes Frühstück",
    "generate": "Mit KI generieren",
    "generating": "Generiere…",
    "titleField": "Titel",
    "clientNotes": "Notizen für den Nutzer",
    "addMeal": "Mahlzeit hinzufügen",
    "addDay": "Tag hinzufügen (z.B. Training)",
    "savePlan": "Plan speichern",
    "mealName": "Mahlzeit",
    "mealTime": "Uhrzeit",
    "mealDesc": "Beschreibung (Lebensmittel, Menge)",
    "generatedOk": "Plan mit KI generiert. Du kannst ihn bearbeiten und speichern.",
    "savedOk": "Plan gespeichert und dem Nutzer zugewiesen",
    "defaultDayLabel": "Typischer Tag",
    "trainingDayLabel": "Trainingstag",
    "dayTypeGeneric": "allgemein",
    "dayTypeTraining": "training",
    "dayTypeRest": "ruhetag",
    "aiErrorPrefix": "KI-Fehler"
  },
  "apptsNut": {
    "title": "Termine",
    "subtitle": "Verwalte Terminanfragen deiner Nutzer.",
    "pendingSection": "Offene Anfragen",
    "confirmedSection": "Bestätigt",
    "archiveSection": "Archiv",
    "markDone": "Als erledigt markieren",
    "empty": "Nichts hier",
    "confirmed": "Bestätigt",
    "cancelled": "Abgesagt",
    "updated": "Aktualisiert"
  },
  "shop": {
    "unknown": {
      "title": "Produkt unbekannt – hilf Solano, es kennenzulernen",
      "subtitle": "Fotografiere die Nährwert-Tabelle. Die KI liest die Werte, du bestätigst – und beim nächsten Scan erkennt Solano das Produkt sofort.",
      "photoLabel": "Nährwert-Tabelle fotografieren",
      "analyzing": "KI liest die Tabelle …",
      "manual": "Lieber manuell eingeben",
      "analyzeFailed": "Tabelle nicht lesbar – bitte nochmals fotografieren oder manuell eingeben.",
      "aiRead": "Von der KI gelesen – bitte kurz prüfen",
      "name": "Produktname",
      "brand": "Marke",
      "serving": "Portion (z. B. 30 g)",
      "ingredients": "Zutaten (optional, für den Mediterran-Bonus)",
      "save": "Speichern & bewerten",
      "saved": "Produkt gespeichert – danke!",
      "nameRequired": "Bitte einen Produktnamen eingeben.",
      "shared": "Angelernte Produkte stehen allen Solano-Nutzern zur Verfügung.",
      "f": {
        "kcal": "kcal",
        "protein": "Protein g",
        "carbs": "KH g",
        "sugar": "Zucker g",
        "fat": "Fett g",
        "satfat": "ges. Fett g",
        "fiber": "Ballastst. g",
        "salt": "Salz g"
      }
    },
    "logToDiary": "Ins Tagebuch",
    "perServing": "Werte pro Portion ({s})",
    "show100": "pro 100 g zeigen",
    "showServing": "pro Portion zeigen",
    "clearConfirm": "Verlauf wirklich leeren?",
    "yes": "Ja",
    "no": "Nein",
    "disclaimer": "Der Solano-Score ist eine Orientierung und ersetzt keine Ernährungs- oder medizinische Beratung.",
    "info": {
      "scores": "Nutri-Score: offizielle Bewertung des Produkts (A–E). Solano-Score: unsere Bewertung 0–100, passend zu deinem Ziel.",
      "thresholds": "Stufen: ab 70 „Kaufen“ · 40–69 „Ok in Massen“ · unter 40 „Lieber nicht“.",
      "how": "So entsteht der Score: Basis aus dem Nutri-Score, dann Plus/Minus für Zucker, gesättigtes Fett, Salz, Ballaststoffe, Protein, Verarbeitungsgrad, Zusatzstoffe und mediterrane Zutaten – gewichtet nach deinem Ziel."
    },
    "med": {
      "med_good_ingredients": "Passt zur mediterranen Ernährung: gute Zutaten",
      "med_good_natural": "Passt zur mediterranen Ernährung: wenig verarbeitet",
      "med_neutral": "Mediterran neutral – in Massen ok",
      "med_poor_processed": "Eher nicht mediterran: stark verarbeitet",
      "med_poor_sugar": "Eher nicht mediterran: viel Zucker bzw. Süssstoffe"
    },
    "altTip": {
      "food": "Coach-Tipp: Greif zu unverarbeiteten Basics – Naturjoghurt, Skyr, Nüsse, Obst oder Vollkorn schlagen jedes Fertigprodukt.",
      "beverage": "Coach-Tipp: Wasser, ungesüsster Tee oder Kaffee – mit Zitrone oder Minze, wenn du Geschmack willst."
    },
    "addToList": "Auf die Einkaufsliste",
    "onList": "Auf der Liste",
    "addedToList": "Auf die Einkaufsliste gesetzt",
    "alreadyOnList": "Steht schon auf deiner Einkaufsliste",
    "listTicked": "Abgehakt und in den Vorrat gelegt: {name}",
    "listTickedTitle": "Von der Einkaufsliste abgehakt – liegt jetzt im Vorrat",
    "verifiedSeal": "Von Solano geprüft",
    "verifiedHint": "Die Nährwerte dieses Produkts wurden vom Solano-Team kontrolliert.",
    "miniList": {
      "title": "Deine Einkaufsliste",
      "open": "{n} offen",
      "more": "+{n} weitere"
    },
    "openList": "Liste öffnen",
    "per100g": "Werte pro 100 g",
    "per100ml": "Getränk – Werte pro 100 ml",
    "stats": {
      "title": "Deine Einkaufs-Bilanz",
      "smartRate": "So oft hast du in den letzten {days} Tagen „Kaufen“ statt „Lieber nicht“ gewählt",
      "summary": "{total} Scans · Ø Score {avg}"
    },
    "altTitle": "Bessere Alternative",
    "altLoading": "Suche eine gesündere Alternative …",
    "altTap": "Antippen für Details",
    "title": "Einkaufs-Check",
    "subtitle": "Produkt im Laden scannen – Solano sagt dir, ob es in den Korb darf.",
    "hint": "Strichcode (EAN) in den Rahmen halten",
    "enterManually": "Code manuell eingeben",
    "checking": "Produkt wird geprüft …",
    "notFound": "Produkt nicht gefunden – versuch einen anderen Code.",
    "error": "Prüfung fehlgeschlagen. Bitte erneut versuchen.",
    "solanoScore": "Solano-Score",
    "verdict": {
      "buy": "Kaufen",
      "moderate": "Ok in Massen",
      "avoid": "Lieber nicht"
    },
    "goal": {
      "lose": "Gewichtet für dein Ziel: Abnehmen",
      "gain": "Gewichtet für dein Ziel: Muskelaufbau",
      "maintain": "Ausgewogen bewertet"
    },
    "reason": {
      "sugar_high": "Sehr viel Zucker: {v} g/100 g",
      "sugar_mid": "Viel Zucker: {v} g/100 g",
      "sugar_low": "Wenig Zucker: {v} g/100 g",
      "satfat_high": "Viel gesättigtes Fett: {v} g/100 g",
      "satfat_mid": "Etwas gesättigtes Fett: {v} g/100 g",
      "salt_high": "Viel Salz: {v} g/100 g",
      "salt_mid": "Etwas Salz: {v} g/100 g",
      "fiber_high": "Reich an Ballaststoffen: {v} g/100 g",
      "fiber_mid": "Gute Ballaststoffe: {v} g/100 g",
      "protein_high": "Proteinreich: {v} g/100 g",
      "protein_mid": "Gute Proteinquelle: {v} g/100 g",
      "kcal_high": "Kaloriendicht: {v} kcal/100 g",
      "nova_4": "Hochverarbeitet (NOVA 4)",
      "nova_3": "Verarbeitet (NOVA 3)",
      "nova_1": "Unverarbeitet (NOVA 1)",
      "additives": "{v} Zusatzstoffe",
      "med_olive": "Mediterran: Olivenöl / Oliven",
      "med_nuts": "Mediterran: Nüsse / Mandeln",
      "med_wholegrain": "Mediterran: Vollkorn",
      "med_legumes": "Mediterran: Hülsenfrüchte",
      "med_fish": "Mediterran: Fisch",
      "palm_oil": "Enthält Palmöl",
      "few_ingredients": "Kurze Zutatenliste – wenig verarbeitet",
      "bev_water": "Wasser – die beste Wahl",
      "bev_unsweetened": "Ungesüsst, praktisch kalorienfrei",
      "bev_sugar_high": "Süssgetränk: {v} g Zucker/100 ml",
      "bev_sugar_mid": "Viel Zucker: {v} g/100 ml",
      "bev_sugar_some": "Etwas Zucker: {v} g/100 ml",
      "bev_sugar_low": "Wenig Zucker: {v} g/100 ml",
      "bev_kcal_high": "Flüssige Kalorien: {v} kcal/100 ml",
      "sweeteners": "Enthält Süssstoffe",
      "fruit_juice": "100 % Fruchtsaft (natürlicher Zucker)",
      "alcohol": "Alkoholisches Getränk"
    },
    "coach": "Coach",
    "coachThinking": "Dein Coach schaut sich das an …",
    "coachUnavailable": "Coach-Kommentar gerade nicht verfügbar.",
    "n": {
      "kcal": "kcal",
      "protein": "Protein",
      "sugar": "Zucker",
      "salt": "Salz"
    },
    "next": "Nächstes scannen",
    "logAnyway": "Trotzdem loggen",
    "history": "Zuletzt gescannt",
    "clear": "Leeren",
    "emptyHistory": "Deine gescannten Produkte erscheinen hier zum Vergleichen.",
    "cameraStarting": "Kamera startet …",
    "retry": "Erneut",
    "fromPhoto": "Aus Foto",
    "err": {
      "permission": "Kamera-Zugriff verweigert. Erlaube den Zugriff in den Einstellungen oder nutze ein Foto.",
      "nodevice": "Keine Kamera gefunden.",
      "generic": "Kamera konnte nicht gestartet werden.",
      "notfound": "Kein Strichcode im Foto erkannt."
    }
  },
  "quickTrack": {
    "title": "Schnell tracken",
    "qrScan": "QR-Rezept scannen",
    "addMeal": "Mahlzeit hinzufügen",
    "photo": "KI-Foto",
    "voice": "Stimme",
    "barcode": "EAN Scanner",
    "shop": "Einkaufs-Check",
    "fridge": "Aus dem Kühlschrank",
    "search": "Lebensmittel suchen",
    "manual": "Manuell eingeben"
  },
  "cliDash": {
    "weightSaved": "Gewicht gespeichert",
    "hi": "Hallo,",
    "waterUndo": "Rückgängig",
    "waterCustom": "Custom",
    "waterCustomPh": "z. B. 330",
    "waterSettings": "Wasser-Einstellungen",
    "waterTargetLabel": "Tagesziel (Liter)",
    "foodWater": "+ Wasser aus Lebensmitteln: ~{ml} ml",
    "waterContainers": "Deine Trinkgefässe",
    "waterAddContainer": "+ Gefäss",
    "waterContainerNamePh": "Name (z. B. Flasche)",
    "checkinTitle": "Tages-Check-in",
    "checkinOutTitle": "Check-in / Check-out",
    "checkinSection": "Check-in · Morgen",
    "checkoutSection": "Check-out · Abend",
    "checkoutMoodQ": "Wie endet dein Tag?",
    "checkoutSave": "Check-out abschliessen",
    "checkoutSaved": "Check-out gespeichert ✓",
    "checkinMoodQ": "Wie war dein Tag?",
    "checkinEnergyQ": "Wie ist deine Energie?",
    "checkinNotePh": "Optionale Notiz …",
    "checkinSave": "Check-in abschliessen",
    "checkinSaved": "Tages-Check-in gespeichert ✓",
    "checkinDone": "Erledigt",
    "of": "von",
    "kcalBurnedShort": "Verbrannt",
    "changePhoto": "Foto ändern",
    "removePhoto": "Foto entfernen",
    "avatarUpdated": "Profilbild aktualisiert",
    "avatarRemoved": "Profilbild entfernt",
    "avatarFrame": "Rahmen",
    "avatarFrameUpdated": "Rahmen aktualisiert",
    "avatarZoom": "Zoom",
    "editAvatar": "Foto zentrieren",
    "journey": "Deine Reise beginnt hier.",
    "currentWeight": "Aktuelles Gewicht",
    "logWeightLabel": "Gewicht eintragen (kg)",
    "logWeightBtn": "Speichern",
    "weightLogged": "Gewicht gespeichert",
    "sinceStart": "seit Start",
    "nextAppt": "Nächster Termin",
    "noneProgrammed": "Nichts geplant.",
    "book": "Buchen",
    "yourPlan": "Dein Plan",
    "seeDetail": "Details →",
    "noPlanAssigned": "Deine Ernährungsberatung hat noch keinen Plan zugewiesen.",
    "otherMeals": "weitere Mahlzeiten",
    "goals": "Deine Ziele",
    "today": "Heute",
    "yesterday": "Gestern",
    "tomorrow": "Morgen",
    "calories": "Kalorien",
    "kcalLeft": "übrig",
    "kcalOver": "zu viel",
    "kcalTooLow": "zu wenig",
    "kcalBurned": "kcal Alltagsaktivität",
    "aiQuotaLeft": "Noch {n} von {total} Gratis-KI-Aktionen diesen Monat",
    "aiQuotaTitle": "Gratis-Foto-Analysen",
    "aiQuotaUsed": "{used} von {total} verbraucht",
    "aiQuotaLeftShort": "Noch {n} frei diesen Monat",
    "aiQuotaNoneLeft": "Alle aufgebraucht — ab nächstem Monat wieder frei",
    "aiQuotaPro": "Unbegrenzt mit Pro",
    "kcalInfoTitle": "Wie werden die kcal berechnet?",
    "kcalInfoTotalHint": "Alltagsbewegung heute (Apple Health Gesamtverbrauch minus Workout-kcal) — ohne Training.",
    "kcalInfoWorkoutHint": "zusätzlich aus deinen geloggten Workouts (WHOOP + manuell, ±5 min dedupliziert).",
    "kcalInfoFallback": "Ohne Apple Health-Sync wird die Alltagsaktivität aus deinen Schritten geschätzt (~0,04 kcal pro Schritt).",
    "kcalConsumed": "gegessen",
    "kcalTarget": "Ziel",
    "workoutBonus": "workout",
    "nextMealSuggest": "Nächste: {meal} ~{kcal} kcal",
    "nextMealDone": "Super gemacht heute!",
    "steps": "Schritte",
    "hydration": "Wasser",
    "goal": "Ziel",
    "setKcalTarget": "Kcal-Ziel setzen",
    "editKcalTitle": "Tägliches Kalorienziel",
    "editKcalHint": "Lege fest, wie viele Kalorien du pro Tag zu dir nehmen möchtest.",
    "saveTarget": "Ziel speichern",
    "planCtaTitle": "Tagesziele & Makro-Verteilung",
    "planCtaHint": "Presets (Ausgewogen, Low Carb, High Protein) und alle Ziele selbst festlegen",
    "targetSaved": "Ziel aktualisiert",
    "kcalRange": "Wert zwischen 500 und 6000 eingeben",
    "macros": "Makros",
    "carbs": "Kohlenhydrate",
    "protein": "Eiweiß",
    "fat": "Fett",
    "sugar": "Zucker",
    "fiber": "Ballaststoffe",
    "satFat": "Gesättigte Fettsäuren",
    "salt": "Salz",
    "microsInfo": "Zucker (max 50g WHO), Ballaststoffe (30g/Tag), Gesättigte Fette (max 10% kcal), Salz (max 5g WHO)",
    "showDetails": "Zucker · Ballaststoffe · Salz anzeigen",
    "hideDetails": "Details ausblenden",
    "mealsToday": "Mahlzeiten heute",
    "tapToAddMeal": "Tippe + für eine neue Mahlzeit",
    "mealEmpty": "Keine Mahlzeit eingetragen",
    "oneMeal": "1 Zutat",
    "manyMeals": "Zutaten",
    "addMeal": "Mahlzeit hinzufügen",
    "aiScan": "Mit KI scannen",
    "openDiary": "Tagebuch öffnen",
    "openPlan": "Plan ansehen",
    "activities": "Aktivitäten",
    "connectDevice": "Gerät verbinden",
    "noPlanShort": "Noch kein Plan"
  },
  "myPlan": {
    "title": "Mein Plan",
    "subtitle": "Der personalisierte Ernährungsplan deines Beraters.",
    "empty": "Kein Plan zugewiesen",
    "emptyDesc": "Dein Berater weist ihn dir bald zu.",
    "notLinkedTitle": "Mit deiner Ernährungsberatung verbinden",
    "notLinkedDesc": "Gib den Einladungscode ein, den dir dein Berater gegeben hat, um deinen persönlichen Plan zu erhalten.",
    "notLinkedHint": "Der Code hat 6 Zeichen (z.B. ABC123). Wenn du ihn nicht hast, frag deinen Berater.",
    "translateBtn": "Auf Deutsch übersetzen",
    "translateOriginal": "Original anzeigen",
    "translating": "Übersetze…",
    "translatedBadge": "Übersetzt",
    "translateError": "Übersetzung fehlgeschlagen"
  },
  "feed": {
    "title": "Nutzer-Feed",
    "subtitle": "Alle Aktivitäten deiner Nutzer in chronologischer Reihenfolge. Tippe auf eine Karte, um den Nutzer zu öffnen.",
    "emptyTitle": "Keine aktuellen Aktivitäten",
    "emptyDesc": "Fotos, Gewichte, Maße und Nachrichten deiner Nutzer erscheinen hier.",
    "viewByClient": "Nach Nutzer",
    "viewChrono": "Chronologisch",
    "oneActivity": "Aktivität",
    "manyActivities": "Aktivitäten",
    "today": "Heute",
    "yesterday": "Gestern",
    "itemOne": "Eintrag",
    "itemMany": "Einträge",
    "thumbsUp": "Super",
    "thumbsSent": "Gesendet",
    "commentLabel": "Kommentieren",
    "commentedLabel": "Kommentiert",
    "commentPlaceholder": "Schnelles Feedback schreiben…",
    "commentSent": "Feedback an Nutzer gesendet",
    "mealLogged": "Mahlzeit eingetragen",
    "weightLogged": "Gewicht eingetragen",
    "measurementUpdated": "Maße aktualisiert",
    "progressPhoto": "Fortschrittsfoto",
    "chatMessage": "Neue Nachricht",
    "angle_front": "vorne",
    "angle_side": "seite",
    "angle_back": "hinten"
  },
  "progress": {
    "title": "Fortschritt",
    "subtitle": "Sieh deine Veränderungen im Zeitverlauf.",
    "navOverview": "Übersicht",
    "navBody": "Körper",
    "navNutrition": "Ernährung",
    "navHealth": "Geräte & Apps",
    "navPhotos": "Fotos",
    "bmiTitle": "Body-Mass-Index",
    "bmiUnder": "Untergewicht",
    "bmiNormal": "Normalgewicht",
    "bmiOver": "Übergewicht",
    "bmiObese": "Adipositas",
    "thisWeek": "Letzte 7 Tage",
    "noDataConnect": "Keine Daten · Wearable verbinden",
    "monthlyTitle": "Fortschritt",
    "days": "Tage",
    "weightLabel": "Gewicht",
    "waistLabel": "Bauchumfang",
    "recapNow": "aktuell",
    "recapUnchanged": "unverändert in 30 Tagen",
    "recapNeedTwo": "2 Einträge nötig für die Veränderung",
    "recapNoWaist": "Noch kein Bauchumfang erfasst – unter „Körper“ eintragen",
    "recapNoWeight": "Noch kein Gewicht erfasst",
    "workoutsLabel": "Trainings",
    "diaryLabel": "Tagebuch",
    "waterLabel": "Wasser",
    "hitTarget": "Tagesdurchschnitt",
    "streakLabel": "Tage in Folge",
    "streakToast7Title": "7 Tage Wasser-Streak! 💧",
    "streakToast7Desc": "Eine ganze Woche am Ziel. Dein Körper dankt dir!",
    "streakToast14Title": "Zwei Wochen in Folge! 🔥",
    "streakToast14Desc": "Trinken ist jetzt zur Gewohnheit geworden. Weiter so!",
    "streakToast30Title": "30 Tage in Folge! 🏆",
    "streakToast30Desc": "Ein ganzer Monat am Ziel. Beeindruckend!",
    "aiInsightTitle": "KI-Coach",
    "aiInsightEmpty": "Trage mehr Daten ein, um einen personalisierten KI-Tipp zu erhalten.",
    "refreshInsight": "Aktualisieren",
    "weightTrend": "Gewichtsverlauf",
    "goalShort": "Ziel",
    "prevPeriod": "Vorperiode",
    "kcalTrend": "Kalorien-Verlauf · 30 Tage",
    "kcalAvg": "Ø pro Tag",
    "kcalVsGoal": "kcal zum Ziel",
    "kcalBand": "Zielbereich",
    "macroTrend": "Makro-Verlauf · 30 Tage",
    "macroProtein": "Protein",
    "macroCarbs": "Kohlenhydrate",
    "macroCarbsShort": "KH",
    "macroTipCta": "Passende Rezepte ansehen",
    "macroRecipesHigh": "Rezepte mit viel {macro}",
    "macroRecipesLow": "Rezepte mit wenig {macro}",
    "macroRecipesHint": "Sortiert nach Anteil an den Kalorien pro Portion – antippen öffnet das Rezept.",
    "macroRecipesEmpty": "Noch keine passenden Rezepte in deiner Sammlung.",
    "macroFat": "Fett",
    "macroOfGoal": "{pct} % von {goal} g",
    "kcalInBand": "{n} von {total} erfassten Tagen im Zielbereich (±10 %)",
    "needMore": "Trag mindestens 2 Gewichte ein, um den Graphen zu sehen.",
    "now": "Aktuell",
    "measChartTitle": "Verlauf der Maße",
    "rangeW": "Woche",
    "rangeM": "Monat",
    "range3M": "3 Monate",
    "rangeY": "Jahr",
    "rangeAll": "Alle",
    "logMeasurements": "Maße eintragen",
    "saveMeasurements": "Maße speichern",
    "measurementsLogged": "Maße gespeichert",
    "waist": "Bauchumfang (cm)",
    "hips": "Hüfte (cm)",
    "chest": "Brust (cm)",
    "arm": "Arm (cm)",
    "thigh": "Oberschenkel (cm)",
    "armGroup": "Arm",
    "thighGroup": "Oberschenkel",
    "armLeft": "Arm links",
    "armRight": "Arm rechts",
    "thighLeft": "Oberschenkel li.",
    "thighRight": "Oberschenkel re.",
    "calf": "Wade (cm)",
    "calfGroup": "Wade",
    "calfLeft": "Wade li.",
    "calfRight": "Wade re.",
    "leftShort": "Links",
    "rightShort": "Rechts",
    "history": "Maß-Verlauf",
    "trend": "Verlauf der Maße",
    "needMoreData": "Mindestens 2 Einträge nötig, um den Verlauf zu zeigen.",
    "latest": "Neuestes",
    "measure": "Maß",
    "measures": "Maße",
    "needAtLeastOne": "Bitte mindestens ein Maß eingeben"
  },
  "weightGoal": {
    "title": "Zielgewicht",
    "setPrompt": "Zielgewicht festlegen →",
    "currentToTarget": "Aktuell → Ziel",
    "startCurrentTarget": "Start → Aktuell → Ziel",
    "remaining": "Verbleibend",
    "reached": "Ziel erreicht! 🎯",
    "etaLine": "Bei deinem aktuellen Tempo ({rate} kg/Woche) erreichst du es in ~{weeks} Wochen",
    "etaTooFast": "Ziemlich schnelles Tempo ({rate} kg/Woche). Bitte mit dem Ernährungsberater abstimmen.",
    "etaProjection": "Prognose",
    "weeks": "Wochen",
    "wrongDirection": "Dein Gewicht bewegt sich in die falsche Richtung.",
    "wrongDirectionHint": "Kalorien und Trainings mit deinem Ernährungsberater überprüfen.",
    "needMore": "Wiege dich mindestens 2 Wochen in Folge, um eine Prognose zu sehen.",
    "logFirst": "Erfasse zuerst dein aktuelles Gewicht.",
    "invalid": "Bitte ein gültiges Gewicht zwischen 30 und 250 kg eingeben",
    "saved": "Zielgewicht gespeichert",
    "cleared": "Ziel entfernt",
    "clearBtn": "Ziel entfernen",
    "editBtn": "Bearbeiten",
    "milestones": "Zwischenziele",
    "milestoneTitle": "Zwischenziel erreicht! 🎉",
    "milestoneDesc": "Du bist bei {kg} kg — jede 2 kg zählt.",
    "milestoneFinalTitle": "Zielgewicht erreicht! 🎯",
    "milestoneFinalDesc": "Gratulation, du hast dein Wunschgewicht erreicht."
  },
  "diary": {
    "title": "Tagebuch von heute",
    "today": "Heute",
    "yesterday": "Gestern",
    "pctOfDay": "{n}% des Tagesziels",
    "mealVerdictGood": "Top",
    "mealVerdictWarn": "Gut",
    "mealVerdictBad": "Verbessern",
    "verdictExplainGood": "Top: ausgewogene, gut zusammengestellte Mahlzeit.",
    "verdictExplainWarn": "In Ordnung — kleine Verbesserungen möglich:",
    "verdictExplainBad": "Zu verbessern — über den Grenzwerten bei:",
    "verdictReason": {
      "sugar": "Zu viel Zucker (> 25 g)",
      "salt": "Zu viel Salz (> 2,5 g)",
      "satFat": "Zu viele gesättigte Fette (> 8 g)",
      "heavySnack": "Snack zu kalorienreich (> 350 kcal)",
      "balancedMain": "Ausgewogen: Protein + Ballaststoffe + passende kcal",
      "lightSnack": "Leichter, ausgewogener Snack",
      "goodBreakfast": "Frühstück mit guten Ballaststoffen/Proteinen",
      "lowProtein": "Wenig Protein — mehr magere Proteine hinzufügen",
      "lowFiber": "Wenig Ballaststoffe — Gemüse oder Vollkorn ergänzen",
      "tooLight": "Etwas zu leicht für eine Hauptmahlzeit",
      "tooHeavy": "Etwas zu üppig — Portion reduzieren",
      "emptyCarbs": "Nur Kohlenhydrate — Protein oder Ballaststoffe ergänzen",
      "lowProteinOrFiber": "Wenig Protein oder Ballaststoffe",
      "heavyBreakfast": "Frühstück etwas üppig",
      "neutral": "Bewertung neutral — Details prüfen"
    },
    "verdictAdvice": {
      "sugar": "Ersetze zuckerhaltige Getränke/Süßes durch frisches Obst. Probier zuckerarme Rezepte (< 8 g).",
      "salt": "Weniger verarbeitete Lebensmittel (Wurst, Saucen, salzige Snacks). Suche Rezepte mit < 1 g Salz.",
      "satFat": "Nimm Olivenöl statt Butter/tierischen Fetten. Rezepte mit gesättigten Fetten < 3 g.",
      "heavySnack": "Wähle Snacks unter 200 kcal (Obst, griechischer Joghurt, portionierte Nüsse).",
      "lowProtein": "Füge 100–150 g Huhn, Fisch, Eier oder Hülsenfrüchte hinzu. Rezepte mit Protein ≥ 25 g.",
      "lowFiber": "Ergänze rohes/gekochtes Gemüse, Hülsenfrüchte oder Vollkorn. Rezepte mit Ballaststoffen ≥ 8 g.",
      "tooLight": "Rezepte mit 400–700 kcal halten dich bis zur nächsten Mahlzeit satt.",
      "tooHeavy": "Reduziere Kohlenhydrat- & Fettportionen. Ausgewogene Rezepte ≤ 550 kcal.",
      "emptyCarbs": "Ergänze mit Protein (Joghurt, Eier) oder Ballaststoffen (Gemüse, Obst).",
      "lowProteinOrFiber": "Ergänze mageres Protein ODER Ballaststoffe für eine ausgewogene Mahlzeit.",
      "heavyBreakfast": "Frühstück ≤ 450 kcal: Obst + griechischer Joghurt + Vollkornhaferflocken."
    },
    "verdictSheetPraise": "Top gemacht — diese Mahlzeit ist gut ausgewogen für deine Ziele.",
    "verdictRecipesSuggest": "Rezepte, die helfen können",
    "verdictNoRecipes": "Kein passendes Rezept in deiner Sammlung. Probier eins aus dem Kühlschrank-AI!",
    "subtitle": "Trag ein, was du isst.",
    "newCommentOne": "1 neuer Kommentar",
    "newCommentMany": "{count} neue Kommentare",
    "newCommentTap": "Tippe, um das Feedback zu sehen",
    "logAsMeal": "Zur heutigen Mahlzeit hinzufügen",
    "addToDiary": "Zum Tagebuch hinzufügen",
    "totalEst": "Tagesbilanz:",
    "addMeal": "Mahlzeit hinzufügen",
    "addMealHint": "Wähle, wie du diese Mahlzeit erfassen möchtest",
    "quickManual": "Manuell",
    "quickPhoto": "KI-Foto",
    "quickFood": "Lebensmittel",
    "quickVoice": "Sprache",
    "quickSearch": "Lebensmittel suchen",
    "typeLabel": "Art",
    "descLabel": "Beschreibung",
    "kcalOpt": "Kcal (opt.)",
    "descPh": "z.B. 80g Vollkornnudeln, Tomate, Olivenöl",
    "notesPh": "Notizen (Hunger, Stimmung, Sport…)",
    "logMealBtn": "Mahlzeit eintragen",
    "mealLogged": "Mahlzeit eingetragen",
    "sharedToLibrary": "In der Rezept-Bibliothek geteilt",
    "describe": "Beschreibe, was du gegessen hast",
    "noneForDate": "Keine Mahlzeiten an diesem Datum.",
    "saveAsRecipe": "Als Rezept speichern",
    "saveAsRecipeHint": "{n} Einträge · {kcal} kcal gesamt. Speichere dein Gericht als eigenes Rezept — beim nächsten Mal loggst du einfach eine Portion.",
    "recipeNamePh": "Rezeptname (z. B. Omas Lasagne)",
    "recipeNameRequired": "Bitte gib einen Rezeptnamen ein.",
    "recipeServings": "Ergibt Portionen",
    "recipePerServing": "≈ {kcal} kcal pro Portion",
    "recipeNotePh": "Zubereitung / Notizen (optional)",
    "recipeUsePhoto": "Foto aus dem Eintrag übernehmen",
    "recipePhotoAuto": "Dieses Foto wird automatisch als Rezeptbild übernommen",
    "recipeSaveBtn": "Rezept speichern",
    "recipeSaved": "Rezept gespeichert! Du findest es beim Loggen im Tab \"Rezepte\" 📖",
    "autoSortedInto": "Einsortiert in:",
    "recipeKeepMyPortion": "Im Tagebuch nur meine Portion behalten",
    "recipeMyPortions": "Meine Portionen",
    "recipeMyPortionHint": "Die Einträge werden durch 1 Eintrag mit ≈ {kcal} kcal ersetzt",
    "recipeSavedPortion": "Rezept gespeichert — im Tagebuch steht jetzt nur deine Portion 📖",
    "breakfast": "Frühstück",
    "snack": "Snack",
    "lunch": "Mittagessen",
    "afternoon": "Nachmittags-Snack",
    "dinner": "Abendessen",
    "aiPhoto": "Mit KI analysieren",
    "aiPhotoDesc": "Fotografiere dein Gericht: die KI erkennt die Lebensmittel und berechnet Kcal, Makro- und Mikronährstoffe.",
    "openCamera": "Kamera öffnen",
    "uploadPhoto": "Foto hochladen",
    "portionTipTitle": "Tipp für bessere Portionsschätzung",
    "portionTipBody": "Nimm eine Hand, eine Gabel oder eine Münze mit ins Bild – so schätzt die KI die Gramm genauer.",
    "portionUncertain": "Die KI ist bei den Portionsgrössen unsicher – bitte prüfe und korrigiere die Gramm-Angaben.",
    "portionTipDismiss": "Verstanden",
    "aiAnalyzing": "Analysiere…",
    "aiOk": "Mahlzeit erkannt! Anpassen und eintragen.",
    "aiError": "Foto konnte nicht analysiert werden. Erneut versuchen oder manuell eingeben.",
    "wrongMatch": "Falsche Erkennung?",
    "wrongMatchAria": "Falsche Erkennung melden",
    "wrongMatchPrompt": "Wie sollte das Lebensmittel richtig heissen?",
    "wrongMatchOk": "Danke! Korrektur registriert – wir lernen daraus.",
    "wrongMatchError": "Konnte die Korrektur nicht senden. Nochmals versuchen?",
    "recognizedFoods": "Erkannte Lebensmittel",
    "addFood": "Lebensmittel hinzufügen",
    "foodNamePh": "z.B. Gegrillte Zucchini",
    "recompute": "Nährwerte neu berechnen",
    "recomputing": "Berechne…",
    "recomputeOk": "Nährwerte neu berechnet",
    "foodNotRecognized": "Nicht erkannt (0 kcal)",
    "foodPickFromDb": "aus Datenbank wählen",
    "recomputeError": "Neuberechnung fehlgeschlagen — Namen/Gewichte prüfen",
    "confirmDelete": "Mahlzeit löschen?",
    "deleted": "Mahlzeit gelöscht",
    "undo": "Rückgängig",
    "restored": "Löschen rückgängig gemacht",
    "duplicateFromYesterday": "Von gestern kopieren",
    "yourMeals": "Deine Mahlzeiten",
    "yourMealsSubtitle": "Mahlzeiten & Zutaten der letzten 7 Tage – antippen zum Kopieren",
    "favorites": "Favoriten",
    "favoriteAdd": "Als Favorit markieren",
    "favoriteRemove": "Favorit entfernen",
    "favoriteAdded": "Zu Favoriten hinzugefügt",
    "favoriteRemoved": "Aus Favoriten entfernt",
    "favLongPressHint": "Lang drücken = direkt loggen",
    "favQuickLogged": "Favorit direkt eingetragen",
    "noMealsYesterday": "Gestern keine Mahlzeiten eingetragen",
    "mealDuplicated": "Mahlzeit in heute kopiert",
    "mealUpdated": "Mahlzeit aktualisiert",
    "editMeal": "Mahlzeit bearbeiten",
    "hintLabel": "Hilf der KI",
    "hintOptional": "(optional)",
    "hintPlaceholder": "z. B. 35g Mehl, 80g Ei, 80g Banane",
    "hintReanalyze": "Nochmal mit Hinweis analysieren",
    "hintCompute": "Nährwerte berechnen",
    "photoAttached": "Foto hinzugefügt",
    "quickEntryLabel": "Schnelleingabe",
    "hintComputed": "Nährwerte aus deiner Liste berechnet",
    "hintComputedPartial": "{matched} von {total} Zutaten erkannt — Werte evtl. unvollständig",
    "splitIngredients": "In Zutaten aufteilen",
    "splitIngredientsHint": "Jede Zutat einzeln anpassbar – Makros nach Gramm-Anteil geschätzt (≈), Summe bleibt gleich",
    "splitDone": "{n} Zutaten angelegt",
    "lookupIngredients": "Nährwerte aus Datenbank übernehmen",
    "lookupIngredientsHint": "Ersetzt die geschätzten (≈) Werte durch echte Nährwerte pro 100 g",
    "lookupRow": "Aus Datenbank",
    "lookupDone": "{n} Zutaten aus der Datenbank übernommen",
    "lookupPartial": "{found} von {total} Zutaten gefunden – Rest bleibt geschätzt",
    "hintReanalyzed": "Analyse mit deinem Hinweis aktualisiert",
    "aiRetryTitle": "Foto-Analyse fehlgeschlagen",
    "aiRetryHelp": "Gib unten einen Hinweis ein, damit die KI besser erkennt, oder versuche es einfach erneut.",
    "aiRetryBtn": "Erneut versuchen",
    "aiChefStep1": "Ich analysiere deine Mahlzeit…",
    "aiChefStep2": "Ich erkenne die Lebensmittel…",
    "aiChefStep3": "Ich berechne Kalorien und Makros…",
    "aiChefStep4": "Fast fertig…",
    "aiChefStep5": "Deine Mahlzeit ist gleich bereit…",
    "aiChefDone": "Deine Mahlzeit ist bereit.",
    "barcodeNudgeTitle": "Verpacktes Produkt erkannt",
    "barcodeNudgeBody": "Barcode scannen für exakte Etikettwerte",
    "barcodeNudgeCta": "Scannen →",
    "journalTitle": "Tagebuch",
    "journalSubtitle": "Wie fühlst du dich heute? Wie war der Tag?",
    "journalPlaceholder": "Freie Notizen zum Tag, Training, Energie, Cravings…",
    "journalSaving": "Speichere…",
    "journalSaved": "Gespeichert",
    "journalVoiceRec": "Aufnahme",
    "journalVoiceTranscribing": "Transkribiere…",
    "journalVoiceEmpty": "Keine Sprache erkannt",
    "journalVoicePermDenied": "Mikrofonzugriff verweigert",
    "journalReplies": "Antworten deines Ernährungsberaters",
    "journalSaveEntry": "Eintrag speichern",
    "journalTodayEntries": "Einträge von heute",
    "journalMorning": "Morgen",
    "journalAfternoon": "Nachmittag",
    "journalEvening": "Abend",
    "journalPickSomething": "Wähle eine Stimmung oder schreib etwas",
    "duplicateAll": "Alle kopieren",
    "swipeEdit": "Bearbeiten",
    "swipeDuplicate": "Kopieren",
    "swipeDelete": "Löschen",
    "allDuplicated": "{n} Mahlzeiten kopiert",
    "meal": "Mahlzeit",
    "portionLabel": "Portion",
    "portionHint": "Gramm ändern: Makros passen sich an",
    "notesTitle": "Anleitung und Notizen",
    "save": "Speichern",
    "voiceTap": "Zum Sprechen tippen",
    "voiceListening": "Ich höre zu…",
    "voiceAnalyzing": "Analysiere was du gesagt hast…",
    "voiceListeningHint": "Beschreibe deine Mahlzeit laut. Tippe auf «Stop», wenn du fertig bist.",
    "voiceAnalyzingHint": "Einen Moment, transkribiere…",
    "voiceStop": "Stop",
    "voiceOk": "Fertig! Anpassen und speichern.",
    "voiceError": "Nicht verstanden, versuche es nochmal",
    "voicePermDenied": "Mikrofon-Erlaubnis nötig",
    "transcript": "Transkript",
    "selectMealType": "Mahlzeitentyp",
    "chooseDateTime": "Datum & Uhrzeit",
    "summaryTitle": "Mahlzeit-Übersicht",
    "kcalShort": "kcal",
    "proteinShort": "Prot.",
    "carbsShort": "KH",
    "fatShort": "Fett",
    "fiberShort": "Ballaststoffe",
    "voiceNoteMax": "Sprachnotiz aufnehmen (max. 15 s)"
  },
  "food": {
    "gramsTab": "Gramm",
    "pieces": "Stück",
    "sizeSmall": "klein",
    "sizeMedium": "mittel",
    "sizeLarge": "groß",
    "barcodeNotFoundAddManually": "Produkt nicht gefunden — jetzt manuell hinzufügen",
    "torch": "Taschenlampe",
    "pinchZoomHint": "Zwei Finger zum Zoomen.",
    "title": "Lebensmittel suchen",
    "description": "Suche nach Name oder scanne den Produkt-Strichcode",
    "recipeIngredients": "Zutaten",
    "recipeSteps": "Zubereitung",
    "portion": "Portion",
    "servings": "Portionen",
    "servingsN": "{n} Portionen",
    "byName": "Name",
    "byBarcode": "Strichcode",
    "searchPh": "Banane, Vollkornnudeln, griechischer Joghurt…",
    "scanWithCamera": "Mit Kamera scannen",
    "or": "oder",
    "aimAtBarcode": "Richte die Kamera auf den Strichcode",
    "scannerFocusHint": "Wenn er nicht liest, tippe auf den Code zum Scharfstellen.",
    "zoom": "Zoom",
    "labelOcrTitle": "Strichcode unleserlich?",
    "labelOcrBody": "Fotografiere die Nährwerttabelle — die KI liest die Werte",
    "labelOcrCameraCta": "Foto",
    "labelOcrGalleryCta": "Galerie",
    "labelUnreadable": "Etikett unleserlich, mit mehr Licht erneut versuchen",
    "labelError": "Etikett konnte nicht gelesen werden",
    "labelProduct": "Produkt vom Etikett",
    "pointBarcode": "Richte die Kamera auf den Strichcode",
    "startingCamera": "Kamera startet…",
    "orEnterManually": "Oder Code manuell eingeben:",
    "enterCode": "Code eingeben",
    "rescan": "Neu scannen",
    "camPermission": "Kamera-Berechtigung nötig",
    "camError": "Kamera kann nicht geöffnet werden",
    "camNoStream": "Kamera startet nicht. Nimm ein Foto oder gib den Code manuell ein.",
    "camNodevice": "Keine Kamera gefunden",
    "camGeneric": "Kamera nicht verfügbar",
    "pickPhoto": "Foto aufnehmen oder auswählen",
    "noBarcodeInImage": "Kein Barcode im Foto erkannt",
    "camNoDevice": "Keine Kamera gefunden",
    "camBusy": "Die Kamera wird bereits von einer anderen App verwendet",
    "camIframe": "Kamera von der Vorschau blockiert. Öffne die App in einem neuen Tab ↗",
    "camTip": "Tipp: Tippe auf das ↗ Symbol oben, um die App außerhalb der Vorschau zu öffnen und den Zugriff zu erlauben.",
    "camTipNative": "Tipp: Erlaube den Kamerazugriff unter Einstellungen → Apps → Solano Essence → Berechtigungen → Kamera und versuche es erneut.",
    "notFound": "Produkt nicht gefunden",
    "manualAdd": {
      "title": "Produkt manuell hinzufügen",
      "subtitle": "Der Code ist noch nicht in der Datenbank — einmal speichern, und beim nächsten Scan ist er direkt da.",
      "barcode": "EAN-Code",
      "name": "Produktname",
      "namePlaceholder": "z.B. Naturjoghurt griechisch",
      "brand": "Marke (optional)",
      "brandPlaceholder": "z.B. FAGE",
      "per100g": "Werte pro 100 g",
      "kcal": "Kalorien",
      "protein": "Eiweiß",
      "carbs": "Kohlenhydrate",
      "fat": "Fett",
      "sugar": "Zucker",
      "fiber": "Ballaststoffe",
      "satFat": "Ges. Fett",
      "salt": "Salz",
      "hint": "Werte vom Nährwert-Etikett übernehmen. Nicht benötigte Felder kannst du leer lassen.",
      "saveAndUse": "Speichern & nutzen",
      "saved": "Produkt gespeichert ✓",
      "needBasics": "Name und Barcode sind Pflicht",
      "labelAiTitle": "Mit KI ausfüllen ✨",
      "labelAiSubtitle": "Foto vom Nährwert-Etikett — die KI liest kcal und Makros und füllt das Formular aus.",
      "labelCamera": "Foto aufnehmen",
      "labelUpload": "Foto hochladen",
      "labelAnalyzing": "KI liest das Etikett…",
      "labelAnalyzed": "Etikett erkannt ✓ — bitte prüfen",
      "labelError": "Etikett konnte nicht gelesen werden. Mach ein schärferes Foto.",
      "productPhoto": "Produktfoto",
      "productPhotoAdd": "Foto hinzufügen",
      "productPhotoRetake": "Foto neu aufnehmen"
    },
    "searchError": "Suchfehler",
    "backToResults": "Zurück",
    "nameSaved": "Produktname gespeichert — künftige Scans zeigen ihn korrekt",
    "quantityConsumed": "Verzehrte Menge",
    "yourPortion": "Deine Portion",
    "sugar": "Zucker",
    "fiber": "Ballastst.",
    "satFat": "Ges. Fett",
    "salt": "Salz",
    "ofCarbs": "davon",
    "ofFat": "davon",
    "lightSugarShort": "Z",
    "lightFatShort": "F",
    "lightSaltShort": "S",
    "altTitle": "Gesündere Alternative?",
    "altCta": "3 Vorschläge",
    "altEmpty": "Keine passende grüne Alternative gefunden.",
    "lightLow": "wenig",
    "lightMid": "mittel",
    "lightHigh": "viel",
    "lightBasis": "pro 100 g",
    "noDetails": "Keine Angaben zu Zucker, Ballaststoffen, gesättigtem Fett und Salz für dieses Produkt.",
    "addToMeal": "Zur Mahlzeit hinzufügen",
    "tabDb": "Solano-Datenbank",
    "tabFav": "Favoriten",
    "tabCustom": "Eigene Daten",
    "tabRecipes": "Rezepte",
    "tabRecent": "Verlauf",
    "noRecentYet": "Noch keine kürzlich getrackten Lebensmittel. Füge deine erste Mahlzeit hinzu!",
    "per100g": "pro 100 g",
    "perPortion": "pro Portion",
    "addToFav": "Zu Favoriten hinzufügen",
    "removeFav": "Aus Favoriten entfernen",
    "favAdded": "Zu Favoriten hinzugefügt",
    "favRemoved": "Aus Favoriten entfernt",
    "noFavYet": "Noch keine Favoriten. Tippe auf das Herz, um ein Lebensmittel zu speichern.",
    "noCustomYet": "Noch keine eigenen Lebensmittel. Erstelle dein erstes.",
    "noRecipesYet": "Keine Rezepte gefunden.",
    "createCustom": "Neues Lebensmittel",
    "editCustom": "Lebensmittel bearbeiten",
    "customName": "Name",
    "customBrand": "Marke (opt.)",
    "customNotes": "Notizen (opt.)",
    "customKcal": "Kcal / 100 g",
    "customProtein": "Eiweiß / 100 g",
    "customCarbs": "Kohlenhydrate / 100 g",
    "customFat": "Fett / 100 g",
    "customSugar": "Zucker / 100 g",
    "customFiber": "Ballaststoffe / 100 g",
    "customSat": "Ges. Fettsäuren / 100 g",
    "customSalt": "Salz / 100 g",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "customCreated": "Lebensmittel erstellt",
    "customDeleted": "Lebensmittel gelöscht",
    "deleteConfirm": "Wirklich löschen?",
    "detailBadge": "DETAIL",
    "minLettersHint": "Mindestens 2 Zeichen eingeben, um die Datenbank zu durchsuchen.",
    "aiBadge": "KI-SCHÄTZUNG",
    "aiEstimateTip": "Nährwerte von der KI geschätzt: bitte vor dem Speichern überprüfen.",
    "searchInDbCta": "„{q}\" in der Solano-Datenbank suchen"
  },
  "calc": {
    "title": "Kalorien- & Makrorechner",
    "subtitle": "Basierend auf deinen Daten schätze ich deinen Tagesbedarf.",
    "ctaTitle": "Weißt du nicht, wie viele kcal du brauchst?",
    "ctaHint": "Automatische Berechnung nach Maß",
    "gender": "Geschlecht",
    "genderM": "Mann",
    "genderF": "Frau",
    "age": "Alter",
    "height": "Größe",
    "weight": "Gewicht",
    "targetWeight": "Zielgewicht",
    "targetWeightHint": "Optional · erscheint im Fortschritt mit ETA-Prognose",
    "activity": "Aktivitätslevel",
    "actSedentary": "Sitzend",
    "actLight": "Leicht",
    "actModerate": "Mäßig",
    "actIntense": "Intensiv",
    "actAthlete": "Sportler",
    "goal": "Ziel",
    "goalCut": "Abnehmen",
    "goalMaintain": "Halten",
    "goalPerf": "Performance",
    "goalBulk": "Aufbau",
    "calculate": "Berechnen",
    "recalculate": "Neu berechnen",
    "applyToProfile": "Übernehmen",
    "applied": "Ziele im Profil gespeichert",
    "missing": "Alle Felder ausfüllen",
    "customAdj": "Defizit/Überschuss individuell anpassen",
    "customAdjHint": "Verschiebe, um die Prozent gegenüber deinem Erhaltungsbedarf zu ändern (-30% Defizit ↔ +30% Überschuss).",
    "manualLink": "Kalorienziel bereits bekannt? Manuell eingeben",
    "maintenance": "Erhaltungsbedarf",
    "goalLabel": "Ziel",
    "recommended": "Empfohlenes Tagesziel",
    "applyComputed": "Berechnetes Ziel übernehmen",
    "adjustManually": "Manuell anpassen",
    "macrosSum": "Makros-Summe: {sum}%",
    "sumHint": "Summe: {sum}% — bitte auf 100% anpassen",
    "jobTitle": "Beruf & Alltag",
    "jobSitting": "Überwiegend sitzend (Büro, Homeoffice)",
    "jobStanding": "Stehend / gemischt (Verkauf, Unterricht)",
    "jobPhysical": "Körperlich aktiv (Handwerk, Pflege)",
    "stepsTitle": "Schritte pro Tag",
    "trainTitle": "Training pro Woche",
    "factorLabel": "Aktivitätsfaktor",
    "deficitTitle": "Tempo beim Abnehmen",
    "deficitSoft": "Sanft",
    "deficitModerate": "Moderat",
    "deficitFast": "Schnell",
    "deficitCustom": "Individuell",
    "goalCustom": "Individuell",
    "etaWeeks": "≈ {weeks} Wochen bis {target} kg",
    "etaNote": "Nur eine Schätzung — das Zielgewicht fließt nicht in die Kalorienberechnung ein.",
    "dblCountHint": "Dein Training steckt bereits im Aktivitätsfaktor — Trainings-Kalorien werden nicht zusätzlich zum Tagesbudget addiert.",
    "reviewTitle": "Ziel-Check",
    "reviewBody": "Seit {days} Tagen: {actual} kg/Woche (geplant: {expected} kg/Woche).",
    "reviewSuggestDown": "Vorschlag: Tagesziel um 100 kcal senken auf {kcal} kcal.",
    "reviewSuggestUp": "Vorschlag: Tagesziel um 100 kcal erhöhen auf {kcal} kcal.",
    "reviewApply": "Übernehmen",
    "reviewLater": "Später",
    "reviewApplied": "Neues Tagesziel gespeichert",
    "recompute": "Mit neuen Werten neu berechnen",
    "yourNeeds": "Dein Tagesbedarf",
    "day": "Tag",
    "adjustment": "Anpassung"
  },
  "nutriPlan": {
    "buttonShort": "Plan",
    "title": "Ernährungsplan",
    "subtitle": "Setze Tagesziele für",
    "client": "Nutzer",
    "selfLabel": "dich",
    "historyTitle": "Ziel-Verlauf",
    "byCoach": "Coach",
    "bySelf": "Du",
    "modeAuto": "Automatisch berechnen",
    "modeManual": "Manuell",
    "autoTitle": "Mifflin-St Jeor berechnen",
    "formulaTitle": "BMR-Formel",
    "fMifflin": "Mifflin-St Jeor",
    "fMifflinHint": "Empfohlen · allgemein",
    "fHarris": "Harris-Benedict",
    "fHarrisHint": "Rev. 1984 · klassisch",
    "fKatch": "Katch-McArdle",
    "fKatchHint": "Braucht KFA %",
    "fCunningham": "Cunningham",
    "fCunninghamHint": "Sportler · KFA %",
    "bodyFat": "Körperfett %",
    "bodyFatHint": "3–60% · nötig für Katch/Cunningham",
    "needBodyFat": "Körperfett % eingeben (3–60)",
    "fallbackToMifflin": "KFA fehlt → Mifflin-St Jeor wird verwendet",
    "customAdj": "kcal manuell anpassen",
    "customAdjHint": "Preset überschreiben (-30% Defizit ↔ +30% Überschuss)",
    "calculate": "Makros berechnen",
    "calcDone": "Werte aktualisiert — anpassen falls nötig",
    "presetTitle": "Makro-Verteilung",
    "presetBalanced": "Ausgewogen",
    "presetLowCarb": "Low Carb",
    "presetHighProt": "High Protein",
    "presetCustom": "Individuell",
    "needKcalForPreset": "Zuerst kcal eingeben",
    "targetsTitle": "Tagesziele",
    "fiber": "Ballaststoffe",
    "water": "Wasser",
    "microsTitle": "Mikronährstoffe",
    "optional": "optional",
    "sodium": "Natrium",
    "calcium": "Kalzium",
    "iron": "Eisen",
    "vitD": "Vitamin D",
    "notifyLabel": "Nutzer benachrichtigen",
    "notifyHint": "Erhält Push mit den neuen Werten",
    "saveAndActivate": "Speichern & aktivieren",
    "saved": "Plan gespeichert",
    "savedPushed": "Plan gespeichert · Nutzer benachrichtigt",
    "invalidKcal": "kcal muss zwischen 800 und 6000 liegen",
    "macroSumWarn": "Makro-Summe: {sum}% (Werte prüfen)"
  },
  "supplements": {
    "title": "Supplement-Erinnerungen",
    "atTime": "um {time} Uhr",
    "moreCount": "{n} weitere",
    "subtitleEmpty": "Antippen zum Hinzufügen",
    "addBtn": "Supplement hinzufügen",
    "newTitle": "Neues Supplement",
    "editTitle": "Bearbeiten",
    "presetsLabel": "Preset",
    "nameLabel": "Name",
    "namePlaceholder": "z.B. Magnesium 400mg",
    "timeLabel": "Uhrzeit",
    "daysLabel": "Tage",
    "everyDay": "Jeden Tag",
    "weekdays": "Mo-Fr",
    "weekend": "Wochenende",
    "active": "aktiv",
    "needName": "Name fehlt",
    "needDay": "Mindestens einen Tag wählen",
    "saved": "Gespeichert",
    "confirmDelete": "Diese Erinnerung entfernen?",
    "emptyState": "Noch keine Supplemente. Füge das erste hinzu!",
    "streakDays": "Tage",
    "takenToday": "Heute eingenommen",
    "markTakenToday": "Heute als eingenommen markieren",
    "d": {
      "mon": "Mo",
      "tue": "Di",
      "wed": "Mi",
      "thu": "Do",
      "fri": "Fr",
      "sat": "Sa",
      "sun": "So"
    }
  },
  "apptsCli": {
    "title": "Termine",
    "subtitle": "Fordere eine Beratung bei deinem Berater an.",
    "newRequest": "Neue Anfrage",
    "typeLabel": "Art",
    "modalityLabel": "Modus",
    "firstVisit": "Erstberatung",
    "checkup": "Kontrolle",
    "sportsConsult": "Sportberatung",
    "inOffice": "In der Praxis",
    "video": "Videoberatung",
    "notesPh": "Notizen für den Berater (optional)",
    "sendRequest": "Anfrage senden",
    "sentOk": "Anfrage gesendet! Der Berater bestätigt.",
    "yourBookings": "Deine Buchungen",
    "empty": "Keine Termine.",
    "noNutTitle": "Verknüpfe zuerst eine Ernährungsberatung",
    "noNutDesc": "Um einen Termin zu buchen, gib den Einladungscode deiner Beratung im Profil ein.",
    "goLinkNut": "Zum Profil"
  },
  "profile": {
    "title": "Mein Profil",
    "subtitle": "Halte deine Daten aktuell für einen genaueren Plan.",
    "notifTitle": "Push-Benachrichtigungen",
    "notifTapToOpen": "Antippen, um Erinnerungen zu verwalten",
    "devicesTapToOpen": "Antippen, um Geräte zu verbinden",
    "sectionSettings": "Einstellungen",
    "sectionConnections": "Verbindungen",
    "sectionAccount": "Konto",
    "proActiveHint": "Pro ist aktiv — Abo verwalten",
    "proUpsellHint": "Mehr Möglichkeiten für deinen Alltag freischalten",
    "proQuotaLeft": "frei",
    "personalDataTitle": "Persönliche Daten",
    "languageTitle": "Sprache",
    "languageHint": "App-Sprache — unabhängig von den Geräteeinstellungen",
    "widgetSyncTitle": "Widget jetzt aktualisieren",
    "widgetSyncHelp": "Sendet die aktuellen Tageswerte an die Homescreen-Widgets",
    "widgetSyncOk": "Widget aktualisiert ✓ {kcal} kcal · {water} · {steps} Schritte",
    "widgetSyncFail": "Widget-Sync fehlgeschlagen",
    "linkNutTitle": "Deine Ernährungsberatung",
    "linkNutNone": "Du bist noch nicht mit einer Beratung verknüpft. Gib den Einladungscode ein, wenn du ihn hast.",
    "linkNutLabel": "Einladungscode",
    "linkNutBtn": "Verknüpfen",
    "linkNutOk": "Beratung verknüpft!",
    "linkedTo": "Du bist verknüpft mit:",
    "fullName": "Vollständiger Name",
    "birthdate": "Geburtsdatum",
    "gender": "Geschlecht",
    "height": "Größe (cm)",
    "startingWeight": "Startgewicht (kg)",
    "kcalTarget": "Kcal-Ziel",
    "goal": "Ziel",
    "activity": "Aktivitätsniveau",
    "sport": "Praktizierter Sport",
    "sportPh": "z.B. Laufen, Fußball, Fitnessstudio...",
    "allergies": "Allergien / Unverträglichkeiten",
    "medical": "Medizinische Notizen",
    "saveBtn": "Profil speichern",
    "updated": "Profil aktualisiert",
    "trainingDays": "Trainingstage",
    "trainingDaysHelp": "An welchen Wochentagen trainierst du normalerweise? Passt die tägliche Bewegungs-Mission an.",
    "notifEnableCta": "Push-Benachrichtigungen auf diesem Gerät aktivieren",
    "notifTz": "Zeitzone",
    "notifMeals": "Mahlzeiten-Erinnerungen",
    "notifWater": "Wasser-Erinnerungen",
    "notifEveryMin": "Alle (Min.)",
    "notifHelper": "Aktiviere Erinnerungen für Mahlzeiten und Wasser. Du erhältst zu den eingestellten Zeiten eine Benachrichtigung auf dem Handy.",
    "notifActive": "aktiv",
    "notifDenied": "Berechtigung blockiert: aktiviere sie in den Browsereinstellungen.",
    "notifUnsupported": "Push wird auf diesem Gerät nicht unterstützt.",
    "notifOk": "Push aktiviert ✓",
    "notifTestCta": "Test-Benachrichtigung senden",
    "notifTestSent": "Test-Benachrichtigung gesendet ✓",
    "notifTestFail": "Keine Benachrichtigung gesendet. Aktiviere Push erneut.",
    "notifResetCta": "Zurücksetzen & neu abonnieren",
    "notifResetOk": "Abonnement erneuert ✓",
    "notifResetFail": "Zurücksetzen fehlgeschlagen. Entferne die PWA vom Home-Bildschirm und installiere sie neu.",
    "notifWaterFrom": "Von",
    "notifWaterTo": "Bis",
    "notifWaterFreq": "Alle",
    "notifEvening": "Abendzusammenfassung",
    "notifTraining": "Trainings-Erinnerung",
    "notifPlan": "Plan-Erinnerung am Morgen",
    "notifPlanHint": "An Tagen, an denen ein Trainingsplan eingeplant ist: „Heute: Beintag – bereit?“ – ein Tipp startet das Training direkt.",
    "notifTrainingAt": "Um",
    "notifTrainingHint": "Wird nur an geplanten Trainingstagen gesendet — wenn du an dem Tag noch kein Training eingetragen hast.",
    "notifEveningAt": "Um",
    "notifEveningPreview": "Vorschau",
    "notifEveningSendNow": "Jetzt senden",
    "mealBreakfast": "Frühstück",
    "mealSnack": "Zwischenmahlzeit",
    "mealLunch": "Mittagessen",
    "mealAfternoon": "Nachmittagssnack",
    "mealDinner": "Abendessen",
    "female": "Weiblich",
    "male": "Männlich",
    "other": "Andere",
    "weightLoss": "Abnehmen",
    "maintenance": "Halten",
    "muscle": "Muskelaufbau",
    "performance": "Sportliche Leistung",
    "sedentary": "Sitzend",
    "light": "Leicht",
    "moderate": "Moderat",
    "intense": "Intensiv",
    "athlete": "Athlet"
  },
  "language": {
    "label": "Sprache",
    "it": "Italiano",
    "en": "English",
    "de": "Deutsch"
  },
  "eveningTip": {
    "pageTitle": "Dein Abend-Tipp",
    "pageSubtitle": "Ein kleiner Schritt jetzt, ein großer Erfolg morgen",
    "hero": {
      "suggestion": "Der Vorschlag für heute Abend",
      "fallback": "Achte weiter auf deine Ernährung"
    },
    "stats": {
      "today": "Heute",
      "kcal": "kcal",
      "dayStreak": "Tage in Folge"
    },
    "howto": "So machst du es, ganz einfach",
    "ctaSeeProgress": "Fortschritt ansehen",
    "ctaLogMeal": "Mahlzeit eintragen",
    "ctaLogWater": "Wasser eintragen",
    "ctaFindRecipe": "Eiweißreiches Rezept finden",
    "ctaAddSnack": "Snack hinzufügen",
    "ctaSeeSteps": "Schritte & Aktivität ansehen",
    "backHome": "Zurück zur Startseite",
    "bullets": {
      "long_streak": "Schau dir deine Wochenkurve im Fortschritt an|Gönn dir eine kleine Belohnung – du hast sie verdient|Setz dir das nächste 7-Tage-Ziel",
      "no_dinner": "Öffne das Tagebuch und trag das Abendessen nach|Auch ein leichtes Gericht zählt|Nur erfasste Mahlzeiten zählen für Bilanz und Streak",
      "water_low": "Trink jetzt 1 Glas und 1 vor dem Schlafen|Stell eine Flasche ans Bett|Beginn morgen mit 1 Glas vor dem Kaffee",
      "protein_gap": "Griechischer Joghurt oder Skyr zum Frühstück|Gekochte Eier als Snack|Thunfisch oder Putenaufschnitt zum Mittag",
      "kcal_deficit_large": "Griechischer Joghurt mit Honig und Nüssen|Vollkorntoast mit Avocado|Obst + eine Handvoll Mandeln",
      "steps_low": "Nach dem Abendessen 20 Minuten spazieren|Eine Station früher aussteigen|Treppe statt Aufzug",
      "great_day": "Morgen genauso weiter|Bereite dein Frühstück heute schon vor|Setz dir ein neues Wochenziel",
      "day_recap": "Wirf einen Blick auf deine Tagesbilanz im Fortschritt|Stell dir Wasser für morgen früh bereit|Plane dein Frühstück im Voraus"
    }
  },
  "theme": {
    "title": "Erscheinungsbild",
    "subtitle": "Wähle, wie die App aussehen soll.",
    "light": "Hell",
    "dark": "Dunkel",
    "system": "System",
    "systemHint": "Folgt den Geräteeinstellungen"
  },
  "nutProfile": {
    "title": "Profil",
    "subtitle": "Konto und Erscheinungsbild verwalten.",
    "accountTitle": "Konto",
    "fullName": "Vollständiger Name",
    "email": "E-Mail",
    "emailReadOnly": "E-Mail kann nicht geändert werden",
    "inviteTitle": "Praxis-Einladungscode",
    "inviteHelp": "Teile diesen Code mit neuen Nutzer, um sie mit deiner Praxis zu verknüpfen."
  },
  "trend": {
    "last7days": "Letzte 7 Tage"
  },
  "aiCoach": {
    "title": "AI Coach",
    "chipLabel": "Coach",
    "chipSub": "{n} neue Tipps",
    "chipReady": "Bereit",
    "subtitle": "Deine Tipps für heute",
    "refresh": "Aktualisieren",
    "refreshed": "Tipps aktualisiert",
    "stripHint": "Tippe für {count} Tipps von heute",
    "askBtn": "Coach fragen",
    "chatTitle": "Frag den AI Coach",
    "voiceOn": "Stimme aktivieren – Antworten werden vorgelesen",
    "voiceOff": "Stimme deaktivieren",
    "chatHint": "Der Coach kennt deine Daten: Makros, Scores, Teller, Schlaf, Gewicht, Streaks. Foto oder Screenshot anhängen möglich.",
    "suggestionsLabel": "Frag zum Beispiel:",
    "inputPlaceholder": "Schreib eine Frage…",
    "thinking": "Der Coach überlegt…",
    "send": "Senden",
    "attachPhoto": "Foto anhängen",
    "takePhoto": "Foto aufnehmen",
    "fromGallery": "Foto/Screenshot aus Galerie",
    "photoReady": "Foto bereit zum Senden",
    "startRec": "Sprachnachricht aufnehmen",
    "stopRec": "Aufnahme stoppen",
    "recording": "Aufnahme läuft… tippe auf das Mikro zum Stoppen",
    "transcribing": "Transkribiere deine Stimme…",
    "transcribeError": "Ich habe dich nicht verstanden, sprich bitte deutlicher",
    "micUnsupported": "Mikrofon wird auf diesem Gerät nicht unterstützt",
    "micDenied": "Mikrofonzugriff abgelehnt"
  },
  "restaurant": {
    "title": "Im Restaurant",
    "subtitle": "Lass die KI die Speisekarte lesen und das beste Gericht für dich wählen",
    "badgeNew": "NEU",
    "tabPhoto": "Foto der Karte",
    "tabText": "Karte eintippen",
    "captureBtn": "Foto aufnehmen",
    "chooseFileBtn": "Vom Gerät",
    "captureHint": "Kamera öffnen",
    "chooseFileHint": "Aus deiner Galerie",
    "imageSelected": "Bild ausgewählt",
    "analyzeBtnNow": "Jetzt analysieren",
    "infoTitle": "Die KI analysiert für dich:",
    "infoProtein": "Protein",
    "infoVeg": "Gemüse",
    "infoKcal": "Kalorien",
    "infoCarbs": "KH",
    "infoFat": "Fett",
    "infoBest": "Beste Wahl",
    "step1": "Foto oder Upload",
    "step2": "KI analysiert",
    "step3": "Empfehlung erhalten",
    "photoHint": "Speisekarte einrahmen, dann auf Analysieren tippen",
    "textPlaceholder": "Restaurant-Name ODER Gerichte eingeben (z.B. «Hooters Interlaken» oder «Pasta, Seezunge, Tiramisu»)…",
    "recentSearches": "Zuletzt gesucht",
    "removeRecent": "Entfernen",
    "analyzeBtn": "Karte analysieren",
    "analyzing": "Analysiere…",
    "retakeBtn": "Neues Foto",
    "changeMenuBtn": "Karte ändern",
    "mealLabel": "Mahlzeit",
    "meals": {
      "colazione": "Frühstück",
      "pranzo": "Mittagessen",
      "merenda": "Snack",
      "cena": "Abendessen",
      "spuntino": "Snack"
    },
    "budgetTitle": "Heute noch übrig",
    "budgetKcal": "kcal",
    "budgetProtein": "Eiweiß",
    "budgetCarbs": "KH",
    "budgetFat": "Fett",
    "medScore": "Med-Score",
    "noBudget": "Kein Ziel gesetzt — aktiviere es im Profil für genauere Tipps",
    "resultsTitle": "Empfohlene Auswahl",
    "chooseBtn": "Das nehme ich",
    "choosingIn": "Zum Tagebuch hinzufügen…",
    "addedToDiary": "Gericht ins Tagebuch übernommen 🍽️",
    "addError": "Konnte nicht zum Tagebuch hinzugefügt werden",
    "analyzeError": "Karte konnte nicht analysiert werden. Nochmals versuchen.",
    "needInput": "Bitte Foto der Karte oder Text angeben",
    "tipsTitle": "Extra-Tipps",
    "verdictGreen": "Top-Wahl",
    "verdictYellow": "OK mit Vorsicht",
    "verdictRed": "Lieber nicht",
    "medImpact": {
      "positive": "↑ Med",
      "neutral": "= Med",
      "negative": "↓ Med"
    },
    "backBtn": "Zurück zum Dashboard",
    "historyTitle": "Deine Restaurant-Favoriten",
    "removeFavorite": "Aus Favoriten entfernen",
    "favoriteRemoved": "Aus Favoriten entfernt",
    "reorderBtn": "Nochmal"
  },
  "pantry": {
    "title": "Vorratskammer",
    "subtitle": "Was du zu Hause hast",
    "empty": "Deine Vorratskammer ist leer. Zutaten hinzufügen oder Beleg scannen.",
    "addManual": "Manuell hinzufügen",
    "namePlaceholder": "z.B. Eier, Tomaten, griechischer Joghurt…",
    "qtyPlaceholder": "Menge",
    "added": "Zur Vorratskammer hinzugefügt",
    "deducted": {
      "some": "-{g} von {name} · noch {after}",
      "depleted": "{name} aufgebraucht — aus der Vorratskammer entfernen",
      "restored": "{name} wiederhergestellt"
    },
    "scanReceipt": "Kassenbon scannen",
    "scanReceiptHint": "KI liest die Artikel",
    "scanEan": "EAN scannen",
    "scanEanHint": "Ein Produkt pro Scan",
    "itemAdded": "Zur Vorratskammer",
    "needName": "Name erforderlich",
    "scanError": "Konnte den Kassenbon nicht lesen",
    "scanning": "Kassenbon wird analysiert…",
    "whatToCook": "Was koche ich?",
    "whatToCookHint": "Rezept mit dem was du hast",
    "needMore": "Mindestens 2 Zutaten hinzufügen",
    "recipeCreated": "Rezept erstellt!",
    "receiptTitle": "Artikel prüfen",
    "receiptDesc": "Deaktiviere, was du nicht speichern willst, und passe Namen/Mengen bei Bedarf an.",
    "receiptAdded": "{count} Artikel zur Vorratskammer hinzugefügt",
    "receiptEmpty": "Keine Artikel erkannt",
    "addAll": "Alle hinzufügen",
    "emptyShort": "Leer — tippen zum Füllen",
    "countShort": "{count} Zutaten zu Hause",
    "expiryLabel": "Ablaufdatum",
    "autoSuggested": "AUTO",
    "useSoonTitle": "Zuerst verbrauchen",
    "rest": "Weitere Vorräte",
    "allItems": "Alle Produkte",
    "mergedToast": "{name}: {qty}",
    "storageLabel": "Lagerort",
    "storage": {
      "fridge": "Kühlschrank",
      "pantry": "Vorrat",
      "freezer": "Tiefkühler"
    },
    "expired": "Vor {days}T abgelaufen",
    "today": "Läuft heute ab",
    "inDays": "In {days}T",
    "notifTitle": "Ablauf-Warnung",
    "notifBodyOne": "{name} läuft morgen ab. Verwende es heute.",
    "notifBodyMany": "{count} Zutaten laufen bald ab (z.B. {name}).",
    "categoryLabel": "Kategorie",
    "categoryHint": "Kategorie ändern",
    "cat_fruit": "Obst",
    "cat_vegetables": "Gemüse",
    "cat_dairy": "Milchprodukte",
    "cat_meat": "Fleisch",
    "cat_fish": "Fisch",
    "cat_eggs": "Eier",
    "cat_grains": "Getreide & Pasta",
    "cat_legumes": "Hülsenfrüchte",
    "cat_oils_fats": "Öle & Fette",
    "cat_spices_condiments": "Gewürze & Saucen",
    "cat_sweets": "Süßes",
    "cat_beverages": "Getränke",
    "cat_frozen": "Tiefkühl",
    "cat_supplements": "Proteine & Nahrungsergänzung",
    "cat_other": "Sonstiges",
    "searchPlaceholder": "Vorrat durchsuchen…",
    "stats": {
      "products": "Produkte",
      "categories": "Kategorien",
      "expiring": "Läuft ab",
      "shopping": "Einkaufsliste"
    },
    "shoppingEmptyHappy": "🎉 Alles eingekauft!",
    "shoppingEmptyHint": "Zeit für neue Rezepte.",
    "expiryChip": {
      "fresh": "Frisch",
      "soon": "Bald ab",
      "today": "Heute",
      "expired": "Abgelaufen"
    },
    "filter": {
      "expiringOnly": "Nur bald ablaufende Produkte",
      "all": "Alle",
      "fresh": "Frisch",
      "soon": "Bald ab",
      "expired": "Abgelaufen",
      "favorites": "Favoriten",
      "healthy": "Nur A/B"
    },
    "swap": {
      "title": "Gesündere Alternativen",
      "subtitle": "{n} Produkte mit niedrigem Nutri-Score",
      "added": "{name} zur Liste hinzugefügt",
      "dismiss": "Für mich ok",
      "dismissed": "Vorschlag ausgeblendet",
      "showHidden": "Ausgeblendete anzeigen ({n})",
      "hideHidden": "Ausblenden",
      "restore": "Wiederherstellen",
      "restored": "Vorschlag wiederhergestellt",
      "allDismissed": "Alle Vorschläge sind ausgeblendet"
    },
    "searchExtendedPlaceholder": "Suche Name, Kategorie oder Notiz…",
    "addToShopping": "Zur Einkaufsliste",
    "selectMultiple": "Auswählen",
    "selectAll": "Alle",
    "nSelected": "{n} ausgewählt",
    "bulkDeleted": "{n} Produkte gelöscht",
    "noResults": "Keine Treffer für die aktuellen Filter",
    "noExpiry": "Kein Ablaufdatum",
    "notes": "Notizen",
    "notesPlaceholder": "z. B. bio, geöffnet…",
    "foodScore": {
      "title": "Food Score",
      "subtitle": "Qualität deiner Vorratskammer",
      "info": {
        "title": "So wird der Food Score berechnet",
        "intro": "Der Score (0–100) bewertet, wie gesund und ausgewogen deine aktuelle Vorratskammer ist. Er setzt sich aus drei gewichteten Teilen zusammen:",
        "catBody": "Wie viele gesunde Kategorien du abdeckst (Gemüse, Obst, Fisch, Hülsenfrüchte, Vollkorn, Milchprodukte …) und wie hochwertig die Produkte sind. Ziel: mindestens 8 verschiedene gesunde Kategorien.",
        "medBody": "Wie gut dein Vorrat zur Mittelmeer-Ernährung passt: Gemüse, Fisch, Hülsenfrüchte und Olivenöl zählen positiv — Süßes und stark Verarbeitetes ziehen ab.",
        "freshBody": "Basiert auf den Ablaufdaten: Abgelaufenes zählt 0, in ≤3 Tagen ablaufende Produkte wenig, länger haltbare voll. Ohne Ablaufdaten zählt dieser Teil neutral (50).",
        "sparsity": "Hinweis: Bei weniger als 5 Produkten wird der Score anteilig reduziert, damit eine fast leere Vorratskammer nicht als \"ausgewogen\" gilt."
      },
      "freshnessHint": "Tipp: Füge deinen Produkten Ablaufdaten hinzu, damit die Frische-Wertung aussagekräftig wird — ohne Daten zählt sie neutral (50).",
      "verdict": {
        "excellent": "Ausgezeichnete Vorratskammer!",
        "balanced": "Deine Vorratskammer ist ausgewogen.",
        "improvable": "Du kannst die Vielfalt verbessern.",
        "poor": "Mehr Gemüse und Hülsenfrüchte hinzufügen.",
        "empty": "Füge Produkte hinzu, um deinen Score zu berechnen."
      },
      "sub": {
        "categories": "Vielfalt",
        "mediterranean": "Mediterran",
        "freshness": "Frische"
      },
      "breakdown": {
        "vegetables": "Gemüse",
        "fruit": "Obst",
        "fish": "Fisch",
        "legumes": "Hülsenfrüchte",
        "grains": "Getreide",
        "dairy": "Milchprodukte",
        "meat": "Fleisch",
        "eggs": "Eier"
      }
    }
  },
  "household": {
    "defaultName": "Unser Zuhause",
    "sharedPantry": "Gemeinsame Vorratskammer",
    "emptyTitle": "Seid ihr eine Familie?",
    "emptyHint": "Teilt die Vorratskammer mit allen, die mit euch einkaufen. Gruppe erstellen oder mit Code beitreten.",
    "createBtn": "Gruppe erstellen",
    "joinBtn": "Beitreten",
    "inviteCode": "Einladungscode:",
    "leaveBtn": "Gruppe verlassen",
    "leaveConfirmTitle": "Gruppe verlassen?",
    "leaveConfirmText": "Gemeinsame Produkte bleiben in der Gruppe. Bist du das letzte Mitglied, wird die Gruppe aufgelöst und die Vorräte gehören wieder dir persönlich.",
    "leaveConfirmBtn": "Verlassen",
    "codePlaceholder": "AB3D4E",
    "created": "Gruppe erstellt — teile den Code",
    "joined": "Du bist der Gruppe beigetreten",
    "left": "Du hast die Gruppe verlassen",
    "invalidCode": "Ungültiger Einladungscode"
  },
  "pantryFeed": {
    "title": "Aktuelle Aktivität",
    "action": {
      "add": "hat hinzugefügt",
      "update": "hat aktualisiert",
      "delete": "hat entfernt",
      "deduct": "hat verbraucht",
      "used_up": "hat aufgebraucht",
      "consumed": "hat als leer markiert",
      "restored": "hat wiederhergestellt",
      "undo": "hat den Verbrauch rückgängig gemacht von"
    }
  },
  "clientLang": {
    "preferred": "Bevorzugte Sprache"
  },
  "clientHero": {
    "status": {
      "excellent": "Auf gutem Kurs",
      "good": "Solide",
      "attention": "Aufmerksamkeit nötig",
      "unknown": "Neuer Nutzer"
    },
    "coachAi": "KI-Coach",
    "aiAnalysis": "KI-Analyse",
    "aiError": "KI-Analyse fehlgeschlagen",
    "copied": "Nachricht kopiert",
    "sendAsFeedback": "Als Feedback senden",
    "today": "Heute",
    "yesterday": "Gestern",
    "weeklyAdherence": "Wöchentliche Einhaltung",
    "avg": "Ø:",
    "strengths": "Stärken",
    "toImprove": "Zu verbessern",
    "suggestedMessage": "Vorgeschlagene Nachricht",
    "kpi": {
      "weight": "Gewicht",
      "calories": "Score",
      "protein": "Protein",
      "sleep": "Schlaf",
      "hrv": "HRV",
      "steps": "Schritte",
      "water": "Wasser",
      "workouts": "Training"
    },
    "trends": {
      "title": "Verlauf",
      "subtitle": "Letzte {days} Tage",
      "tabs": {
        "weight": "Gewicht",
        "sleep": "Schlaf",
        "kcal": "Kalorien"
      },
      "avg": "Ø",
      "target": "Ziel",
      "empty": "Keine Daten in diesem Zeitraum",
      "units": {
        "kg": "kg",
        "hours": "h",
        "kcal": "kcal"
      },
      "ranges": {
        "d7": "7T",
        "d14": "14T",
        "d30": "30T"
      }
    },
    "week": "Wo."
  },
  "mealBadges": {
    "excellent": "Top-Mahlzeit",
    "highProtein": "Proteinreich",
    "highFiber": "Ballaststoffreich",
    "lightSnack": "Leichter Snack",
    "lowProtein": "Wenig Protein",
    "lowFiber": "Wenig Gemüse",
    "highSugar": "Zu viel Zucker",
    "highSalt": "Zu salzig",
    "highSatFat": "Gesättigte Fette",
    "heavySnack": "Schwerer Snack"
  },
  "mealFilter": {
    "all": "Alle",
    "problems": "Nur Probleme",
    "warnings": "Zu verbessern",
    "counter": "{n} Mahlzeiten"
  },
  "adherence": {
    "title": "Einhaltungs-Zeitleiste",
    "subtitle": "Letzte {days} Tage",
    "avg": "Ø:",
    "empty": "Keine Daten"
  },
  "quickActions": {
    "chat": "Chat",
    "updatePlan": "Plan aktualisieren",
    "writeFeedback": "Feedback schreiben",
    "noMealToComment": "Keine Mahlzeit ohne Feedback"
  },
  "voiceFood": {
    "tap": "Per Stimme suchen",
    "listening": "Ich höre zu…",
    "processing": "Transkribiere…",
    "tapToStop": "Zum Stoppen tippen",
    "notSupported": "Dein Browser unterstützt kein Mikrofon",
    "micDenied": "Mikrofon nicht erlaubt",
    "tooShort": "Aufnahme zu kurz, versuch's erneut",
    "notRecognized": "Nicht verstanden, bitte wiederholen",
    "error": "Transkription fehlgeschlagen",
    "multiFound": "{n} Lebensmittel erkannt",
    "multiHint": "Tippe ein Eintrag zum Suchen und Loggen",
    "tapToSearch": "Zum Suchen tippen",
    "multiAllDone": "{n} Lebensmittel geloggt ✓",
    "moveTo": "Zu {name} verschieben",
    "moved": "Verschoben nach {name}"
  },
  "onboardingTutorial": {
    "skip": "Überspringen",
    "prev": "Zurück",
    "next": "Weiter",
    "start": "Loslegen",
    "loadError": "Tutorial konnte nicht geladen werden",
    "profileButton": "Tutorial erneut ansehen",
    "slides": {
      "welcome": {
        "hint": "50% Gemüse · 25% Protein · 25% Kohlenhydrate",
        "title": "Deine Reise beginnt hier",
        "body": "Willkommen bei Solano Essence. Kümmere dich elegant um deinen Körper — Teller für Teller."
      },
      "log": {
        "hint": "Stimme · KI-Foto · Suche",
        "title": "In Sekunden loggen",
        "body": "Sprich ins Mikrofon, fotografiere oder durchsuche unsere Solano-Datenbank mit über 5.000 Lebensmitteln."
      },
      "gamify": {
        "hint": "Streaks · Missionen · Status",
        "title": "Jede gute Gewohnheit zählt",
        "body": "Sammle Solano Points für Mahlzeiten, Training und Schlaf. Schalte Abzeichen frei und steige auf."
      },
      "sync": {
        "hint": "Automatisch, leise, immer aktuell",
        "title": "Synchronisiere deinen Körper",
        "body": "Verbinde Google Fit, Apple Health oder dein Wearable. Schritte, Schlaf und Training immer aktuell."
      },
      "start": {
        "hint": "Logge deine erste Mahlzeit",
        "title": "Du bist bereit",
        "body": "Dein KI-Coach ist an deiner Seite. Jeder kleine Schritt zählt — starten wir gemeinsam."
      }
    }
  },
  "rewards": {
    "navLabel": "Belohnungen",
    "title": "Deine Belohnungen",
    "subtitle": "Beständigkeit und Wohlbefinden, Tag für Tag",
    "totalSp": "Solano Points",
    "levelLabel": "Stufe",
    "nextLevel": "Nächster Status",
    "spToNext": "{n} SP bis {name}",
    "maxLevel": "Höchstes Level erreicht",
    "streakCurrent": "Serie",
    "streakLongest": "Bestwert",
    "todaySp": "Heute gesammelt",
    "dailyMissions": "Heutige Missionen",
    "dailyMissionsSub": "Alle 3 abschließen für {n} SP Bonus",
    "allCompletedBonus": "Tagesbonus freigeschaltet! +{n} SP",
    "weeklyMissions": "Wochenmissionen",
    "weeklyMissionsSub": "Alle 5 abschließen für {n} SP Bonus",
    "weeklyAllCompleted": "Wochenbonus freigeschaltet! +{n} SP",
    "weeklyRange": "Woche vom {start} bis {end}",
    "store": "Kosmetik-Store",
    "storeSub": "Verfügbare SP: {n}",
    "buy": "Kaufen",
    "purchased": "Gekauft",
    "insufficientSp": "Nicht genug SP",
    "confirmPurchase": "{name} für {cost} SP kaufen?",
    "purchaseSuccess": "🎉 Freigeschaltet!",
    "spGained": "SP verdient",
    "levelUpToast": "Neues Level: {name}!",
    "levelUpTitle": "Level freigeschaltet",
    "levelUpContinue": "Weiter",
    "personalizeTitle": "Profil personalisieren",
    "personalizeHint": "Nur gekaufte Kosmetik",
    "personalizeThemes": "Aktives Design",
    "personalizeBadges": "Angezeigte Abzeichen (max. 3)",
    "personalizeAnimations": "Animationen",
    "themeDefault": "Petrol (Standard)",
    "categoryTheme": "Design",
    "categoryBadge": "Exklusives Abzeichen",
    "categoryAnimation": "Animation",
    "itemNames": {
      "theme_forest": "Wald-Design",
      "theme_ocean": "Ozean-Design",
      "theme_sunset": "Sonnenuntergang",
      "theme_bianconero": "Schwarz-Gold",
      "theme_nerazzurro": "Blau-Schwarz",
      "theme_rossonero": "Rot-Schwarz",
      "theme_azzurro": "Italien-Blau",
      "theme_giallorosso": "Gelb-Rot",
      "theme_tricolore": "Italien-Tricolore",
      "theme_neon": "Neon Cyber",
      "theme_lavender": "Lavendel Wellness",
      "theme_rosegold": "Roségold",
      "theme_matcha": "Matcha",
      "theme_midnight": "Mitternacht",
      "badge_early_bird": "Goldener Sonnenaufgang",
      "badge_night_owl": "Nachteule",
      "badge_gourmet": "Gourmet",
      "anim_confetti_gold": "Gold-Konfetti",
      "anim_progress_glow": "Fortschritts-Leuchten",
      "anim_sparkle_rain": "Sternen-Regen",
      "anim_aura_pulse": "Aura-Puls",
      "anim_shimmer": "Glanz-Schimmer",
      "theme_summer": "Sommer-Türkis",
      "theme_halloween": "Halloween-Kürbis",
      "theme_christmas": "Weihnachts-Rot"
    },
    "itemDesc": {
      "default_theme": "Wendet diese Palette auf den Level-Hero, Fortschrittsbalken und alle Hauptgradienten in der App an.",
      "default_badge": "Ein exklusives Abzeichen, das auf deinem Profil erscheint.",
      "default_animation": "Ein animierter Effekt, der deine Erfolge zum Leben erweckt.",
      "theme_forest": "Tiefes Waldgrün mit frischem Blattgrün-Akzent — ruhig und naturverbunden.",
      "theme_ocean": "Tiefblaue Ozean-Töne mit türkisem Wellen-Akzent.",
      "theme_sunset": "Warmer Sonnenuntergang von Orange über Pink bis Violett.",
      "theme_bianconero": "Klassisch Schwarz-Weiss mit Silber-Akzent — elegant und zeitlos.",
      "theme_nerazzurro": "Nachtblau und Schwarz mit eisblauem Akzent.",
      "theme_rossonero": "Kraftvolles Rot-Schwarz mit goldenem Akzent.",
      "theme_azzurro": "Strahlendes Azurblau mit hellem Himmels-Akzent.",
      "theme_giallorosso": "Warmes Gelb-Rot im satten Verlauf mit Gold-Akzent.",
      "anim_sparkle_rain": "Funkelnde Sterne regnen sanft über deine Fortschritts-Karte.",
      "anim_confetti_gold": "Goldenes Konfetti regnet bei jedem Level-Aufstieg über deinen Bildschirm.",
      "anim_progress_glow": "Dein Fortschrittsbalken pulsiert mit einem sanften Leuchten.",
      "anim_aura_pulse": "Eine pulsierende Aura umgibt dein Level-Symbol.",
      "anim_shimmer": "Ein edler Lichtglanz wandert immer wieder über deine Fortschritts-Karte.",
      "theme_summer": "Lagunen-Türkis mit Sonnengelb — limitiertes Sommer-Design, nur Juni bis August erhältlich.",
      "theme_halloween": "Kürbis-Orange glüht aus dem lila Nachthimmel — limitiert, nur rund um Halloween erhältlich. 🎃",
      "theme_christmas": "Festliches Weihnachts-Rot mit Tannengrün und Gold — limitiert, nur in der Adventszeit erhältlich.",
      "theme_tricolore": "Italienische Flagge: Grün-Weiß-Rot in einem klaren Verlauf mit Smaragd-Akzent.",
      "theme_neon": "Cyberpunk-Vibes: tiefes Violett, Magenta und Elektroblau. Futuristischer Look.",
      "theme_lavender": "Lavendel- und Pflaumentöne für ein ruhiges, entspanntes Gefühl.",
      "theme_rosegold": "Elegantes Roségold mit Champagner-Akzent. Chic und raffiniert.",
      "theme_matcha": "Matcha-Grün mit Creme-Akzent. Inspiriert von der japanischen Teezeremonie.",
      "theme_midnight": "Tiefes Mitternachtsblau mit Sternenglanz. Perfekt für den Abend."
    },
    "previewLabel": "Theme-Vorschau",
    "seasonalTag": "Limitiert",
    "seasonalLocked": "Saison-Design — erhältlich nur {window}",
    "weeklyNames": {
      "wk_workouts_5": "5 Trainings",
      "wk_plates_5": "5 exzellente Teller",
      "wk_sleep_6": "6 Nächte über 7h",
      "wk_fiber_5": "5 Tage mit 30g Ballaststoffen",
      "wk_steps_60k": "60.000 Schritte"
    },
    "syncFit": "Google Fit synchronisieren",
    "syncFitHint": "Heute keine Schritte — jetzt synchronisieren",
    "syncing": "Synchronisiere…",
    "syncOk": "Daten synchronisiert",
    "syncFailed": "Synchronisierung fehlgeschlagen",
    "badges": "Abzeichen",
    "earnedBadges": "{n} freigeschaltet",
    "lockedBadges": "{n} zu erreichen",
    "recentActivity": "Neueste Aktivität",
    "empty": "Noch keine Ereignisse",
    "widgetTitle": "Fortschritt",
    "widgetCta": "Belohnungen öffnen",
    "viewAll": "Alles anzeigen",
    "congratsBadge": "Neues Abzeichen!",
    "levelUp": "Neuer Status erreicht!",
    "states": {
      "newStart": {
        "name": "Neuanfang",
        "quote": "Jede große Veränderung beginnt mit einem kleinen Schritt."
      },
      "inBalance": {
        "name": "Im Gleichgewicht",
        "quote": "Du baust gesunde Gewohnheiten auf."
      },
      "activeWellness": {
        "name": "Aktives Wohlbefinden",
        "quote": "Dein Lebensstil verbessert sich."
      },
      "steadyShape": {
        "name": "Beständige Form",
        "quote": "Beständigkeit ist deine Stärke."
      },
      "totalEnergy": {
        "name": "Volle Energie",
        "quote": "Dein Körper dankt es dir."
      },
      "eliteHealth": {
        "name": "Elite-Gesundheit",
        "quote": "Du hast ein höheres Wohlbefinden erreicht."
      },
      "ambassador": {
        "name": "Botschafter",
        "quote": "Du bist ein Vorbild für Disziplin."
      },
      "legend": {
        "name": "Legende",
        "quote": "Exzellenz ist dein Lebensstil geworden."
      },
      "master": {
        "name": "Meister",
        "quote": "Du beherrschst deine Gewohnheiten – nicht umgekehrt."
      },
      "champion": {
        "name": "Champion",
        "quote": "Beständigkeit auf höchstem Niveau."
      },
      "inspiration": {
        "name": "Inspiration",
        "quote": "Dein Weg motiviert andere."
      },
      "diamond": {
        "name": "Diamant",
        "quote": "Unter Druck gewachsen, unzerbrechlich geworden."
      },
      "titan": {
        "name": "Titan",
        "quote": "Deine Disziplin kennt keine Grenzen."
      },
      "olymp": {
        "name": "Olymp",
        "quote": "Du spielst in einer eigenen Liga."
      },
      "immortal": {
        "name": "Unsterblich",
        "quote": "Deine Gewohnheiten sind für die Ewigkeit."
      }
    },
    "badgeNames": {
      "meals_30": "30 Mahlzeiten geloggt",
      "meals_100": "100 Mahlzeiten geloggt",
      "water_100_days": "100 hydrierte Tage",
      "steps_100k": "100k Schritte",
      "steps_1m": "1 Mio. Schritte",
      "workouts_50": "50 Trainings",
      "workouts_100": "100 Trainings",
      "sleep_30": "30 Nächte à 7h",
      "streak_30": "30 Tage Serie",
      "streak_100": "100 Tage Serie",
      "first_month": "Erster Monat",
      "first_year": "Erstes Jahr",
      "protein_30": "30 Tage Protein OK",
      "fiber_30": "30 Tage Ballaststoffe OK",
      "learn_streak_7": "7 Tage Lernsträhne",
      "learn_streak_30": "30 Tage Lernsträhne",
      "learn_correct_50": "50 richtige Quiz-Antworten"
    },
    "missionNames": {
      "protein_meal25": {
        "title": "Protein clever verteilen",
        "hint": "Bei einer Mahlzeit mindestens 25 g Protein erreichen."
      },
      "protein_daily": {
        "title": "Protein-Tagesziel",
        "hint": "Erreiche dein persönliches Protein-Tagesziel."
      },
      "veg_2p": {
        "title": "Gemüse x2",
        "hint": "Trage heute zwei Portionen Gemüse ein."
      },
      "fruit_2p": {
        "title": "Obst x2",
        "hint": "Trage heute zwei Portionen Obst ein."
      },
      "fiber_target": {
        "title": "Ballaststoff-Ziel",
        "hint": "Erreiche dein persönliches Ballaststoffziel."
      },
      "plate_balanced": {
        "title": "Solano-Teller",
        "hint": "Ausgewogen: 50% Gemüse, 25% Protein, 25% Kohlenhydrate."
      },
      "steps_target": {
        "title": "Schrittziel erreichen",
        "hint": "Erreiche dein persönliches Schrittziel."
      },
      "active_min_20": {
        "title": "20 aktive Minuten",
        "hint": "Mindestens 20 Minuten Bewegung heute."
      },
      "workout_done": {
        "title": "Training abschließen",
        "hint": "Beende dein geplantes Training."
      },
      "rest_day_walk": {
        "title": "Regenerations-Spaziergang",
        "hint": "Ruhetag? Mindestens 3.000 leichte Schritte."
      },
      "water_target": {
        "title": "Wasserziel erreichen",
        "hint": "Erreiche dein persönliches Wasserziel."
      },
      "log_all_meals": {
        "title": "Alle Mahlzeiten eintragen",
        "hint": "Frühstück, Mittag und Abend — alle 3."
      },
      "day_checkin": {
        "title": "Tages-Check-in",
        "hint": "Schließe deinen Tages-Check-in ab."
      },
      "sleep_logged": {
        "title": "Schlafdauer eintragen",
        "hint": "Trage deine letzte Schlafdauer ein."
      },
      "protein_bkfst30": {
        "title": "30g Protein zum Frühstück",
        "hint": "Eier, griech. Joghurt oder Whey zur 1. Mahlzeit."
      },
      "water_2l": {
        "title": "2 Liter Wasser trinken",
        "hint": "Ein Glas pro Stunde hält den Rhythmus."
      },
      "steps_8k": {
        "title": "8.000 Schritte",
        "hint": "Ein 30-min Spaziergang plus Treppen."
      },
      "fiber_30g": {
        "title": "30g Ballaststoffe",
        "hint": "Gemüse zu Mittag/Abend + Obst und Hülsenfrüchte."
      },
      "sleep_7h": {
        "title": "7h Schlaf",
        "hint": "Bildschirme 30 Min vor dem Schlafen aus."
      }
    },
    "swap": "Tauschen",
    "swapDone": "Mission getauscht",
    "swapTooltip": "Diese Mission gegen eine andere aus derselben Kategorie tauschen",
    "swapUsedTooltip": "Du hast deinen täglichen Tausch bereits genutzt",
    "actions": {
      "meal_log": "Mahlzeit geloggt",
      "meal_photo_bonus": "Foto der Mahlzeit",
      "plate_check_80": "Ausgewogener Teller-Check (80%+)",
      "plate_balanced": "Ausgewogener Teller",
      "water_goal": "Wasser-Ziel",
      "steps_goal": "Schritte-Ziel",
      "workout_done": "Training",
      "sleep_7h": "Nacht mit 7h+",
      "learn_pill": "Tipp gelesen",
      "diary_complete": "Tagebuch komplett",
      "streak_bonus": "Serien-Bonus",
      "daily_bonus": "Missions-Bonus",
      "weekly_bonus": "Wochen-Bonus",
      "purchase": "Store-Kauf"
    }
  },
  "cook": {
    "title": "Was koche ich?",
    "subtitle": "{n} Ideen aus deiner Vorratskammer",
    "haveAll": "Alles vorhanden",
    "oneMissing": "1 Zutat fehlt",
    "manyMissing": "Mehrere Zutaten fehlen",
    "missing": "{n} fehlt",
    "addMissing": "Fehlende in Liste",
    "addedToList": "{n} zur Liste",
    "cook": "Kochen"
  },
  "shopping": {
    "title": "Einkaufsliste",
    "empty": "Liste ist leer",
    "emptyHint": "Füge hinzu, was du brauchst, oder warte bis Vorräte aufgebraucht sind.",
    "itemsCount": "{n} Artikel zu kaufen",
    "section": {
      "auto": "Nachkaufen",
      "manual": "Du hast hinzugefügt"
    },
    "reason": {
      "consumed": "Aufgebraucht",
      "expired": "Abgelaufen",
      "weeklyMenu": "Aus dem Wochenmenü",
      "shoppingCheck": "Aus dem Einkaufs-Check"
    },
    "restockHint": "Empfohlen: {qty} · reicht ~{days}T",
    "addPlaceholder": "Artikel hinzufügen (z. B. Milch)…",
    "boughtBtn": "Gekauft",
    "checkedByScan": "Abgehakt",
    "movedToPantry": "{name} → in den Vorrat gelegt",
    "expiry": {
      "title": "{name} gekauft",
      "body": "Haltbar bis? Optional – hält den Frische-Score im Vorrat aktuell.",
      "d3": "+3 Tage",
      "w1": "+1 Woche",
      "w2": "+2 Wochen",
      "m1": "+1 Monat",
      "until": "Haltbar bis {date}",
      "skip": "Ohne Datum",
      "save": "In den Vorrat"
    },
    "uncheckBtn": "Wieder auf die Liste",
    "notNeededBtn": "Nicht nötig",
    "shareBtn": "Liste teilen",
    "copied": "Liste in die Zwischenablage kopiert",
    "restocked": "{name} wieder in der Vorratskammer",
    "importAll": "Alle in Vorrat übernehmen",
    "importedAdded": "{n} neu",
    "importedMerged": "{n} aktualisiert",
    "importedRestocked": "{n} aufgefüllt",
    "importedNothing": "Nichts zu übernehmen",
    "addedToList": "Zur Einkaufsliste hinzugefügt"
  },
  "weekly": {
    "title": "Wochenmenü",
    "servings": "Port.",
    "subtitle": "7 Tage abgestimmt auf deine Ziele",
    "generate": "Menü generieren",
    "regenerate": "Neu generieren",
    "generated": "Menü erstellt!",
    "generatedWithList": "Menü fertig! Fehlende Zutaten wurden zu deiner Einkaufsliste hinzugefügt.",
    "viewShoppingList": "Liste ansehen",
    "autoSyncedHint": "Zutaten, die nicht in der Vorratskammer sind, wurden automatisch zur Einkaufsliste hinzugefügt.",
    "generatedAt": "Erstellt",
    "emptyHint": "Du hast noch kein Menü. Tippe 'Menü generieren', um ein passendes zu erstellen.",
    "shoppingList": "Einkaufsliste",
    "addToPantry": "Zur Vorratskammer",
    "importedShopping": "Einkauf zur Vorratskammer hinzugefügt",
    "tapToBuy": "Tippe ein Produkt an, um es als gekauft zu markieren und in die Vorratskammer zu übernehmen",
    "movedToPantry": "In die Vorratskammer verschoben",
    "print": "Drucken",
    "printMenu": "Menü drucken",
    "printMenuShort": "Menü",
    "share": "Teilen",
    "copied": "Einkaufsliste in die Zwischenablage kopiert",
    "allBought": "Alles gekauft!",
    "popupBlocked": "Pop-up blockiert — bitte Pop-ups zulassen, um zu drucken",
    "focusMode": "Einkaufsmodus",
    "focusModeShort": "Einkaufen",
    "showDone": "Erledigte zeigen",
    "hideDone": "Erledigte ausblenden",
    "voiceStart": "Per Sprache abhaken",
    "voiceStop": "Aufnahme stoppen",
    "voiceListening": "Höre zu…",
    "voiceNoMatch": "Nicht gefunden",
    "voiceError": "Mikrofon-Fehler",
    "voiceUnsupported": "Dein Browser unterstützt keine Spracherkennung",
    "mealLoading": "Vollständiges Rezept wird erstellt…",
    "ingredients": "Zutaten",
    "procedure": "Zubereitung",
    "fiber": "Ballaststoffe"
  },
  "shoppingAisle": {
    "produce": "Obst & Gemüse",
    "meatFish": "Fleisch & Fisch",
    "dairyEggs": "Milchprodukte & Eier",
    "bakery": "Backwaren",
    "pantry": "Vorratskammer (trocken)",
    "frozen": "Tiefkühl",
    "supplements": "Proteine & Nahrungsergänzung",
    "beverages": "Getränke",
    "other": "Sonstiges"
  },
  "wearables": {
    "empty": "Noch keine Wearable-Daten. Verbinde ein Gerät, um Recovery, HRV, Schlaf und mehr zu sehen.",
    "sleep": "Schlaf",
    "hrv": "HRV",
    "restingHr": "Ruhepuls",
    "strain": "Belastung",
    "sleepChart": "Schlaf (Stunden/Nacht)",
    "hrvChart": "HRV (ms)",
    "syncNow": "Jetzt synchronisieren",
    "syncing": "Synchronisiere…",
    "syncOk": "{n} Tage aktualisiert",
    "syncEmpty": "Keine neuen Daten",
    "lastSync": "Letzte Sync:",
    "neverSynced": "Noch nicht synchronisiert",
    "title": "Wearable & Health",
    "connectDevice": "Gerät verbinden",
    "deviceConnected": "{n} verbundenes Gerät",
    "devicesConnected": "{n} verbundene Geräte",
    "supportedList": "WHOOP · Garmin · Fitbit · Oura · Polar · Withings · Google Fit · Peloton · Apple Health",
    "connectBtn": "Verbinden",
    "addBtn": "Hinzufügen",
    "sdkError": "SDK nicht geladen — wird in einer neuen Seite geöffnet",
    "providerConnected": "{p} verbunden",
    "deviceConnectedToast": "Gerät verbunden",
    "connectWhoopDirect": "WHOOP direkt verbinden",
    "noDataYet": "Noch keine Daten",
    "agingToast": "{p} sendet seit über 1 Stunde keine Daten mehr — jetzt synchronisieren",
    "autoSyncing": "Automatische Synchronisation…",
    "autoSyncFailed": "Automatische Sync für {p} fehlgeschlagen",
    "rel": {
      "sec": "vor {n}s",
      "min": "vor {n}m",
      "hr": "vor {n}h",
      "day": "vor {n}T"
    },
    "tapToConnect": "Tippe auf Hinzufügen, um ein Wearable zu verbinden und Schlaf, HRV und Aktivität zu synchronisieren"
  },
  "streaks": {
    "title": "Streak",
    "diary": "Tagebuch",
    "weight": "Gewicht",
    "water": "Wasser",
    "daysShort": "T",
    "memberSince": "Dabei seit",
    "activeDays": "aktive Tage",
    "keepItUp": "Weiter so!",
    "badgeUnlockOne": "In 1 Tag schaltest du das Badge {name} frei",
    "badgeUnlockMany": "In {n} Tagen schaltest du das Badge {name} frei",
    "badge_seed": "Keimling",
    "badge_bronze": "Bronze",
    "badge_silver": "Silber",
    "badge_gold": "Gold",
    "badge_diamond": "Diamant",
    "badge_legend": "Legende"
  },
  "chat": {
    "title": "Chat",
    "subtitleClient": "Schreib deiner Ernährungsberatung",
    "subtitleNut": "Antworte deinen Nutzer",
    "noClients": "Noch keine Nutzer",
    "noMessages": "Noch keine Nachrichten. Schreib die erste!",
    "linkNutFirst": "Verbinde eine Ernährungsberatung, um zu chatten",
    "selectClient": "Nutzer auswählen",
    "messagePh": "Nachricht schreiben…"
  },
  "progressPhotos": {
    "title": "Fortschrittsfotos",
    "subtitle": "Vorne, seitlich, hinten — im Zeitverlauf vergleichen",
    "front": "Vorne",
    "side": "Seitlich",
    "back": "Hinten",
    "photoBtn": "Foto",
    "empty": "Noch keine Fotos.",
    "emptyHint": "Tippe, um dein erstes Foto hinzuzufügen",
    "saved": "Foto gespeichert",
    "latest": "Neueste Fotos",
    "timeline": "Verlauf",
    "compare": "Vergleichen",
    "openCompare": "Ausgewählte vergleichen",
    "compareTitle": "Vergleich"
  },
  "igImport": {
    "title": "Aus Instagram importieren",
    "subtitle": "Füge die Beschreibung eines deiner Posts ein — die KI erstellt das Rezept mit USDA/CREA-Makros.",
    "urlLabel": "Post-Link (optional)",
    "urlHint": "Nützlich, um die Quelle später wiederzufinden.",
    "captionLabel": "Beschreibung des Posts",
    "captionPh": "Füge hier den Instagram-Text ein (Emojis und Hashtags eingeschlossen)…",
    "captionHint": "Optional, wenn du ein Foto hochlädst (z.B. Rezept-Infografik) – die KI liest das Rezept dann direkt aus dem Bild.",
    "photoLabel": "Foto des Gerichts (optional)",
    "photoPick": "Ziehe oder tippe, um ein Foto auszuwählen",
    "photoOptional": "Empfohlen: hilft der KI das Gericht zu verstehen",
    "analyzeBtn": "Mit KI analysieren",
    "analyzing": "Die KI liest dein Rezept…",
    "analyzingHint": "Wir extrahieren Name, Zutaten, Zubereitung und berechnen Makros aus der Solano-Datenbank.",
    "back": "Text bearbeiten",
    "cancel": "Abbrechen",
    "saveBtn": "Rezept speichern (öffentlich)",
    "saved": "Rezept importiert und veröffentlicht",
    "fName": "Rezeptname",
    "fMealType": "Mahlzeit",
    "fServings": "Portionen",
    "fDesc": "Beschreibung",
    "fIngredients": "Zutaten",
    "fInstructions": "Zubereitung",
    "ingHint": "Eine pro Zeile, mit Menge und Einheit (z. B. 80g Pasta, 1 Ei)",
    "macrosPreview": "Makros pro Portion",
    "macrosComputed": "Aus der Lebensmittel-Datenbank berechnet",
    "perServing": "Portion",
    "errImageOnly": "Du kannst nur Bilder hochladen",
    "errTooBig": "Bild zu groß, wähle ein kleineres",
    "errCaptionShort": "Die Beschreibung ist zu kurz",
    "errNeedInput": "Füge einen Text ein ODER lade ein Rezept-Foto hoch",
    "errAnalyze": "Analyse fehlgeschlagen. Bitte erneut versuchen."
  },
  "recipes": {
    "qrScanBtn": "QR scannen",
    "qrScanTitle": "QR-Code scannen",
    "qrScanHint": "Richte die Kamera auf den QR-Code eines Freundes (Rezept oder Mahlzeit)",
    "qrInvalid": "Kein gültiger Solano-QR-Code",
    "qrCameraError": "Kamera nicht verfügbar. Bitte Kamera-Zugriff erlauben.",
    "quickActionQr": "QR-Code",
    "qrTitle": "Per QR-Code teilen",
    "qrHint": "Scannen öffnet das Rezept direkt — mit App auf dem Handy in der App.",
    "qrCopyLink": "Link kopieren",
    "goalScore": {
      "title": "Ziel-Score",
      "goals": {
        "dimagrimento": "Abnehmen",
        "mantenimento": "Gewicht halten",
        "massa": "Muskelaufbau"
      },
      "bands": {
        "very_good": "Sehr gut geeignet",
        "good": "Gut geeignet",
        "conditional": "Bedingt geeignet",
        "less_suited": "Weniger geeignet"
      },
      "reasons": {
        "protein_rich": "Proteinreich",
        "satiating": "Sättigend bei moderaten Kalorien",
        "fiber_rich": "Reich an Ballaststoffen",
        "veg_rich": "Hoher Gemüse-/Obstanteil",
        "kcal_fits": "Kalorien passen zu dieser Mahlzeit",
        "good_for_muscle": "Gute Mahlzeit für den Muskelaufbau",
        "kcal_high_for_goal": "Für dein Ziel etwas kalorienreich",
        "kcal_low_for_goal": "Für den Aufbau etwas kalorienarm",
        "salt_high": "Salzgehalt relativ hoch",
        "sugar_high": "Zuckergehalt relativ hoch",
        "satfat_high": "Viele gesättigte Fettsäuren",
        "protein_low": "Wenig Protein",
        "over_budget_today": "Übersteigt dein heutiges Restbudget",
        "balanced_ok": "Insgesamt ausgewogen"
      }
    },
    "nutritionBasisLabel": "Nährwerte pro Portion",
    "nutritionBasisScaled": "Nährwerte für {n} Portionen",
    "seasoningEstimateHint": "Gewürze/Salz „nach Geschmack“ sowie optionale Zutaten sind nicht exakt eingerechnet",
    "partialEstimateBadge": "Nährwerte teilweise geschätzt",
    "highSaltWarning": "Hoher Salzgehalt",
    "matchedCount": "{a} von {b} Zutaten vollständig berechnet",
    "reviewNeeded": "Nährwerte unvollständig — bitte Zutaten prüfen",
    "reviewUnmatched": "Nicht erkannt",
    "fixBtn": "Zutaten prüfen & korrigieren",
    "editIngredients": "Bearbeiten",
    "fillAmounts": "Mengen ergänzen",
    "fillAmountsHint": "Einige Zutaten haben keine Menge – mit typischen Mengen & Nährwerten aus der Datenbank auffüllen.",
    "fillAmountsDone": "{n} Zutat(en) mit typischen Mengen ergänzt – bitte kurz prüfen",
    "fillAmountsNone": "Alle Zutaten haben bereits eine Menge",
    "livePerServing": "pro Portion",
    "liveTotal": "gesamt",
    "liveCalculating": "Berechne…",
    "fixTitle": "Zutaten korrigieren",
    "fixSubtitle": "Bearbeite die Zutaten, bis alle erkannt werden. Beim Speichern werden die Nährwerte automatisch neu berechnet.",
    "fixMatched": "Erkannt",
    "fixUnmatched": "Nicht erkannt — bearbeite den Text oder wähle über die Lupe ein Lebensmittel aus der Datenbank",
    "fixNegligible": "Vernachlässigbar (Wasser/Gewürz)",
    "fixPickFood": "Aus Datenbank wählen",
    "fixSearchPlaceholder": "Lebensmittel suchen…",
    "fixNoResults": "Keine Treffer",
    "fixSuggestion": "Meintest du",
    "fixAdd": "Zutat hinzufügen",
    "fixSearchDb": "Treffer suchen",
    "fixUnknownCount": "{n} Zutat(en) nicht erkannt – gelb markiert, per Tipp Datenbank-Treffer wählen",
    "fixServings": "Portionen",
    "fixSave": "Speichern & neu berechnen",
    "fixSaving": "Berechne…",
    "fixSavedOk": "Rezept aktualisiert — Nährwerte neu berechnet",
    "fixSavedStillReview": "Gespeichert — einige Zutaten wurden weiterhin nicht erkannt",
    "fixError": "Aktualisierung fehlgeschlagen",
    "cuisineTitle": "Wunsch-Küchen (optional)",
    "cuisineNames": {
      "asian": "Asiatisch",
      "mediterranean": "Mediterran",
      "oriental": "Orientalisch",
      "mexican": "Mexikanisch",
      "indian": "Indisch",
      "japanese": "Japanisch",
      "thai": "Thailändisch",
      "southamerican": "Südamerikanisch"
    },
    "title": "Rezepte",
    "subtitle": "Speichere deine Lieblingsrezepte mit Kalorien und Makros",
    "newRecipe": "Neues Rezept",
    "importInstagram": "Aus Instagram",
    "photoGenerate": "KI-Foto erzeugen",
    "photoRegenerate": "KI-Foto neu erzeugen",
    "photoGenerating": "Foto wird erzeugt…",
    "photoGenerated": "Foto erzeugt",
    "photoBatchStart": "KI-Fotos erzeugen ({n} fehlen)",
    "photoBatchRunning": "{done}/{total} werden erzeugt…",
    "photoBatchDone": "{n} Fotos erzeugt 🎉",
    "trBanner": "{n} Rezepte noch nicht in deiner Sprache",
    "trBatchBtn": "Alle übersetzen",
    "trBatchRunning": "Übersetze {done}/{total}…",
    "trBatchDone": "{n} Rezepte übersetzt 🎉",
    "saveRecipe": "Rezept speichern",
    "addBtn": "Hinzufügen",
    "libraryBadge": "Bibliothek",
    "addToDiary": "Zum Tagebuch",
    "byAuthor": "von",
    "confirmDeleteOther": "Rezept eines anderen Nutzers löschen? Diese Aktion ist unwiderruflich.",
    "deleted": "Rezept gelöscht",
    "more": "weitere…",
    "microSugar": "Zucker",
    "microFiber": "Ballaststoffe",
    "microSat": "Gesättigte Fettsäuren",
    "microSalt": "Salz",
    "folderAll": "Alle",
    "folderFavorites": "Favoriten",
    "folderBreakfast": "Frühstück",
    "folderSnack": "Snack",
    "folderLunch": "Mittag",
    "folderAfternoon": "Nachmittag",
    "folderDinner": "Abend",
    "folderSauce": "Sauce / Dressing",
    "collectionsTitle": "Sammlungen",
    "collectionsNew": "Neu",
    "collectionsCreateTitle": "Neue Sammlung",
    "collectionsEditTitle": "Sammlung bearbeiten",
    "collectionsNamePh": "Name (z. B. Meal-Prep)",
    "collectionsEmojiLabel": "Symbol",
    "collectionsColorLabel": "Farbe",
    "collectionsCreateBtn": "Erstellen",
    "collectionsSaveBtn": "Speichern",
    "collectionsDeleteConfirm": "Sammlung löschen? Die Rezepte bleiben in deiner Bibliothek.",
    "collectionsAddTo": "Zu Sammlung",
    "collectionsAddToTitle": "In Sammlungen speichern",
    "collectionsCreated": "Sammlung erstellt",
    "collectionsDeleted": "Sammlung gelöscht",
    "sauceAiBtn": "Saucen mit KI vorschlagen",
    "sauceAiHint": "Passend zu deinen Rezepten und deinem Vorrat — salzarm und mit exakten Mengen",
    "sauceAiDone": "3 neue Saucen/Dressings erstellt",
    "recipeSingular": "Rezept",
    "recipePlural": "Rezepte",
    "emptyLibrary": "Noch keine Rezepte",
    "emptyFolder": "Hier ist noch nichts",
    "emptyFolderHint": "Füge ein Rezept in diesen Ordner hinzu oder wähle einen anderen.",
    "emptyFavorites": "Noch keine Favoriten",
    "emptyFavoritesHint": "Tippe auf das Herz eines Rezepts, um es hier für 1-Klick-Nutzung zu speichern.",
    "favoriteAdded": "Zu Favoriten hinzugefügt",
    "favoriteRemoved": "Aus Favoriten entfernt",
    "favoriteAdd": "Zu Favoriten hinzufügen",
    "favoriteRemove": "Aus Favoriten entfernen",
    "ingredients": "Zutaten",
    "preparation": "Zubereitung",
    "person": "Person",
    "people": "Personen",
    "servingsHint": "Portionen beim Hinzufügen zum Tagebuch ändern",
    "portion": "Portion",
    "logPreview": "Wird deinem Tagebuch hinzugefügt",
    "logPreviewAdapted": "Die angepassten kcal werden deinem Tagebuch hinzugefügt",
    "servingsOfHint": "Von {total} Rezept-Portionen (Mengen sind bereits skaliert)",
    "scaledForPeople": "Skaliert für {n} Personen",
    "visibilityTitle": "Wer sieht dieses Rezept",
    "visibilityPrivate": "Nur ich",
    "visibilityNutritionist": "Mein Ernährungsberater",
    "visibilityPublic": "Alle",
    "visibilityPrivateShort": "Privat",
    "visibilityNutritionistShort": "Berater",
    "visibilityHint": "Kannst du jederzeit ändern. „Alle“-Rezepte landen in der öffentlichen Bibliothek.",
    "visibilityUpdated": "Sichtbarkeit aktualisiert",
    "useAdjustHint": "Gramm anpassen, wenn du andere Mengen gegessen hast",
    "useAdjustedNotice": "Kalorien werden aus den angepassten Zutaten neu berechnet",
    "aiGenerateBtn": "5 mit KI erstellen",
    "aiGenerating": "Erstelle…",
    "aiGeneratedOk": "5 Rezepte mit KI erstellt!",
    "aiError": "KI-Fehler",
    "aiPromptTitle": "Rezepte mit KI erstellen",
    "aiPromptDesc": "Beschreibe, was du möchtest (optional). Die KI erstellt 5 Rezepte passend zu deiner Anfrage.",
    "aiPromptPlaceholder": "z.B. Menü unter 500 kcal, glutenfrei, schnell zubereitet…",
    "aiPromptGenerate": "5 Rezepte erstellen",
    "aiChipUnder500": "unter 500 kcal",
    "aiChipHighProtein": "eiweißreich",
    "aiChipVegetarian": "vegetarisch",
    "aiChipGlutenFree": "glutenfrei",
    "aiChipQuick": "in 15 Min fertig",
    "adaptBtn": "Kcal anpassen",
    "adaptTitle": "Rezept anpassen",
    "adaptDesc": "Aktuelles Rezept: {current} kcal pro Portion. Gib deine Wunsch-Kalorien ein und ich passe die Mengen an.",
    "adaptTargetLabel": "Ziel-Kcal pro Portion",
    "adaptConfirm": "Anpassen",
    "adapting": "Passe an…",
    "adaptedOk": "Rezept angepasst",
    "adaptError": "Anpassung nicht möglich",
    "adaptInvalidKcal": "Gib einen gültigen Kcal-Wert ein",
    "restoreOriginal": "Original wiederherstellen",
    "verifiedBadge": "Nährwerte geprüft",
    "infographicBtn": "Rezept",
    "infographicBusy": "Erstelle…",
    "infographicDone": "Infografik gespeichert!",
    "infographicServings": "Portionen",
    "infographicNutrition": "Nährwerte pro Portion",
    "infographicIngredients": "Hauptzutaten",
    "infographicSteps": "Zubereitung",
    "recipeMenuShare": "Teilen",
    "recipeMenuDuplicate": "Rezept duplizieren",
    "recipeMenuDelete": "Löschen",
    "showAllIngredients": "Alle Zutaten anzeigen",
    "linkCopied": "Link kopiert",
    "difficultyEasy": "Einfach",
    "difficultyMedium": "Mittel",
    "difficultyHard": "Schwer",
    "quickActionShare": "Teilen",
    "shareMenuLink": "Link teilen",
    "shareMenuLinkHint": "WhatsApp, Nachrichten, E-Mail …",
    "shareMenuSocial": "Für Social Media teilen",
    "shareMenuSocialShort": "Social",
    "shareMenuSocialHint": "Bild + Text für Instagram, TikTok & Co.",
    "socialShareTitle": "Für Social Media teilen",
    "socialFormatSquare": "Quadrat 1:1",
    "socialFormatStory": "Story 9:16",
    "socialFormatPortrait": "Beitrag 4:5",
    "socialFormatHintPortrait": "Beitrag: im Instagram-Teilen „Beitrag“ wählen – 4:5 passt ohne Zuschneiden.",
    "socialFullRecipeInApp": "Ganzes Rezept nur in der App",
    "socialCaption": "KI-Text",
    "socialCaptionBusy": "Text wird erstellt …",
    "socialCaptionError": "Text konnte nicht erstellt werden",
    "socialCaptionHint": "Instagram & TikTok übernehmen den Text nicht automatisch – beim Teilen wird er in die Zwischenablage kopiert, einfach einfügen.",
    "socialCaptionInClipboard": "Text kopiert – in der App einfügen",
    "socialRegenerate": "Neu",
    "socialCopy": "Kopieren",
    "socialCopied": "Text kopiert",
    "socialShareBtn": "Bild teilen",
    "socialBusy": "Bild wird erstellt …",
    "socialDownloaded": "Bild gespeichert",
    "socialMadeWith": "Erstellt mit Solano Essence",
    "socialPhotoFailed": "Rezeptfoto konnte nicht eingebettet werden – Karte ohne Foto erstellt.",
    "socialFormatHintStory": "Story/Reel: im Instagram-Teilen „Story“ wählen – 9:16 passt ohne Zuschneiden.",
    "socialFormatHintSquare": "Quadrat: Bild gedrückt halten → in Fotos sichern → in Instagram als Beitrag posten.",
    "socialLongPressHint": "Tipp: Bild gedrückt halten, um es in Fotos zu sichern.",
    "socialShareFailedHint": "Teilen nicht möglich – halte das Bild gedrückt, um es zu sichern.",
    "quickActionShoppingList": "Einkaufsliste",
    "quickActionDuplicate": "Duplizieren",
    "addedToShoppingList": "Zutaten zur Liste hinzugefügt",
    "privacyPrivateDesc": "Nur für dich sichtbar.",
    "privacyNutritionistDesc": "Mit deinen Nutzer geteilt.",
    "privacyPublicDesc": "Für die ganze Solano-Community sichtbar.",
    "addedToDiaryFlash": "Zum Tagebuch hinzugefügt",
    "healthScoreTitle": "Health Score",
    "healthScoreGreat": "Sehr ausgewogen",
    "healthScoreGood": "Ausgewogen",
    "healthScoreImprove": "Überdenken",
    "goalFitTitle": "Geeignet für",
    "goalWeightLoss": "Abnehmen",
    "goalMaintenance": "Halten",
    "goalMuscleGain": "Muskelaufbau",
    "aiCoachBtn": "KI-Coach",
    "aiCoachTitle": "Rezept mit KI ändern",
    "aiCoachDesc": "Beschreibe, wie das Rezept angepasst werden soll. Die KI erstellt eine neue Version mit aktualisierten Zutaten, Schritten und Makros.",
    "aiCoachPlaceholder": "z. B. vegetarisch / mehr Eiweiß / laktosefrei / 700 kcal / für 4 Personen",
    "aiCoachRun": "Mit KI generieren",
    "aiCoachRunning": "KI arbeitet…",
    "aiCoachDone": "Rezept von der KI angepasst",
    "aiCoachError": "Die KI konnte das Rezept nicht anpassen",
    "aiCoachBadge": "KI-Anpassung",
    "aiCoachRestore": "Original wiederherstellen",
    "aiCoachChipVeggie": "Vegetarisch",
    "aiCoachChipHiPro": "Mehr Protein",
    "aiCoachChipNoLactose": "Laktosefrei",
    "aiCoachChipKcal": "700 kcal",
    "aiCoachChipServings": "Für 4",
    "aiCoachChipCheap": "Günstiger",
    "aiEstimateBadge": "Geschätzte Nährwerte",
    "goalPortionDependent": "je nach Portion & Tagesbilanz",
    "recomputeBtn": "Neu berechnen",
    "recomputing": "Berechne…",
    "recomputedOk": "Nährwerte neu berechnet",
    "recomputeError": "Neuberechnung nicht möglich",
    "formName": "Name",
    "formDescription": "Beschreibung",
    "formIngredients": "Zutaten (eine pro Zeile)",
    "formIngredientsPh": "80g Nudeln\n1 EL Olivenöl\n...",
    "formServings": "Portionen",
    "formPrepMin": "Zubereitung (Min.)",
    "formKcalServing": "Kcal/Portion",
    "formMealType": "Mahlzeit",
    "formProtein": "P (g)",
    "formCarbs": "K (g)",
    "formFat": "F (g)",
    "formDate": "Datum",
    "nameRequired": "Rezeptname ist erforderlich",
    "recipeSaved": "Rezept gespeichert",
    "addedToDiary": "Zum Tagebuch hinzugefügt!",
    "shareExpired": "Der Link ist abgelaufen.",
    "shareNotFound": "Geteiltes Rezept nicht gefunden."
  },
  "groupChallenges": {
    "section": "Gruppenherausforderungen",
    "new": "Neu",
    "auto": "AUTO",
    "manual": "MANUELL",
    "autoTip": "Automatisch aus den App-Daten überprüft",
    "manualTip": "Manueller Check-in (vertrauensbasiert)",
    "daysRemaining": "Noch {n} Tage",
    "lastDay": "Letzter Tag!",
    "today": "Heute",
    "yourProgress": "Dein Fortschritt",
    "daysUnit": "Tage",
    "wearableHint": "Smartwatch (Vital.io) verbinden für automatische Überprüfung",
    "targetReached": "Ziel heute erreicht",
    "needMore": "Noch {n} {unit}",
    "markDone": "Heute als erledigt markieren",
    "doneToday": "Heute erledigt",
    "noOneCheckedIn": "Noch niemand hat eingecheckt",
    "leaderInFront": "vorne",
    "newTitle": "Neue Gruppenherausforderung",
    "newDesc": "Wähle Ziel, Dauer und Freunde aus.",
    "chooseGoal": "Wähle ein Ziel",
    "customTitleLabel": "Eigene Challenge",
    "customHint": "Manuell · vertrauensbasierter Check-in",
    "autoDisclaimer": "Challenges mit AUTO-Badge werden automatisch aus den in der App erfassten Daten überprüft (Wasser, Training, Mahlzeiten, Smartwatch). Schummeln ist nicht möglich.",
    "fldTitle": "Titel",
    "fldEmoji": "Emoji",
    "fldTargetPerDay": "Ziel/Tag",
    "fldUnit": "Einheit",
    "titlePlaceholder": "z. B. Morgenmeditation",
    "unitPlaceholder": "z. B. Minuten",
    "target": "Ziel",
    "duration": "Dauer",
    "d7": "7 Tage",
    "d30": "30 Tage",
    "inviteFriends": "Freunde einladen",
    "selectedCount": "({n} ausgewählt)",
    "create": "Challenge erstellen",
    "creating": "Erstelle…",
    "emptyTitle": "Keine aktiven Challenges",
    "emptyDesc": "Fordere deine Freunde heraus: 10 000 Schritte, 5 Gemüseportionen, wöchentliches Training…",
    "emptyCta": "Erste Challenge erstellen",
    "inviteBadge": "Challenge-Einladung",
    "inviteDetails": "{days} Tage · {n} sind schon dabei",
    "accept": "Annehmen",
    "decline": "Ablehnen",
    "detailSubtitle": "Rangliste nach abgeschlossenen Tagen",
    "detailStats": "{d} Tage · {n} Teilnehmer",
    "you": "Du",
    "leave": "Challenge verlassen",
    "del": "Challenge löschen",
    "confirmDelete": "Diese Challenge endgültig für alle Teilnehmer löschen?",
    "confirmLeave": "Möchtest du diese Challenge verlassen?",
    "toastCreated": "Challenge erstellt!",
    "toastCheckinDone": "Super! Check-in erfasst 🎯",
    "toastCheckinRemoved": "Check-in entfernt",
    "toastAccepted": "Challenge angenommen!",
    "toastDeleted": "Challenge gelöscht",
    "toastLeft": "Du hast die Challenge verlassen",
    "toastAutoNotYet": "Auto-Challenge: noch {n} {unit}. Trage die Daten in die App ein!",
    "toastError": "Fehler",
    "loading": "Challenges werden geladen…"
  },
  "privacy": {
    "title": "Datenschutz & Rechtliches",
    "exportPdf": "Als PDF exportieren",
    "sections": {
      "privacy": "Datenschutzerklärung",
      "beta": "Wichtiger Hinweis",
      "medical": "Medizinischer Hinweis",
      "consents": "Einwilligungen verwalten",
      "delete": "Konto & Daten löschen",
      "contact": "Kontakt / Datenschutzanfrage"
    }
  },
  "addMeal": {
    "addPhoto": "Foto hinzufügen",
    "addPhotoSub": "Mahlzeit fotografieren",
    "tbShare": "Teilen",
    "tbQr": "QR",
    "tbFav": "Favorit",
    "tbDuplicate": "Duplizieren",
    "tbPhoto": "Foto",
    "tbClear": "Löschen",
    "tbClose": "Schließen",
    "favoriteAdded": "Zu Favoriten hinzugefügt",
    "favoriteRemoved": "Aus Favoriten entfernt",
    "duplicated": "Mahlzeit dupliziert",
    "duplicatePickTitle": "Mahlzeit duplizieren",
    "duplicatePickSubtitle": "Wähle eine kürzliche Mahlzeit zum Wiederverwenden",
    "duplicatePickEmpty": "Keine kürzlichen Mahlzeiten zum Duplizieren",
    "quickLogTitle": "Schnell loggen",
    "sauceTitle": "Sauce dazu?",
    "quickLogSubtitle": "Favoriten mit einem Tipp loggen oder eine kürzliche Mahlzeit duplizieren",
    "favTab": "Favoriten",
    "recentTab": "Letzte",
    "favPickEmpty": "Noch keine Favoriten — speichere eine Mahlzeit mit dem Herz-Symbol",
    "favTapToLog": "Tippen zum Loggen",
    "favLogged": "„{name}“ geloggt",
    "duplicateFromDiary": "Aus dem Tagebuch duplizieren",
    "shareTapToOpen": "Tippe auf den Link, um ihn in deiner Solano Essence App zu öffnen:",
    "sharedOk": "Rezept geteilt",
    "sharedCopied": "Link kopiert — füge ihn in WhatsApp ein",
    "imported": "Rezept aus Link importiert",
    "shareExpired": "Der Link ist abgelaufen (90 Tage Gültigkeit)",
    "shareNotFound": "Rezept nicht gefunden",
    "eatWhereTitle": "Wo gegessen?",
    "eatHome": "Zuhause",
    "eatOut": "Auswärts",
    "eatHomeHint": "Passende Zutaten werden automatisch vom Vorrat abgezogen.",
    "eatOutHint": "Auswärts gegessen — es wird nichts vom Vorrat abgezogen."
  },
  "features": {
    "title": "Meine Funktionen",
    "subtitle": "Wähle aus, welche Werkzeuge du auf deinem Dashboard sehen möchtest",
    "summary": "{on}/{total} aktiv",
    "enabled": "Funktion aktiviert",
    "disabled": "Funktion deaktiviert",
    "footnote": "Du kannst diese Einstellungen jederzeit ändern. Deaktivierte Funktionen zeigen keine Widgets, Erinnerungen oder Push-Nachrichten mehr.",
    "items": {
      "water": {
        "label": "Tägliches Wasser",
        "desc": "Gläser und ml verfolgen"
      },
      "weight": {
        "label": "Gewicht & Taille",
        "desc": "Körpergewicht und Maße erfassen"
      },
      "sleep": {
        "label": "Schlaf & HRV",
        "desc": "Schlafdauer und Herzfrequenzvariabilität synchronisieren"
      },
      "steps_wearable": {
        "label": "Schritte & Wearable",
        "desc": "Tägliche Schritte aus Apple Health / Fitbit / Garmin"
      },
      "workouts": {
        "label": "Workouts",
        "desc": "Trainings und verbrannte Kalorien loggen"
      },
      "supplements": {
        "label": "Nahrungsergänzung",
        "desc": "Erinnerungen und Check-ins für Supplements"
      },
      "gamification": {
        "label": "Gamification",
        "desc": "Punkte, Abzeichen, Level und Streaks"
      },
      "pantry": {
        "label": "Vorratskammer",
        "desc": "Verwalte deine Zutaten zu Hause"
      },
      "plate_solano": {
        "label": "Solano-Teller",
        "desc": "50/25/25-Aufteilung (Gemüse/Protein/Kohlenhydrate)"
      },
      "mediterranean_score": {
        "label": "Mediterran-Score",
        "desc": "Adhärenz zur Mittelmeerdiät"
      },
      "coach_ai": {
        "label": "AI-Coach",
        "desc": "Automatische KI-Empfehlungen und -Feedback"
      }
    }
  }
};

export default de;
